(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2682],{

/***/ 28935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$q": function() { return /* binding */ setGeoLocationStatus; },
/* harmony export */   "Gi": function() { return /* binding */ setStoreDetails; },
/* harmony export */   "oA": function() { return /* binding */ setChangeStore; },
/* harmony export */   "p5": function() { return /* binding */ setChangeMethods; },
/* harmony export */   "pt": function() { return /* binding */ setGeoLocationPosition; }
/* harmony export */ });
/* harmony import */ var _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1369);

var setGeoLocationStatus = function setGeoLocationStatus(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__/* .GEOLOCATION_STATUS */ .Hi,
      payload: value
    });
  };
};
var setGeoLocationPosition = function setGeoLocationPosition(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__/* .GEOLOCATION_POSITION */ .EI,
      payload: value
    });
  };
};
var setStoreDetails = function setStoreDetails(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__/* .CANDC_STORE_DETAILS */ .f$,
      payload: value
    });
  };
};
var setChangeStore = function setChangeStore(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__/* .CHANGE_OTHER_STORE */ .PH,
      payload: value
    });
  };
};
var setChangeMethods = function setChangeMethods(value) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_0__/* .CHANGE_OTHER_METHODS */ .ey,
      payload: value
    });
  };
};

/***/ }),

/***/ 15623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ resetSyncUserProfile; },
  "c": function() { return /* binding */ syncUserProfile; }
});

;// CONCATENATED MODULE: ./utils/CreateThunk.js
var createThunk = function createThunk(_ref) {
  var apiCall = _ref.apiCall,
      type = _ref.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      }, function (payload) {
        return dispatch({
          type: "".concat(type, "_FAILURE"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
var createRejectableThunk = function createRejectableThunk(_ref2) {
  var apiCall = _ref2.apiCall,
      type = _ref2.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
;// CONCATENATED MODULE: ./services/userProfileService.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var syncUserPorfile = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var _profileInfoRequest$r, _profileInfoRequest$r2, _profileInfo$result, _profileInfo$result2, _profileInfoRequest$e;

    var payload, params, profileInfoRequest, profileInfo;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload;

            if (payload.cartId) {
              params = {
                guestCartId: payload.cartId
              };
            }

            _context.next = 4;
            return microServices/* default.post */.Z.post("api", "profileSync", {}, params);

          case 4:
            profileInfoRequest = _context.sent;
            profileInfo = (_profileInfoRequest$r = profileInfoRequest.response) === null || _profileInfoRequest$r === void 0 ? void 0 : (_profileInfoRequest$r2 = _profileInfoRequest$r.data) === null || _profileInfoRequest$r2 === void 0 ? void 0 : _profileInfoRequest$r2.result;

            if (!(!profileInfoRequest.fail && profileInfo && profileInfo !== null && profileInfo !== void 0 && profileInfo.result && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result = profileInfo.result) !== null && _profileInfo$result !== void 0 && _profileInfo$result.magentoProfileResponse && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result2 = profileInfo.result) !== null && _profileInfo$result2 !== void 0 && _profileInfo$result2.magentoProfileResponse[0])) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, profileInfo), {}, {
              pageAction: payload.pageAction
            }));

          case 10:
            if (!(((_profileInfoRequest$e = profileInfoRequest.error) === null || _profileInfoRequest$e === void 0 ? void 0 : _profileInfoRequest$e.status) == 401)) {
              _context.next = 14;
              break;
            }

            throw {
              apiFailStatus: "401"
            };

          case 14:
            throw new Error();

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function syncUserPorfile(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./Redux/actions/userProfileAction.js



var syncUserProfile = createThunk({
  apiCall: syncUserPorfile,
  type: actionTypes/* SYNC_USER_PROFILE */.fR
});
var resetSyncUserProfile = function resetSyncUserProfile() {
  return {
    type: actionTypes/* SYNC_USER_PROFILE_RESET */.gC
  };
};

/***/ }),

/***/ 38975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88447);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var LabelText = function LabelText(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClickHandler = _ref.onClickHandler,
      uniqueLabelId = _ref.uniqueLabelId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
    className: "".concat(className, " ").concat((_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["label-text"])),
    style: style,
    onClick: onClickHandler,
    id: uniqueLabelId,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LabelText);

/***/ }),

/***/ 92308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Link_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4924);
/* harmony import */ var _Link_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Link_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Link = function Link(_ref) {
  var href = _ref.href,
      text = _ref.text,
      clickHandler = _ref.clickHandler,
      prefetch = _ref.prefetch,
      className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Link, {
    legacyBehavior: true,
    href: href,
    prefetch: prefetch,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
      className: "".concat((_Link_module_scss__WEBPACK_IMPORTED_MODULE_2___default().link), " ").concat(className),
      onClick: clickHandler,
      children: text
    })
  });
};

Link.defaultProps = {
  href: "",
  text: "",
  prefetch: true
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ }),

/***/ 81181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20753);
/* harmony import */ var _radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var RadioButton = function RadioButton(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      handleOnChange = _ref.handleOnChange,
      name = _ref.name,
      selectedOption = _ref.selectedOption,
      label = _ref.label,
      className = _ref.className,
      optionStyle = _ref.optionStyle,
      labelStyle = _ref.labelStyle,
      labelNameStyle = _ref.labelNameStyle;

  var getSelectedLabel = function getSelectedLabel(val) {
    return items.some(function (itm) {
      return itm.label === val && (itm === null || itm === void 0 ? void 0 : itm.swatch_data) !== null;
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: "".concat((_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button"]), " ").concat(className, " button-wrapper"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: (_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__text"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "".concat((_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__label"]), " ").concat(labelStyle),
        children: [label, ":"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: getSelectedLabel(selectedOption) ? "".concat((_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__label-name"]), " ").concat(labelNameStyle) : null,
        children: getSelectedLabel(selectedOption) ? selectedOption : null
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className: "".concat((_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().radioOptions), " ").concat(label === 'Colour' ? (_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().colorOptions) : (_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().defaultOptions)),
      children: items.map(function (radio, index) {
        var _radio$swatch_data, _radio$swatch_data2, _radio$swatch_data3, _radio$swatch_data4, _radio$swatch_data5;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
          className: "".concat((_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__clickable"]), " "),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
            name: name,
            type: "radio",
            value: radio.label,
            className: (_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__input-hidden"]),
            checked: selectedOption === radio.label,
            onChange: function onChange() {
              return handleOnChange(radio.label);
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "".concat(radio !== null && radio !== void 0 && (_radio$swatch_data = radio.swatch_data) !== null && _radio$swatch_data !== void 0 && _radio$swatch_data.value ? (_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__coloring"]) : (_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__checkmark"])),
            style: (radio === null || radio === void 0 ? void 0 : (_radio$swatch_data2 = radio.swatch_data) === null || _radio$swatch_data2 === void 0 ? void 0 : _radio$swatch_data2.value) && {
              backgroundColor: radio === null || radio === void 0 ? void 0 : (_radio$swatch_data3 = radio.swatch_data) === null || _radio$swatch_data3 === void 0 ? void 0 : _radio$swatch_data3.value
            },
            children: !(radio !== null && radio !== void 0 && (_radio$swatch_data4 = radio.swatch_data) !== null && _radio$swatch_data4 !== void 0 && _radio$swatch_data4.value) && radio.label
          }), (radio === null || radio === void 0 ? void 0 : (_radio$swatch_data5 = radio.swatch_data) === null || _radio$swatch_data5 === void 0 ? void 0 : _radio$swatch_data5.value) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_radioButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["radio-button__checked"])
          })]
        }, index);
      })
    })]
  });
};

RadioButton.defaultProps = {
  items: [],
  className: "",
  label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);

/***/ }),

/***/ 4648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tag_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58428);
/* harmony import */ var _tag_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tag_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Tag = function Tag(_ref) {
  var label = _ref.label,
      variant = _ref.variant,
      className = _ref.className,
      labelColor = _ref.labelColor;
  var labels = {
    custom: label,
    "brand-new": label || "Brand new",
    discount: label || "X% off",
    "device-deal": label || "Double device deal",
    "limited-offer": label || "Limited offer",
    "low-stock": label || "Low stock",
    "no-stock": label || "Out of stock",
    "on-backorder": label || "Currently on backorder",
    "pre-order": label || "Pre-order",
    "top-pick": label || "Top pick",
    "currently-viewing": label || "Currently viewing",
    "one-time-offer": label || "One-time offer",
    "today-only": label || "Today Only",
    "for-today-only": label || "For today only",
    "exclusive-to-online": label || "Exclusive to Online",
    "read-hot-dealz": label || "Red Hot Dealz",
    "red-hot-deal": label || "Red Hot Deal",
    "buy-one-get-one-free": label || "Buy One Get One Free",
    "Black-Friday": "Black Friday",
    "black-friday": label || "Black Friday",
    "badge-style-1": label || "badge-style-1",
    Recommended: label || "Recommended"
  };

  var colorValue = function colorValue(value, defaultColor) {
    switch (value) {
      case "no-stock":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Red75 */ .Z.Red75);
        }

      case "low-stock":
      case "on-backorder":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Yellow50 */ .Z.Yellow50);
        }

      case "discount":
      case "buy-one-get-one-free":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Teal51 */ .Z.Teal51);
        }

      case "pre-order":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Teal75 */ .Z.Teal75);
        }

      case "top-pick":
      case "Recommended":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Purple53 */ .Z.Purple53);
        }

      default:
        return defaultColor && defaultColor !== null ? defaultColor : labelColor;
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    id: labels[variant] ? "tag_".concat(labels[variant.toLowerCase()]) : "tag_".concat(label),
    className: "".concat((_tag_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tag), " ").concat(className),
    style: {
      backgroundColor: labelColor && labelColor !== null ? colorValue(variant) : colorValue(variant, "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Black40 */ .Z.Black40))
    },
    children: labels[variant] ? labels[variant.toLowerCase()] : label
  });
};

Tag.defaultProps = {
  variant: "custom",
  className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);

/***/ }),

/***/ 97984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18517);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28658);
/* harmony import */ var _upgradeModal_UpgradeModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27575);
/* harmony import */ var _services_upgradeService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70098);
/* harmony import */ var services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69152);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99599);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var AffordabilityContainer = function AffordabilityContainer(_ref) {
  var showModal = _ref.showModal,
      toggleModal = _ref.toggleModal,
      resultCode = _ref.resultCode,
      profileData = _ref.profileData,
      userLoggedIn = _ref.userLoggedIn,
      upgradeResponse = _ref.upgradeResponse;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      displayData = _useState[0],
      setDisplayData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      selectedNumber = _useState2[0],
      setSelectedNumber = _useState2[1];

  var router = (0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_10___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_10___default().envConfigs)[env].imagePrefix;

  var getUtagViewData = function getUtagViewData() {
    return (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["visitor_customer_id", "visitor_login_status", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"]);
  };

  var ctaRedirection = function ctaRedirection(route) {
    var pageName = (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["page_name"]).page_name;
    (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .link */ .p4)(_objectSpread({
      page_tool_event: "o",
      page_tool_name: "".concat(pageName, ": show deals")
    }, getUtagViewData()));
    router.push(route);
  };

  var handleNewSelect = function handleNewSelect(selectedValue) {
    setSelectedNumber(selectedValue);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    function fetchDisplayData() {
      return _fetchDisplayData.apply(this, arguments);
    }

    function _fetchDisplayData() {
      _fetchDisplayData = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var affordData, dropdownData, responseData, _responseData$, _responseData$2, _responseData$3, _responseData$4, _responseData$5, _responseData$6, _responseData$7, _responseData$8;

        return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                affordData = {};
                dropdownData = [{
                  num: upgradeResponse.msisdn,
                  id: 1,
                  label: upgradeResponse.upgradeEligible ? "".concat((0,_services_upgradeService__WEBPACK_IMPORTED_MODULE_7__/* .maskMsisdn */ .Ly)(upgradeResponse.msisdn), " (Upgradeable)") : "".concat((0,_services_upgradeService__WEBPACK_IMPORTED_MODULE_7__/* .maskMsisdn */ .Ly)(upgradeResponse.msisdn), " (Not upgradeable)"),
                  upgradeEligible: upgradeResponse.upgradeEligible
                }];
                setSelectedNumber(dropdownData[0].label);
                _context.next = 5;
                return _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_4__/* ["default"].httpGet */ .Z.httpGet("drupalBaseUrl", "", "api", "upgradeResult", [resultCode]);

              case 5:
                responseData = _context.sent;

                if (responseData.length) {
                  affordData = {
                    iconUrl: ((_responseData$ = responseData[0]) === null || _responseData$ === void 0 ? void 0 : _responseData$.icon) || "",
                    title: ((_responseData$2 = responseData[0]) === null || _responseData$2 === void 0 ? void 0 : _responseData$2.resultTitle) || "",
                    analyticsTitle: ((_responseData$3 = responseData[0]) === null || _responseData$3 === void 0 ? void 0 : _responseData$3.analyticTitle) || "",
                    description: (_responseData$4 = responseData[0]) !== null && _responseData$4 !== void 0 && _responseData$4.resultHTML ? (_responseData$5 = responseData[0]) === null || _responseData$5 === void 0 ? void 0 : _responseData$5.resultHTML : ((_responseData$6 = responseData[0]) === null || _responseData$6 === void 0 ? void 0 : _responseData$6.resultText) || "",
                    primaryButtonText: ((_responseData$7 = responseData[0]) === null || _responseData$7 === void 0 ? void 0 : _responseData$7.primaryEnabled) === "Yes" ? (_responseData$8 = responseData[0]) === null || _responseData$8 === void 0 ? void 0 : _responseData$8.primaryCTAText : null,
                    onClickHandlerPrimary: function onClickHandlerPrimary() {
                      var _responseData$9;

                      return ctaRedirection((_responseData$9 = responseData[0]) === null || _responseData$9 === void 0 ? void 0 : _responseData$9.primaryCTAURL);
                    },
                    dropdown: true,
                    handleVal: handleNewSelect,
                    selectedDropdownValue: selectedNumber ? selectedNumber : dropdownData[0].label,
                    dropdownData: dropdownData
                  };
                } else {
                  affordData = {
                    iconUrl: "".concat(imagePrefix, "/assets/images/icon-info.svg"),
                    title: _config_labels__WEBPACK_IMPORTED_MODULE_9__/* ["default"].upgrade.lbl_afford_title */ .Z.upgrade.lbl_afford_title,
                    description: _config_labels__WEBPACK_IMPORTED_MODULE_9__/* ["default"].upgrade.lbl_afford_desc */ .Z.upgrade.lbl_afford_desc,
                    primaryButtonText: _config_labels__WEBPACK_IMPORTED_MODULE_9__/* ["default"].upgrade.lbl_afford_btn */ .Z.upgrade.lbl_afford_btn,
                    onClickHandlerPrimary: ctaRedirection("/shopping/deals"),
                    dropdown: true,
                    handleVal: handleNewSelect,
                    selectedDropdownValue: selectedNumber ? selectedNumber : dropdownData[0].label,
                    dropdownData: dropdownData
                  };
                }

                setDisplayData(affordData);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchDisplayData.apply(this, arguments);
    }

    fetchDisplayData();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var userMetaData = (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getProfileData */ .$y)(userLoggedIn, profileData);
    (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .view */ .ei)(_objectSpread(_objectSpread({
      page_event: "view",
      page_name: displayData.analyticsTitle,
      page_channel: "shopping",
      page_master_tab: "personal"
    }, (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      upgrade_eligibility_status: "".concat(upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.upgradeEligible ? upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeEligible : false),
      upgrade_eligible_date: (upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeDate) || "",
      upgrade_ineligible_reason: !(upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.upgradeEligible) ? "".concat(displayData.title) : null,
      upgrade_customer_type: upgradeResponse ? null : upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.c3dCustomer ? "C3D" : upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.business ? "EBU" : "Legacy"
    }, userMetaData));
  }, [displayData]);

  var hideModal = function hideModal() {
    var pageName = (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["page_name"]).page_name;
    (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .link */ .p4)(_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": dismiss")
    }, getUtagViewData()));
    toggleModal();
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_upgradeModal_UpgradeModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    showModal: showModal,
    displayData: displayData,
    toggleModal: hideModal
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    profileData: state.navDetails.profileData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    upgradeResponse: state.upgrade.upgradeResponse
  };
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, {})(AffordabilityContainer));

/***/ }),

/***/ 20775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ extractPromoData; },
/* harmony export */   "j": function() { return /* binding */ formatPromoData; }
/* harmony export */ });
/**
 *
 * @param promoData
 * @returns {string}
 */
var formatPromoData = function formatPromoData(promoData) {
  if (promoData >= 1000) {
    return "".concat(promoData / 1000, "GB");
  }

  return "".concat(promoData, "MB");
};
/**
 * Extracts the sum of promo_data value from the plan object products
 *
 * @param plan
 * @returns {number|null}
 */

var extractPromoData = function extractPromoData(plan) {
  if (!plan || !plan.items) {
    return null;
  } // Find the item with title "Promo"


  var promoItem = plan.items.find(function (item) {
    return item.title === "Promo";
  });

  if (!promoItem || !promoItem.options) {
    return null;
  } // Extract promo_data values from each product in the options array


  var promoDataValues = promoItem.options.map(function (option) {
    var _option$product;

    return option === null || option === void 0 ? void 0 : (_option$product = option.product) === null || _option$product === void 0 ? void 0 : _option$product.promo_data;
  }).filter(function (value) {
    return value !== null && value !== undefined;
  }); // If there are no valid promo_data values, return null

  if (promoDataValues.length === 0) {
    return null;
  }

  if (promoDataValues.length === 1) {
    return promoDataValues[0];
  }

  return promoDataValues.reduce(function (sum, value) {
    return sum + value;
  }, 0);
};

/***/ }),

/***/ 48998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pr": function() { return /* binding */ DealBuilderRecommendedPlansBasicInfo; },
/* harmony export */   "RB": function() { return /* binding */ CmsBlocks; },
/* harmony export */   "fF": function() { return /* binding */ DealBuilderRecommendedPlans; },
/* harmony export */   "hV": function() { return /* binding */ DealBuilderContractSearch; },
/* harmony export */   "k6": function() { return /* binding */ DealBuilderSearchProducts; },
/* harmony export */   "vn": function() { return /* binding */ DealBuilderContractSearchData; },
/* harmony export */   "x5": function() { return /* binding */ DealBuilderProductData; }
/* harmony export */ });
/* unused harmony export DealBuilderProductSearch */
var DealBuilderProductSearch = "query products($id: String!) {\n    products(filter: { sku: { eq: $id } }) {\n      total_count\n      items {\n        id\n        name\n        deal_builder_deals\n        contract_sku\n        stock_status\n        stock_message {\n          out_of_stock_title\n          out_of_stock_description\n          low_stock_title\n          low_stock_description\n        }\n        sku\n        delivery_message\n        image {\n          url\n          label\n        }\n        small_image {\n          url\n          label\n        }\n        media_gallery {\n          url\n          label\n        }\n        ... on ConfigurableProduct {\n          configurable_options {\n            label\n            attribute_code\n           attribute_id\n            values {\n              value_index\n              label\n              swatch_data {\n                value\n              }\n            }\n          }\n          variants {\n            product {\n              id\n              name\n              sku\n              quantity\n              stock_message {\n                  out_of_stock_title\n                  out_of_stock_description\n              }\n              stock_status\n              image {\n                url\n                label\n              }\n              small_image {\n                url\n                label\n              }\n              thumbnail {\n                url\n                label\n              }\n              media_gallery {\n                url\n                label\n              }\n            }\n            attributes {\n              label\n              code\n              value_index,\n            }\n          }\n        }\n      }\n    }\n  }\n  ";
var DealBuilderRecommendedPlans = "query products($filter: ProductAttributeFilterInput, $pageSize: Int) {\n    products(\n       filter: $filter,\n       pageSize: $pageSize,\n       sort: {\n           monthly_recurring: ASC\n       }\n    ) {\n        total_count\n        page_info {\n            page_size\n            current_page\n            total_pages\n        }\n        items {\n           name\n           sku\n           promo_data\n           minutes\n           contract_type\n           contract_type_label\n           promotion_tag_swatch\n           minutes_label\n           airtime\n           sms\n           primary_product_sku\n           contract_sku\n           payment_terms\n           payment_terms_label\n           package_description\n           promotion_tag\n           promotion_tag_label\n           plan_type\n           plan_type_label\n           plan_name\n           plan_name_label\n           monthly_recurring\n           old_tariff\n           old_installment\n           old_monthly_recurring\n           nightowl_units\n           nightowl_uom\n           save_monthly_recurring\n           stock_status\n           deal_go_live_date\n           deal_end_date\n           deal_label\n           ... on CustomizableProductInterface { options { title required sort_order option_id __typename ... on CustomizableDropDownOption { title value { price_type option_type_id title price sku } } } }\n           ... on BundleProduct {\n              enable_click_and_collect\n              items {\n                  option_id\n                  title\n                  required\n                  type\n                  position\n                  sku\n                  options {\n                      id\n                      quantity\n                      position\n                      is_default\n                      price\n                      price_type\n                      is_hidden_product\n                      can_change_quantity\n                      label\n                      product {\n                        id\n                        name\n                        sku\n                        monthly_recurring\n                        old_tariff\n                        old_installment\n                        old_monthly_recurring\n                        quantity\n                        stock_status\n                        promotion_link\n                        primary_product_sku\n                        promo_data\n                        nightowl_units\n                        nightowl_uom\n                        minutes\n                        minutes_label\n                        airtime\n                        sms\n                        badges\n                        visibility\n                        attribute_set_id\n                        badges_label\n                        promotion_tag_swatch\n                        badges_swatch\n                        color\n                        color_label\n                        size\n                        size_label\n                        screen_size_pixels_label\n                        internal_storage\n                        internal_storage_label\n                        battery_capacity_label\n                        __typename\n                        image {\n                          url\n                          label\n                        }\n                        small_image {\n                          url\n                          label\n                        }\n                        ... on ConfigurableProduct {\n                          configurable_options {\n                          label\n                          attribute_code\n                               attribute_id\n                          values {\n                            value_index\n                            label\n                            swatch_data {\n                            value\n                            }\n                          }\n                          }\n                          variants {\n                          product {\n                            id\n                            name\n                            contract_sku\n                            sku\n                            stock_message {\n                              out_of_stock_title\n                              out_of_stock_description\n                            }\n                            delivery_and_return\n                            stock_status\n                            image {\n                            url\n                            label\n                            }\n                            small_image {\n                            url\n                            label\n                            }\n                            thumbnail {\n                            url\n                            label\n                            }\n                            media_gallery {\n                            url\n                            label\n                            }\n                          }\n                          attributes {\n                            label\n                            code\n                            value_index,\n                          }\n                          }\n                        }\n                      }\n                  }\n              }\n           }\n        }\n    }\n}";
var DealBuilderRecommendedPlansBasicInfo = "query products($filter: ProductAttributeFilterInput, $pageSize: Int) {\n    products(\n       filter: $filter,\n       pageSize: $pageSize,\n       sort: {\n           monthly_recurring: ASC\n       }\n    ) {\n        total_count\n        page_info {\n            page_size\n            current_page\n            total_pages\n        }\n        items {\n           name\n           sku\n           promo_data\n           minutes\n           contract_type\n           contract_type_label\n           promotion_tag_swatch\n           minutes_label\n           airtime\n           sms\n           primary_product_sku\n           contract_sku\n           payment_terms\n           payment_terms_label\n           package_description\n           promotion_tag\n           promotion_tag_label\n           plan_type\n           plan_type_label\n           plan_name\n           plan_name_label\n           monthly_recurring\n           old_tariff\n           old_installment\n           old_monthly_recurring\n           nightowl_units\n           nightowl_uom\n           save_monthly_recurring\n           stock_status\n           deal_go_live_date\n           deal_end_date\n           deal_label\n           ... on BundleProduct {\n              items {\n                  title\n                  options {\n                      product {\n                        promo_data\n                      }\n                  }\n              }\n           }\n        }\n    }\n}";
var DealBuilderContractSearch = "query products($name: String)\n{\n\tDealSelection (sku: $name)\n\t{\n\tdeal_skus\n\t}\n}";
var DealBuilderSearchProducts = "query products(\n    $search: String\n) {\n\tproducts(\n        search: $search\n        filter: {\n            price: {\n                from: 0.00,\n                to: 9999999999\n            },\n            is_deal_product: {\n                eq: 0\n            }\n        }\n\t\tsort: {\n            product_ranking: DESC,\n            sku: ASC\n        }\n        pageSize: 30\n        currentPage: 1\n\t) {\n\n\t\titems {\n\t\t\tname\n            sku\n            attribute_set_id\n\t\t}\n\t}\n}\n";
var DealBuilderProductData = "query products($id: String!) {\n\tproducts(filter: { sku: { eq: $id } }) {\n\t  items {\n\t  url_key\n\t\tid\n\t\tname\n\t\tdeal_builder_deals\n    manufacturer\n    manufacturer_label\n\t\tcontract_sku\n\t\tstock_status\n\t\tstock_message {\n\t\t  out_of_stock_title\n\t\t  out_of_stock_description\n\t\t  low_stock_title\n\t\t  low_stock_description\n\t\t}\n\t\tsku\n\t\tdelivery_message\n\t\timage {\n\t\t  url\n\t\t  label\n\t\t}\n\t\tsmall_image {\n\t\t  url\n\t\t  label\n\t\t}\n\t\tmedia_gallery {\n\t\t  url\n\t\t  label\n\t\t}\n\t\t... on ConfigurableProduct {\n\t\t  configurable_options {\n\t\t\tlabel\n\t\t\tattribute_code\n\t\t\t     attribute_id\n\t\t\tvalues {\n\t\t\t  value_index\n\t\t\t  label\n\t\t\t  swatch_data {\n\t\t\t\tvalue\n\t\t\t  }\n\t\t\t}\n\t\t  }\n\t\t  variants {\n\t\t\tproduct {\n\t\t\t  id\n\t\t\t  name\n\t\t\t  contract_sku\n\t\t\t  sku\n\t\t\t  quantity\n\t\t\t  stock_message {\n\t\t\t\t  out_of_stock_title\n\t\t\t\t  out_of_stock_description\n\t\t\t  }\n\t\t\t  delivery_and_return\n\t\t\t  stock_status\n\t\t\t  image {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t  }\n\t\t\t  small_image {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t  }\n\t\t\t  thumbnail {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t  }\n\t\t\t  media_gallery {\n\t\t\t\turl\n\t\t\t\tlabel\n\t\t\t  }\n\t\t\t  __typename\n\t\t\t}\n\t\t\tattributes {\n\t\t\t  label\n\t\t\t  code\n\t\t\t  value_index,\n\t\t\t}\n\t\t  }\n\t\t}\n\t  }\n\t}\n  }\n  ";
var CmsBlocks = "query blocks($identifiers: [String]) {\n  cmsBlocks(identifiers: $identifiers) {\n    items {\n      identifier\n      title\n      content\n    }\n  }\n}\n";
var DealBuilderContractSearchData = "query products($filter: ProductAttributeFilterInput) {\n  products(\n\t filter: $filter,\n\t pageSize: 1000,\n\t currentPage: 1,\n\t sort: {\n\t\t monthly_recurring: ASC\n\t }\n  ) {\n\t  total_count\n\t  page_info {\n\t\t  page_size\n\t\t  current_page\n\t\t  total_pages\n\t  }\n\t  items {\n\t\t name\n\t\t sku\n\t\t promo_data\n\t\t minutes\n\t\t contract_type\n\t\t contract_type_label\n\t\t promotion_tag_swatch\n\t\t minutes_label\n\t\t airtime\n\t\t sms\n\t\t primary_product_sku\n\t\t contract_sku\n\t\t payment_terms\n\t\t payment_terms_label\n\t\t package_description\n\t\t promotion_tag\n\t\t promotion_tag_label\n\t\t plan_type\n\t\t plan_type_label\n     plan_name\n     plan_name_label\n\t\t monthly_recurring\n\t\t old_tariff\n\t\t old_installment\n\t\t old_monthly_recurring\n\t\t save_monthly_recurring\n\t\t stock_status\n\t\t deal_go_live_date\n\t\t deal_end_date\n\t\t deal_label\n\t\t is_deal_locked\n\t\t __typename\n\t\t image {\n\t\t   url\n\t\t }\n\t\t small_image {\n\t\t   url\n\t\t }\n\t   }\n\t  aggregations {\n\t\t attribute_code\n\t\t options {\n\t\t   label\n\t\t   value\n\t\t }\n\t  }\n\t  price_range {\n\t\t attribute_code\n\t\t min_value\n\t\t max_value\n\t   }\n  }\n}";

/***/ }),

/***/ 1448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/molecules/modals/clickAndCollectModal/ClickAndCollectModal.jsx + 1 modules
var ClickAndCollectModal = __webpack_require__(89429);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./components/molecules/productViewer/productViewer.module.scss
var productViewer_module = __webpack_require__(15291);
var productViewer_module_default = /*#__PURE__*/__webpack_require__.n(productViewer_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/productViewer/ProductViewer.jsx








var ProductViewer = function ProductViewer(_ref) {
  var mediaGallery = _ref.mediaGallery,
      className = _ref.className,
      sku = _ref.sku;

  var _useState = (0,react.useState)(0),
      activeCounter = _useState[0],
      setActiveCounter = _useState[1];

  var _useState2 = (0,react.useState)(''),
      currentThumb = _useState2[0],
      setCurrentThumb = _useState2[1];

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

  var removeDuplicates = function removeDuplicates(array) {
    var uniqueUrls = new Set();
    return array.filter(function (item) {
      if (!uniqueUrls.has(item.url)) {
        uniqueUrls.add(item.url);
        return true;
      }

      return false;
    });
  };

  var uniqueImages = removeDuplicates(mediaGallery);
  var deviceOptions = {
    items: 1,
    nav: false,
    autoplay: false,
    center: true,
    animateIn: "animate__fadeIn",
    responsive: {
      0: {
        dots: true
      },
      1024: {
        dots: false
      }
    }
  };
  var thumbOptions = {
    autoplay: false,
    nav: false,
    autoWidth: true,
    lazyLoad: true,
    margin: 16,
    mouseDrag: false,
    responsive: {
      0: {
        dots: true,
        slideBy: 1
      },
      1024: {
        dots: false
      }
    }
  };
  var events = {
    onTranslate: function onTranslate(event) {
      setActiveCounter(event.item.index);
      setCurrentThumb(event.item.index);
      window.currentThumb = event.item.index;
    }
  };
  var thumbEvents = {
    onTranslate: function onTranslate(event) {
      setActiveCounter(window.currentThumb);
    }
  };

  var next = function next() {
    var imageCount = deviceCarousel.props.children.length;

    if (deviceCarousel.currentPosition + 1 > imageCount - 1) {
      deviceCarousel.goTo(0);
      thumbCarousel.goTo(0);
      setActiveCounter(0);
      return;
    }

    if (deviceCarousel) {
      deviceCarousel.next(600);
    }

    if (thumbCarousel) {
      thumbCarousel.goTo(deviceCarousel.currentPosition == (mediaGallery === null || mediaGallery === void 0 ? void 0 : mediaGallery.length) ? deviceCarousel.currentPosition + 1 : deviceCarousel.currentPosition);
    }

    setActiveCounter(deviceCarousel.currentPosition);
  };

  var prev = function prev() {
    var imageCount = deviceCarousel.props.children.length;

    if (activeCounter - 1 < 0) {
      deviceCarousel.goTo(imageCount - 1);
      setActiveCounter(deviceCarousel.currentPosition);

      if (thumbCarousel) {
        thumbCarousel.goTo(deviceCarousel.currentPosition);
        thumbCarousel.currentPosition = deviceCarousel.currentPosition;
      }

      return;
    }

    if (deviceCarousel) {
      deviceCarousel.prev(600);
    }

    if (thumbCarousel) {
      thumbCarousel.goTo(deviceCarousel.currentPosition);
      thumbCarousel.currentPosition = deviceCarousel.currentPosition;
    }

    setActiveCounter(deviceCarousel.currentPosition);
  };

  var goTo = function goTo(index) {
    if (deviceCarousel) {
      deviceCarousel.goTo(index);
    }

    if (thumbCarousel) {
      thumbCarousel.goTo(index);
    }
  };

  var deviceCarousel;
  var thumbCarousel;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((productViewer_module_default())["product-viewer"], " ").concat(className || ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (productViewer_module_default())["product-viewer__device"],
      children: uniqueImages.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (productViewer_module_default()).carousel__prev,
          onClick: prev,
          id: "".concat(sku, "-next"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/chevron-prev-white.svg")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.OwlCarousel, {
          ref: function ref(c) {
            return deviceCarousel = c;
          },
          options: deviceOptions,
          events: events,
          children: uniqueImages.map(function (thumbnail, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (productViewer_module_default())["product-viewer__image"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Image, {
                src: thumbnail.url,
                alt: thumbnail.label,
                id: "".concat(index, "-").concat(thumbnail.label)
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (productViewer_module_default()).carousel__next,
          onClick: next,
          id: "".concat(sku, "-next"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/chevron-next-white.svg")
          })
        })]
      })
    }), uniqueImages.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((productViewer_module_default()).carousel, " ").concat((productViewer_module_default()).thumbnailCarousel, " ").concat(uniqueImages.length > 6 ? (productViewer_module_default()).thumbMaxWidth : ''),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((productViewer_module_default()).carousel__container),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.OwlCarousel, {
          ref: function ref(c) {
            return thumbCarousel = c;
          },
          options: thumbOptions,
          events: thumbEvents,
          children: uniqueImages.map(function (thumbnail, index) {
            var prevThumbnail = uniqueImages[index === 0 ? 0 : index - 1].url;
            return index >= 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onClick: function onClick() {
                return goTo(index);
              },
              "data-url": prevThumbnail,
              className: "".concat(index !== 0 && prevThumbnail === thumbnail.url ? 'hidden' : 'not-hidden', " ").concat((productViewer_module_default()).thumbnail, " ").concat(index === activeCounter ? (productViewer_module_default())["thumbnail--active"] : ""),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Image, {
                src: thumbnail.url,
                alt: thumbnail.label,
                id: "".concat(index, "-").concat(thumbnail.label)
              })
            }, index) : null;
          })
        })
      })
    })]
  });
};

/* harmony default export */ var productViewer_ProductViewer = (ProductViewer);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react-owl-carousel2/lib/OwlCarousel.js
var OwlCarousel = __webpack_require__(68820);
var OwlCarousel_default = /*#__PURE__*/__webpack_require__.n(OwlCarousel);
// EXTERNAL MODULE: ./components/atoms/radioButton/RadioButton.jsx
var RadioButton = __webpack_require__(81181);
// EXTERNAL MODULE: ./components/molecules/productDetailPrice/productDetailPrice.module.scss
var productDetailPrice_module = __webpack_require__(12502);
var productDetailPrice_module_default = /*#__PURE__*/__webpack_require__.n(productDetailPrice_module);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
;// CONCATENATED MODULE: ./components/molecules/productDetailPrice/ProductDetailPrice.jsx








var ProductDetailPrice = function ProductDetailPrice(_ref) {
  var label = _ref.label,
      nowText = _ref.nowText,
      wasText = _ref.wasText,
      saveText = _ref.saveText,
      amount = _ref.amount,
      prevAmount = _ref.prevAmount,
      saveAmount = _ref.saveAmount,
      currency = _ref.currency,
      saveSuffix = _ref.saveSuffix,
      className = _ref.className,
      forText = _ref.forText,
      dealText = _ref.dealText,
      amountStyle = _ref.amountStyle;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((productDetailPrice_module_default()).textWhite, " ").concat(className),
    id: "".concat(label, "-container"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (productDetailPrice_module_default()).whiteLabel,
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((productDetailPrice_module_default()).price),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat(saveAmount > 0 ? (productDetailPrice_module_default()).specialPrice : '', " ").concat((productDetailPrice_module_default()).price__main),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (productDetailPrice_module_default()).price__amount,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
            displayType: "text",
            value: (0,helperServices/* numberFormat */.i8)(amount),
            prefix: currency,
            thousandSeparator: true,
            className: amountStyle && (productDetailPrice_module_default())[amountStyle]
          }), dealText && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: amountStyle && (productDetailPrice_module_default())[amountStyle],
            children: dealText
          })]
        })
      }), saveAmount > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (productDetailPrice_module_default()).price__was,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (productDetailPrice_module_default()).prefix,
            children: wasText
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
            displayType: "text",
            value: (0,helperServices/* numberFormat */.i8)(prevAmount),
            prefix: currency,
            thousandSeparator: true
          }), dealText && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: dealText
          })]
        })
      })]
    })]
  });
};

ProductDetailPrice.defaultProps = {
  nowText: "Now only",
  wasText: "Was",
  saveText: "Save",
  currency: "R",
  saveSuffix: "!",
  label: "Price:",
  forText: "For only "
};
/* harmony default export */ var productDetailPrice_ProductDetailPrice = (ProductDetailPrice);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./Redux/actions/userProfileAction.js + 2 modules
var userProfileAction = __webpack_require__(15623);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./components/organisms/productDetailForm/productDetailForm.module.scss
var productDetailForm_module = __webpack_require__(76401);
var productDetailForm_module_default = /*#__PURE__*/__webpack_require__.n(productDetailForm_module);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./components/atoms/promotionTimer/PromotionTimer.module.scss
var PromotionTimer_module = __webpack_require__(60682);
var PromotionTimer_module_default = /*#__PURE__*/__webpack_require__.n(PromotionTimer_module);
;// CONCATENATED MODULE: ./components/atoms/promotionTimer/PromotionTimer.jsx







var env = (config_default()).env;
var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

var PromotionTimer = function PromotionTimer(_ref) {
  var date = _ref.date,
      flag = _ref.flag;

  var renderer = function renderer(_ref2) {
    var days = _ref2.days,
        hours = _ref2.hours,
        minutes = _ref2.minutes,
        seconds = _ref2.seconds;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PromotionTimer_module_default()).timerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "".concat(imagePrefix, "/assets/images/promotion-tag.svg")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).discountLabel,
        children: [labels/* default.lbl_discount_end_text */.Z.lbl_discount_end_text, ":"]
      }), days > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).time,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PromotionTimer_module_default()).zerotimepad,
          children: flag ? (0,index_es/* zeroPad */.Bu)(days).replace(/^0+/, '') : (0,index_es/* zeroPad */.Bu)(days)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "d"
        }), " "]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).zerotime,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PromotionTimer_module_default()).zerotimepad,
          children: "0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "d"
        })]
      }), hours ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).time,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PromotionTimer_module_default()).zerotimepad,
          children: flag ? (0,index_es/* zeroPad */.Bu)(hours).replace(/^0+/, '') : (0,index_es/* zeroPad */.Bu)(hours)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "h"
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).zerotime,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PromotionTimer_module_default()).zerotimepad,
          children: "0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "h"
        })]
      }), minutes ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).time,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PromotionTimer_module_default()).zerotimepad,
          children: flag ? (0,index_es/* zeroPad */.Bu)(minutes).replace(/^0+/, '') : (0,index_es/* zeroPad */.Bu)(minutes)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "m"
        }), " "]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).zerotime,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PromotionTimer_module_default()).zerotimepad,
          children: "0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "m"
        })]
      }), seconds > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PromotionTimer_module_default()).zerotime,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PromotionTimer_module_default()).zerotimepad,
          children: flag ? (0,index_es/* zeroPad */.Bu)(seconds).replace(/^0+/, '') : (0,index_es/* zeroPad */.Bu)(seconds)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "s"
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.ZP, {
      date: date,
      renderer: renderer,
      zeroPadTime: 1
    })
  });
};

/* harmony default export */ var promotionTimer_PromotionTimer = (PromotionTimer);
// EXTERNAL MODULE: ./Redux/actions/upgradeAction.js
var upgradeAction = __webpack_require__(58486);
// EXTERNAL MODULE: ./components/molecules/affordabilityContainer/AffordabilityContainer.jsx
var AffordabilityContainer = __webpack_require__(97984);
// EXTERNAL MODULE: ./services/upgradeService.js
var upgradeService = __webpack_require__(70098);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
// EXTERNAL MODULE: ./components/atoms/indication/Indication.jsx
var Indication = __webpack_require__(28093);
// EXTERNAL MODULE: ./components/atoms/shopWithStock/shopWithStock.module.scss
var shopWithStock_module = __webpack_require__(58837);
var shopWithStock_module_default = /*#__PURE__*/__webpack_require__.n(shopWithStock_module);
// EXTERNAL MODULE: ./components/atoms/link/Link.module.scss
var Link_module = __webpack_require__(4924);
var Link_module_default = /*#__PURE__*/__webpack_require__.n(Link_module);
// EXTERNAL MODULE: ./components/atoms/link/Link.jsx
var Link = __webpack_require__(92308);
;// CONCATENATED MODULE: ./components/atoms/shopWithStock/ShopWithStock.jsx






var ShopWithStock = function ShopWithStock(_ref) {
  var shopName = _ref.shopName,
      mapLink = _ref.mapLink,
      onClickHandler = _ref.onClickHandler,
      linkText = _ref.linkText,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (shopWithStock_module_default()).store,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (shopWithStock_module_default()).store__icon
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (shopWithStock_module_default()).store__name,
        children: shopName.toLowerCase()
      }), ' ']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((shopWithStock_module_default()).link, " mt-s"),
      children: mapLink ? /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        text: linkText,
        href: mapLink
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "regular-link ".concat((Link_module_default()).link),
        onClick: onClickHandler,
        children: linkText
      })
    })]
  });
};

ShopWithStock.defaultProps = {
  shopName: '',
  linkText: 'Check at another store',
  className: ''
};
/* harmony default export */ var shopWithStock_ShopWithStock = (ShopWithStock);
// EXTERNAL MODULE: ./components/organisms/productDetailIndicators/productDetailIndicators.module.scss
var productDetailIndicators_module = __webpack_require__(19011);
var productDetailIndicators_module_default = /*#__PURE__*/__webpack_require__.n(productDetailIndicators_module);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/molecules/StockModal/StockModal.jsx
var StockModal = __webpack_require__(75217);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
;// CONCATENATED MODULE: ./components/organisms/productDetailIndicators/ProductDetailIndicators.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var ProductDetailIndicators = function ProductDetailIndicators(_ref) {
  var className = _ref.className,
      indicatorClass = _ref.indicatorClass,
      isLowStock = _ref.isLowStock,
      isOutOfStock = _ref.isOutOfStock,
      quantity = _ref.quantity,
      showModal = _ref.showModal,
      productDetails = _ref.productDetails,
      stockMessage = _ref.stockMessage,
      uniqueIndicationId = _ref.uniqueIndicationId,
      userLoggedIn = _ref.userLoggedIn,
      checkSelect = _ref.checkSelect,
      profileLoading = _ref.profileLoading,
      selectedOption = _ref.selectedOption,
      isBuyOptioon = _ref.isBuyOptioon,
      isDeal = _ref.isDeal,
      flag = _ref.flag,
      promotionTag = _ref.promotionTag,
      geoLocationIsAllowed = _ref.geoLocationIsAllowed,
      nearestStore = _ref.nearestStore,
      isStoreStockServiceDown = _ref.isStoreStockServiceDown,
      isCandCEligible = _ref.isCandCEligible,
      isMiniApp = _ref.isMiniApp;

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showPreOrderInfo = _useState2[0],
      setShowPreOrderInfo = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      preOrderAvailable = _useState3[0],
      setPreOrderAvailable = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      preOrderAvailableDesc = _useState4[0],
      setPreOrderAvailableDesc = _useState4[1];

  var env = (config_default()).env;
  var loginUrl = (config_default()).envConfigs[env].DIDLoginUrl;
  var dispatch = (0,DependencyHelper.useDispatch)();

  var _useState5 = (0,react.useState)([]),
      storeStockCheckStatusMessage = _useState5[0],
      setStoreStockCheckStatusMessage = _useState5[1];

  var handleClose = function handleClose() {
    setShow(false);
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      page_form_event: "success",
      page_form_name: "shopping: devices: out of stock: email notification signup"
    }));
  };

  function getAlertData() {
    return _getAlertData.apply(this, arguments);
  }

  function _getAlertData() {
    _getAlertData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var alertResult;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* AlertDetails */.kr, {
                productId: productDetails === null || productDetails === void 0 ? void 0 : productDetails.id
              });

            case 2:
              alertResult = _context4.sent;

              if (alertResult.productAlert == null) {
                setShow(false);
              } else {
                setShow(true);
              }

              dispatch({
                type: actionTypes/* ALERT_SELECT */.XI,
                payload: false
              });

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _getAlertData.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    if (promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER) {
      fetchPreOrderContent();
    }
  }, [promotionTag]);
  (0,react.useEffect)(function () {
    var JWTtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");

    if (checkSelect === true) {
      if (userLoggedIn && JWTtoken && productDetails !== null && productDetails !== void 0 && productDetails.id) {
        getAlertData();
      } else if (!JWTtoken && !profileLoading && !userLoggedIn) {
        var redirectURL = loginUrl + "?redirectUrl=" + window.location.href + (isMiniApp ? "&app=true" : "");
        window.location.replace(redirectURL);
      }
    }
  }, [checkSelect, userLoggedIn, profileLoading]);
  (0,react.useEffect)(function () {
    function storeStockStatusMessages() {
      return _storeStockStatusMessages.apply(this, arguments);
    }

    function _storeStockStatusMessages() {
      _storeStockStatusMessages = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _messages$sections, _messages$sections$, messages;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "storeStockCheckStatus");

              case 3:
                messages = _context.sent;
                setStoreStockCheckStatusMessage(messages === null || messages === void 0 ? void 0 : (_messages$sections = messages.sections) === null || _messages$sections === void 0 ? void 0 : (_messages$sections$ = _messages$sections[0]) === null || _messages$sections$ === void 0 ? void 0 : _messages$sections$.items);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.log("deal-details: features : error: ", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
      return _storeStockStatusMessages.apply(this, arguments);
    }

    storeStockStatusMessages();
  }, [isCandCEligible]);

  var handleShow = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var analyticsData;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                type: actionTypes/* ALERT_SELECT */.XI,
                payload: true
              });
              analyticsData = _objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "sales_product_category", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
                link_type: "o",
                link_name: "shopping: devices: ".concat(isDeal ? "deal details" : "product details", ": out of stock: notify me when its available online")
              });
              analyticsUtag/* link */.p4(analyticsData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleShow() {
      return _ref2.apply(this, arguments);
    };
  }();

  var fetchPreOrderContent = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var url, _result$sections$, result;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = isDeal ? "preOrderDealDetail" : "preOrderProductDetail";
              _context3.prev = 1;
              _context3.next = 4;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", url);

            case 4:
              result = _context3.sent;

              if (result !== null && result !== void 0 && (_result$sections$ = result.sections[0]) !== null && _result$sections$ !== void 0 && _result$sections$.items) {
                if (isDeal) {
                  setPreOrderAvailable(result.sections[0].items[1].title);
                  setPreOrderAvailableDesc(result.sections[0].items[1].description.replace(/<[^>]+>/g, ''));
                } else {
                  setPreOrderAvailable(result.sections[0].items[0].title);
                  setPreOrderAvailableDesc(result.sections[0].items[0].description.replace(/<[^>]+>/g, ''));
                }

                setShowPreOrderInfo(true);
              }

              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              console.error('[ProductDetailIndicators]', _context3.t0);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8]]);
    }));

    return function fetchPreOrderContent() {
      return _ref3.apply(this, arguments);
    };
  }();

  var renderCTA = function renderCTA() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
      // variant="solid white"
      className: "".concat((productDetailIndicators_module_default())["storeCard-button"], " ").concat((productDetailIndicators_module_default())["btn-in-store"]),
      variant: "outline black",
      handleClick: showModal,
      children: "Check in-store stock now"
    }, "check-in-store");
  };

  var noStoreStockMsg = function noStoreStockMsg(index) {
    var _storeStockCheckStatu, _storeStockCheckStatu2;

    if (!Array.isArray(storeStockCheckStatusMessage) || !storeStockCheckStatusMessage.length) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "d-flex ".concat(indicatorClass),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        img_path: storeStockCheckStatusMessage && ((_storeStockCheckStatu = storeStockCheckStatusMessage[index]) === null || _storeStockCheckStatu === void 0 ? void 0 : _storeStockCheckStatu.icon),
        img_width: "19px",
        img_height: "19px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (productDetailIndicators_module_default())["no-stock-store"],
        children: storeStockCheckStatusMessage && ((_storeStockCheckStatu2 = storeStockCheckStatusMessage[index]) === null || _storeStockCheckStatu2 === void 0 ? void 0 : _storeStockCheckStatu2.title)
      })]
    });
  };

  var storeStockAvailable = function storeStockAvailable() {
    var _storeStockCheckStatu3, _storeStockCheckStatu4;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [storeStockCheckStatusMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(Indication/* default */.Z, {
        className: "mt-l ".concat(indicatorClass),
        type: Indication/* IndicationState.Good */.q.Good,
        state: (_storeStockCheckStatu3 = storeStockCheckStatusMessage[0]) === null || _storeStockCheckStatu3 === void 0 ? void 0 : _storeStockCheckStatu3.title,
        description: (_storeStockCheckStatu4 = storeStockCheckStatusMessage[0]) === null || _storeStockCheckStatu4 === void 0 ? void 0 : _storeStockCheckStatu4.description,
        uniqueIndication: uniqueIndicationId,
        preOrder: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(shopWithStock_ShopWithStock, {
        className: (productDetailIndicators_module_default())["shop-with-stock"],
        shopName: nearestStore === null || nearestStore === void 0 ? void 0 : nearestStore.name,
        onClickHandler: showModal
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (productDetailIndicators_module_default()).description,
          children: ["* ", labels/* default.lbl_click_and_collect_msg */.Z.lbl_click_and_collect_msg]
        })
      })]
    });
  };

  var noGeolocationAllowed = function noGeolocationAllowed() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Indication/* default */.Z, {
      className: "mt-l ".concat((productDetailIndicators_module_default())["in-stock-info"], " ").concat(indicatorClass),
      type: Indication/* IndicationState.Question */.q.Question,
      state: "We couldn't check stores near you *",
      description: "* ".concat(labels/* default.lbl_click_and_collect_msg */.Z.lbl_click_and_collect_msg),
      uniqueIndication: uniqueIndicationId,
      extended: renderCTA(),
      preOrder: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER
    });
  };

  var isAvailableOnline = !isLowStock && !isOutOfStock && !showPreOrderInfo;
  var showQuantityLeft = !!(quantity && isLowStock && !isOutOfStock && isBuyOptioon && selectedOption === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option && !showPreOrderInfo);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (productDetailIndicators_module_default()).availabilityWrapper,
    children: [isAvailableOnline && /*#__PURE__*/(0,jsx_runtime.jsx)(Indication/* default */.Z, {
      className: indicatorClass,
      type: Indication/* IndicationState.Good */.q.Good,
      state: 'In stock',
      description: "We can have it delivered to you within ",
      days: "2-5 working days",
      uniqueIndication: uniqueIndicationId,
      preOrder: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER
    }), showQuantityLeft && /*#__PURE__*/(0,jsx_runtime.jsx)(Indication/* default */.Z, {
      className: indicatorClass,
      type: Indication/* IndicationState.Warning */.q.Warning,
      state: (0,helperServices/* replaceValue */.gB)("Only no left online!", "no", quantity),
      description: "We can have it delivered to you within ",
      days: "2-5 working days",
      uniqueIndication: uniqueIndicationId,
      preOrder: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER
    }), isOutOfStock && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StockModal/* default */.Z, {
        show: show,
        handleClose: handleClose
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Indication/* default */.Z, {
        className: indicatorClass,
        type: isBuyOptioon ? selectedOption === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option ? Indication/* IndicationState.Bad */.q.Bad : Indication/* IndicationState.Warning */.q.Warning : Indication/* IndicationState.Bad */.q.Bad,
        state: "Out of stock",
        description: 'But you can still order and get it within ',
        uniqueIndication: uniqueIndicationId,
        days: "2 - 5 weeks",
        actionLabel: "Notify me when it's available online",
        onActionClick: handleShow,
        preOrder: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER,
        showAction: (selectedOption != labels/* default.lbl_custom_dropdown_upgrade_option */.Z.lbl_custom_dropdown_upgrade_option || labels/* default.lbl_custom_dropdown_upgrade_option_new_contract */.Z.lbl_custom_dropdown_upgrade_option_new_contract) && selectedOption != labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option
      })]
    }), showPreOrderInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(Indication/* default */.Z, {
      className: indicatorClass,
      type: Indication/* IndicationState.PreOrder */.q.PreOrder,
      state: 'Available for pre-order!',
      description: "Select how you'd like to pay to continue",
      uniqueIndication: uniqueIndicationId,
      preOrder: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER
    })]
  });
};

ProductDetailIndicators.defaultProps = {
  className: "",
  isLowStock: false,
  isOutOfStock: false,
  isStoreStockServiceDown: false,
  isCandCEligible: true,
  isMiniApp: false,
  indicatorClass: ""
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userLoggedIn: state.navDetails.isUserLoggedIn,
    checkSelect: state.alertSelect.alert,
    profileLoading: state.navDetails.isProfileLoading,
    isMiniApp: state.navDetails.isMiniApp
  };
};

/* harmony default export */ var productDetailIndicators_ProductDetailIndicators = ((0,DependencyHelper.connect)(mapStateToProps)(ProductDetailIndicators));
// EXTERNAL MODULE: ./components/vaimo/queries.js
var vaimo_queries = __webpack_require__(48998);
// EXTERNAL MODULE: ./components/vaimo/dealBuilderUtils.js
var dealBuilderUtils = __webpack_require__(20775);
;// CONCATENATED MODULE: ./components/organisms/productDetailForm/productDetailForm.jsx





function productDetailForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function productDetailForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? productDetailForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : productDetailForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


























var useIsVisible = function useIsVisible(options) {
  var _useState = (0,react.useState)(true),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
          entry = _ref2[0];

      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return function () {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, options]);
  return [ref, isVisible];
};

var ProductDetailForm = function ProductDetailForm(_ref3) {
  var _productDetails$categ, _selectedVariant$prod2, _selectedVariant$prod3, _selectedVariant$prod4, _selectedVariant$prod5, _selectedVariant$prod6, _selectedVariant$attr, _selectedVariant$prod7, _selectedVariant$prod8, _selectedVariant$prod9, _selectedVariant$attr2, _selectedVariant$prod10, _selectedVariant$prod11, _selectedVariant$prod12, _selectedVariant$attr3;

  var productDetails = _ref3.productDetails,
      selectedVariant = _ref3.selectedVariant,
      currentPrice = _ref3.currentPrice,
      oldPrice = _ref3.oldPrice,
      discount = _ref3.discount,
      addBundleProductToGuestCart = _ref3.addBundleProductToGuestCart,
      addSimpleProductToGuestCart = _ref3.addSimpleProductToGuestCart,
      addConfigurableToGuestCart = _ref3.addConfigurableToGuestCart,
      variantDealPrice = _ref3.variantDealPrice,
      buyOption = _ref3.buyOption,
      handleSelectedBuyOption = _ref3.handleSelectedBuyOption,
      buyOptions = _ref3.buyOptions,
      buyOptionTitle = _ref3.buyOptionTitle,
      buyOptionSku = _ref3.buyOptionSku,
      buyOptionId = _ref3.buyOptionId,
      buyOptionTypeId = _ref3.buyOptionTypeId,
      optList = _ref3.optList,
      handleOptionClick1 = _ref3.handleOptionClick1,
      date = _ref3.date,
      displayDiscountTimer = _ref3.displayDiscountTimer,
      selectedOptions = _ref3.selectedOptions,
      showUpgradeModal = _ref3.showUpgradeModal,
      displayHideUpgradeModal = _ref3.displayHideUpgradeModal,
      upgradeCheckDone = _ref3.upgradeCheckDone,
      updateUpgradeRedirect = _ref3.updateUpgradeRedirect,
      syncUserProfile = _ref3.syncUserProfile,
      resetSyncUserProfile = _ref3.resetSyncUserProfile,
      triggerCallback = _ref3.triggerCallback,
      showSnackBarEvent = _ref3.showSnackBarEvent,
      closeSnackBarEvent = _ref3.closeSnackBarEvent,
      variantDeviceInstallment = _ref3.variantDeviceInstallment,
      checkIfdealQualifies = _ref3.checkIfdealQualifies,
      checkIsDealAffordable = _ref3.checkIsDealAffordable,
      creditFilters = _ref3.creditFilters,
      updateJourneyStatus = _ref3.updateJourneyStatus,
      fetchCreditFilters = _ref3.fetchCreditFilters,
      eligibleUpgradeList = _ref3.eligibleUpgradeList,
      setDevicePrice = _ref3.setDevicePrice,
      userLoggedIn = _ref3.userLoggedIn,
      journeyStatus = _ref3.journeyStatus,
      updateUnmaskedMsisdn = _ref3.updateUnmaskedMsisdn,
      upgradeChecksEnabled = _ref3.upgradeChecksEnabled,
      promotionTag = _ref3.promotionTag,
      showShopCheck = _ref3.showShopCheck,
      geoLocationIsAllowed = _ref3.geoLocationIsAllowed,
      nearestStore = _ref3.nearestStore,
      isStoreStockServiceDown = _ref3.isStoreStockServiceDown;

  var _useState2 = (0,react.useState)(false),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      smallMonthlyArray = _useState3[0],
      setSmallMonthlyArray = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      bigMonthlyArray = _useState4[0],
      setBigSmallMonthlyArray = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      hugeMonthlyArray = _useState5[0],
      setHugeSmallMonthlyArray = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      lowestDeal = _useState6[0],
      setLowestDeal = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      recommendedPlans = _useState7[0],
      setRecommendedPlans = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      recommendedPlans24 = _useState8[0],
      setRecommendedPlans24 = _useState8[1];

  var _useState9 = (0,react.useState)([]),
      recommendedPlans36 = _useState9[0],
      setRecommendedPlans36 = _useState9[1];

  var _useState10 = (0,react.useState)([]),
      recommendedPlans48 = _useState10[0],
      setRecommendedPlans48 = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      features = _useState11[0],
      setFeatures = _useState11[1];

  var _useState12 = (0,react.useState)('48'),
      selectedMonthlyInfo = _useState12[0],
      setSelectedMonthlyInfo = _useState12[1];

  var _useState13 = (0,react.useState)(1),
      qtyValue = _useState13[0],
      setQtyValue = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      isInCart = _useState14[0],
      setIsInCart = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      showSnackBar = _useState15[0],
      setShowSnackBar = _useState15[1];

  var _useState16 = (0,react.useState)(false),
      showAffordModal = _useState16[0],
      setShowAffordModal = _useState16[1];

  var _useState17 = (0,react.useState)(true),
      isTimedOut = _useState17[0],
      setTimedOut = _useState17[1];

  var infoText = {
    text: "",
    className: ""
  };
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var legacyEnv = (config_default()).envConfigs[env].legacyEnv;
  var router = (0,DependencyHelper.useRouter)();
  var gqlCallCounter = 0;

  function featuresCheck() {
    return _featuresCheck.apply(this, arguments);
  }

  function _featuresCheck() {
    _featuresCheck = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var featuresResult;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return ajaxServices/* default.httpGet */.Z.httpGet("featureBaseUrl", "", "api", "features");

            case 3:
              featuresResult = _context3.sent;

              if (featuresResult) {
                setFeatures(featuresResult);
              }

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.log("deal-details: features : error: ", _context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return _featuresCheck.apply(this, arguments);
  }

  var _useIsVisible = useIsVisible({
    root: null,
    // use the document's viewport as the container
    rootMargin: '0px',
    threshold: 1 // trigger when at least 10% of the element is visible

  }),
      _useIsVisible2 = (0,slicedToArray/* default */.Z)(_useIsVisible, 2),
      ref = _useIsVisible2[0],
      isVisible = _useIsVisible2[1];

  var _useIsVisible3 = useIsVisible({
    root: null,
    // use the document's viewport as the container
    rootMargin: '0px',
    threshold: 1 // trigger when at least 10% of the element is visible

  }),
      _useIsVisible4 = (0,slicedToArray/* default */.Z)(_useIsVisible3, 2),
      refNewContract = _useIsVisible4[0],
      isNewVisible = _useIsVisible4[1];

  var _useIsVisible5 = useIsVisible({
    root: null,
    // use the document's viewport as the container
    rootMargin: '0px',
    threshold: 1 // trigger when at least 10% of the element is visible

  }),
      _useIsVisible6 = (0,slicedToArray/* default */.Z)(_useIsVisible5, 2),
      refUpgrade = _useIsVisible6[0],
      isUpgradeVisible = _useIsVisible6[1];

  var initialObject = Object.values(optList);

  if (initialObject && selectedOptions) {
    initialObject.map(function (key) {
      Object.keys(key).map(function (element) {
        if (element === labels/* default.lbl_internal_storage */.Z.lbl_internal_storage) {
          if (Object.values(key)[0] && Object.values(key)[0].length === 1) {
            var _Object$values$, _Object$values$$, _Object$values$2, _Object$values$2$;

            ((_Object$values$ = Object.values(key)[0]) === null || _Object$values$ === void 0 ? void 0 : (_Object$values$$ = _Object$values$[0]) === null || _Object$values$$ === void 0 ? void 0 : _Object$values$$.label) === (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.internal_storage) ? selectedOptions["internal_storage"] = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.internal_storage : selectedOptions["internal_storage"] = (_Object$values$2 = Object.values(key)[0]) === null || _Object$values$2 === void 0 ? void 0 : (_Object$values$2$ = _Object$values$2[0]) === null || _Object$values$2$ === void 0 ? void 0 : _Object$values$2$.label;
          } else {
            var _Object$values$3, _Object$values$3$;

            var result = Object.values(key)[0].find(function (obj) {
              return obj.label === selectedOptions[element];
            });
            result && (result === null || result === void 0 ? void 0 : result.label) === selectedOptions[element] ? selectedOptions[element] = selectedOptions[element] : selectedOptions[element] = (_Object$values$3 = Object.values(key)[0]) === null || _Object$values$3 === void 0 ? void 0 : (_Object$values$3$ = _Object$values$3[0]) === null || _Object$values$3$ === void 0 ? void 0 : _Object$values$3$.label;
          }
        } else if (element === labels/* default.lbl_screen_size_pixels */.Z.lbl_screen_size_pixels) {
          if (Object.values(key)[0] && Object.values(key)[0].length === 1) {
            var _Object$values$4, _Object$values$4$, _Object$values$5, _Object$values$5$;

            ((_Object$values$4 = Object.values(key)[0]) === null || _Object$values$4 === void 0 ? void 0 : (_Object$values$4$ = _Object$values$4[0]) === null || _Object$values$4$ === void 0 ? void 0 : _Object$values$4$.label) === (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.screen_size_pixels) ? selectedOptions["screen_size_pixels"] = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.screen_size_pixels : selectedOptions["screen_size_pixels"] = (_Object$values$5 = Object.values(key)[0]) === null || _Object$values$5 === void 0 ? void 0 : (_Object$values$5$ = _Object$values$5[0]) === null || _Object$values$5$ === void 0 ? void 0 : _Object$values$5$.label;
          } else {
            var _Object$values$6, _Object$values$6$;

            var _result = Object.values(key)[0].find(function (obj) {
              return obj.label === selectedOptions[element];
            });

            _result && (_result === null || _result === void 0 ? void 0 : _result.label) === selectedOptions[element] ? selectedOptions[element] = selectedOptions[element] : selectedOptions[element] = (_Object$values$6 = Object.values(key)[0]) === null || _Object$values$6 === void 0 ? void 0 : (_Object$values$6$ = _Object$values$6[0]) === null || _Object$values$6$ === void 0 ? void 0 : _Object$values$6$.label;
          }
        }
      });
    });
  }

  var getProductforBadge = function getProductforBadge() {
    if (selectedVariant) {
      return selectedVariant.product;
    }

    if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle) {
      var _productDetails$items, _productDetails$items2;

      return productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$items = productDetails.items[0]) === null || _productDetails$items === void 0 ? void 0 : (_productDetails$items2 = _productDetails$items.options[0]) === null || _productDetails$items2 === void 0 ? void 0 : _productDetails$items2.product;
    }

    if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple) {
      return productDetails;
    }
  };

  var analyticsData = productDetailForm_objectSpread({
    link_type: "o",
    link_name: "shopping: devices: product details: add to cart",
    sales_event: "cart_add",
    sales_order_discount: [(0,helperServices/* getAmountOffValue */.Dd)(productDetails)],
    page_channel: "shopping",
    page_name: "shopping: devices: product details",
    page_master_tab: "personal",
    sales_product_category: [productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$categ = productDetails.categories[0]) === null || _productDetails$categ === void 0 ? void 0 : _productDetails$categ.name],
    sales_product_id: [productDetails === null || productDetails === void 0 ? void 0 : productDetails.name],
    sales_product_quantity: [1],
    sales_product_price: ["".concat(currentPrice)],
    sales_promo_name: promotionTag ? promotionTag : ""
  }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type"]));

  (0,react.useEffect)(function () {
    if (triggerCallback == "productDetailForm") {
      handleAddToCart();
    }
  }, [triggerCallback]);
  (0,react.useEffect)(function () {
    if (selectedMonthlyInfo === '48') {
      setRecommendedPlans(recommendedPlans48);
    } else if (selectedMonthlyInfo === '36') {
      setRecommendedPlans(recommendedPlans36);
    } else {
      setRecommendedPlans(recommendedPlans24);
    }
  }, [selectedMonthlyInfo]);
  (0,react.useEffect)(function () {
    featuresCheck();

    if (isInCart) {
      setIsInCart(false);
    }
  }, [productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku]);
  (0,react.useEffect)(function () {
    if (showSnackBar) {
      var timer = setTimeout(function () {
        return handleSnackBar();
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);

  var closeOptions = function closeOptions() {
    setShowModal(false);
  };

  var isMobile = (0,helperServices/* componentResize */.Y4)();

  var handleScrollToOptions = function handleScrollToOptions() {
    var element = document.querySelector("[class*='radioButton_radio-button']"),
        elementTop = element.getBoundingClientRect().top + window.scrollY; // Scroll to the element, minus 160px

    window.scrollTo({
      top: elementTop - 160,
      behavior: 'smooth' // This enables smooth scrolling

    });
  };

  var handleGetDeal = function handleGetDeal(selectedDeal) {
    window.location.href = features && features.pdpToDealBuilder ? '/shopping/deal-builder/' + productDetails.sku + '&dealSku=' + selectedDeal + '&variantSku=' + selectedVariant.product.sku + '&colorValue=' + selectedVariant.attributes[0].value_index : "".concat(urlPrefix, "/deal-selection/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku);
  };

  var handleChooseDeal = function handleChooseDeal() {
    window.location.href = features && features.pdpToDealBuilder ? '/shopping/deal-builder/' + productDetails.sku + '&variantSku=' + selectedVariant.product.sku + '&colorValue=' + selectedVariant.attributes[0].value_index : "".concat(urlPrefix, "/deal-selection/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku);
  };

  var handleAddToCart = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _cartResult, _cartResult2, _cartResult2$data, _cartResult3, _cartResult3$data, _cartResult4, _cartResult4$data;

      var cartId, customizable_options, cartArr, cartResult, _selectedVariant$prod, bundleOptions;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              closeSnackBarEvent();
              resetSyncUserProfile();
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              customizable_options = buyOptionId && buyOptionTypeId ? [{
                id: buyOptionId,
                value_string: buyOptionTypeId === null || buyOptionTypeId === void 0 ? void 0 : buyOptionTypeId.toString()
              }] : [];

              if (!(productDetails.__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable)) {
                _context.next = 10;
                break;
              }

              cartArr = [{
                parent_sku: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku).toString(),
                data: {
                  quantity: qtyValue ? qtyValue : labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                  sku: "".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod = selectedVariant.product) === null || _selectedVariant$prod === void 0 ? void 0 : _selectedVariant$prod.sku).toString()
                },
                customizable_options: customizable_options
              }];
              _context.next = 9;
              return addConfigurableToGuestCart(cartId, cartArr);

            case 9:
              cartResult = _context.sent;

            case 10:
              if (!(productDetails.__typename === labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple)) {
                _context.next = 15;
                break;
              }

              cartArr = [{
                data: {
                  quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                  sku: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku)
                },
                customizable_options: customizable_options
              }];
              _context.next = 14;
              return addSimpleProductToGuestCart(cartId, cartArr);

            case 14:
              cartResult = _context.sent;

            case 15:
              if (!(productDetails.__typename === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle)) {
                _context.next = 21;
                break;
              }

              bundleOptions = productDetails.items.map(function (bundle) {
                var obj = {
                  id: bundle.option_id,
                  quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                  value: [bundle.options[0].id]
                };
                return obj;
              });
              cartArr = [{
                bundle_options: bundleOptions,
                data: {
                  sku: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku).toString(),
                  quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty
                },
                customizable_options: customizable_options
              }];
              _context.next = 20;
              return addBundleProductToGuestCart(cartId, cartArr);

            case 20:
              cartResult = _context.sent;

            case 21:
              if (cartResult.status == 422 && gqlCallCounter == 0) {
                (0,helperServices/* handleCartActionFailure */.rO)(cartResult, handleAddToCart, handleProfileSync);
                gqlCallCounter++;
              } else if (cartResult && !cartResult.errors && (!((_cartResult = cartResult) !== null && _cartResult !== void 0 && _cartResult.data) || (_cartResult2 = cartResult) !== null && _cartResult2 !== void 0 && (_cartResult2$data = _cartResult2.data) !== null && _cartResult2$data !== void 0 && _cartResult2$data.addConfigurableProductsToCart || (_cartResult3 = cartResult) !== null && _cartResult3 !== void 0 && (_cartResult3$data = _cartResult3.data) !== null && _cartResult3$data !== void 0 && _cartResult3$data.addSimpleProductsToCart || (_cartResult4 = cartResult) !== null && _cartResult4 !== void 0 && (_cartResult4$data = _cartResult4.data) !== null && _cartResult4$data !== void 0 && _cartResult4$data.addBundleProductsToCart)) {
                setShowModal(true);
                setShowSnackBar(true);

                if (productDetails.badges_label == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER) {
                  viewCart();
                } else {
                  setIsInCart(true);

                  if (buyOption.indexOf('once off') > -1) {
                    setTimeout(function () {
                      setIsInCart(false);
                    }, 4000);
                  }
                }

                (0,helperServices/* hideSpinner */.v3)();
                gqlCallCounter = 0;
              } else {
                resetSyncUserProfile();
                showSnackBarEvent();
                (0,helperServices/* hideSpinner */.v3)();
                window.scrollTo(0, 0);
                gqlCallCounter = 0;
              }

              analyticsUtag/* link */.p4(productDetailForm_objectSpread(productDetailForm_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), analyticsData));

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddToCart() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleProfileSync = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var JWTtoken, cartId, pageAction;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              JWTtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              pageAction = "productDetailForm";
              syncUserProfile({
                JWTtoken: JWTtoken,
                cartId: cartId,
                pageAction: pageAction
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleProfileSync() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleSnackBar = function handleSnackBar() {
    setShowSnackBar(false);
  };

  var stockFlag;

  if (selectedVariant) {
    stockFlag = (0,helperServices/* checkStockQuantity */.LY)(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.product);
  } else {
    stockFlag = (0,helperServices/* checkStockQuantity */.LY)(productDetails);
  }

  var viewCart = function viewCart() {
    (0,helperServices/* showSpinner */.yh)();
    analyticsUtag/* link */.p4(productDetailForm_objectSpread(productDetailForm_objectSpread({}, analyticsData), {}, {
      link_type: "o",
      link_name: "shopping: devices: product details: view cart",
      sales_event: "view cart",
      sales_order_discount: [(0,helperServices/* getAmountOffValue */.Dd)(productDetails)]
    }));
    router.push("".concat(urlPrefix, "/cart")).then(function () {
      window.scrollTo(0, 0);
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var handleSelectedColor = function handleSelectedColor(opt, label, optList) {
    var _productDetails$categ2;

    analyticsUtag/* link */.p4(productDetailForm_objectSpread(productDetailForm_objectSpread(productDetailForm_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type"])), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: product details: device colour filter",
      filter_query: label,
      page_name: "shopping: devices: product details",
      sales_product_category: [productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$categ2 = productDetails.categories[0]) === null || _productDetails$categ2 === void 0 ? void 0 : _productDetails$categ2.name],
      sales_product_id: [productDetails === null || productDetails === void 0 ? void 0 : productDetails.name]
    }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type"])), {}, {
      page_site_section_lvl_1: productDetails === null || productDetails === void 0 ? void 0 : productDetails.name,
      page_site_section_lvl_2: "Browse products",
      page_site_section_lvl_3: "Home"
    }));
    handleSelectedDeals(opt, label, false);
    handleOptionClick1(Object.keys(opt), label, optList);
  };

  (0,react.useEffect)(function () {
    handleSelectedDeals(false, false, productDetails.variants[0]);
  }, []);

  function handleSelectedDeals(_x, _x2, _x3) {
    return _handleSelectedDeals.apply(this, arguments);
  }

  function _handleSelectedDeals() {
    _handleSelectedDeals = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(options, selectedLabel, preselectedVariant) {
      var _finalVariant, _finalVariant2;

      var finalVariant, item, _options$color, plans, result, specialPlans, array48, array24, array36, _yield$Promise$all, _yield$Promise$all2, contractResult, _contractResult$DealS, _result2, _result2$products, terms24, terms36, terms48;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!preselectedVariant) {
                item = options === null || options === void 0 ? void 0 : (_options$color = options.color) === null || _options$color === void 0 ? void 0 : _options$color.find(function (entry) {
                  return entry.label === selectedLabel;
                });
                finalVariant = productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.find(function (variant) {
                  return variant.attributes.some(function (attribute) {
                    return attribute.value_index === item.value_index;
                  });
                });
              } else {
                finalVariant = preselectedVariant;
              }

              plans = (_finalVariant = finalVariant) !== null && _finalVariant !== void 0 && _finalVariant.deal_builder_deals ? (_finalVariant2 = finalVariant) === null || _finalVariant2 === void 0 ? void 0 : _finalVariant2.deal_builder_deals : productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_builder_deals;

              if (!(plans && plans.length)) {
                _context4.next = 7;
                break;
              }

              _context4.next = 5;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(vaimo_queries/* DealBuilderContractSearchData */.vn, {
                filter: {
                  sku: {
                    "in": plans === null || plans === void 0 ? void 0 : plans.toUpperCase().split(',')
                  },
                  is_deal_product: {
                    eq: 1
                  },
                  is_hidden_product: {
                    eq: 0
                  }
                }
              });

            case 5:
              specialPlans = _context4.sent;

              if (specialPlans) {
                array48 = [], array24 = [], array36 = [];
                setRecommendedPlans(specialPlans.products.items);
                specialPlans.products.items.forEach(function (item) {
                  if (item.payment_terms_label === "36") {
                    array36.push(item);
                  } else if (item.payment_terms_label === "24") {
                    array24.push(item);
                  } else if (item.payment_terms_label === "48") {
                    array48.push(item);
                  }
                });
                setRecommendedPlans48(array48);
                setRecommendedPlans36(array36);
                setRecommendedPlans24(array24);
              }

            case 7:
              _context4.next = 9;
              return Promise.all([ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(vaimo_queries/* DealBuilderContractSearch */.hV, {
                name: productDetails.sku
              })]);

            case 9:
              _yield$Promise$all = _context4.sent;
              _yield$Promise$all2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all, 1);
              contractResult = _yield$Promise$all2[0];

              if (!contractResult) {
                _context4.next = 17;
                break;
              }

              _context4.next = 15;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(vaimo_queries/* DealBuilderContractSearchData */.vn, {
                filter: {
                  sku: {
                    "in": contractResult === null || contractResult === void 0 ? void 0 : (_contractResult$DealS = contractResult.DealSelection) === null || _contractResult$DealS === void 0 ? void 0 : _contractResult$DealS.deal_skus
                  },
                  is_deal_product: {
                    eq: 1
                  },
                  is_hidden_product: {
                    eq: 0
                  }
                }
              });

            case 15:
              result = _context4.sent;

              if (result) {
                terms24 = [];
                terms36 = [];
                terms48 = [];
                setLowestDeal((_result2 = result) === null || _result2 === void 0 ? void 0 : (_result2$products = _result2.products) === null || _result2$products === void 0 ? void 0 : _result2$products.items[0]);
                result.products.items.forEach(function (item) {
                  if (item.payment_terms_label === "24") {
                    terms24.push(item);
                  } else if (item.payment_terms_label === "36") {
                    terms36.push(item);
                  } else if (item.payment_terms_label === "48") {
                    terms48.push(item);
                  }
                });
                setSmallMonthlyArray(terms24);
                setBigSmallMonthlyArray(terms36);
                setHugeSmallMonthlyArray(terms48);

                if (!terms48.length) {
                  setSelectedMonthlyInfo('36');
                }

                if (!terms36.length) {
                  setSelectedMonthlyInfo('24');
                }
              }

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _handleSelectedDeals.apply(this, arguments);
  }

  var productCarousel;
  var productCarousel24;
  var productCarousel48;

  var next = function next() {
    if (productCarousel) {
      productCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (productCarousel) {
      productCarousel.prev(600);
    }
  };

  var next24 = function next24() {
    if (productCarousel24) {
      productCarousel24.next(600);
    }
  };

  var prev24 = function prev24() {
    if (productCarousel24) {
      productCarousel24.prev(600);
    }
  };

  var next48 = function next48() {
    if (productCarousel48) {
      productCarousel48.next(600);
    }
  };

  var prev48 = function prev48() {
    if (productCarousel48) {
      productCarousel48.prev(600);
    }
  };

  var carouselOptions = {
    autoplay: false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    slideBy: 1,
    dots: true,
    items: 1,
    nav: true,
    margin: 16,
    responsive: {
      0: {
        dots: true,
        items: 1
      },
      1024: {
        dots: true
      }
    }
  };

  var handleSelectOption = function handleSelectOption(title) {
    setTimedOut(false);
    setTimeout(function () {
      setTimedOut(true);
    }, 300);
    handleSelectedBuyOption(title);
  };

  var handleContinueShopping = function handleContinueShopping() {
    closeOptions();
    (0,helperServices/* showSpinner */.yh)();
    analyticsUtag/* link */.p4(productDetailForm_objectSpread(productDetailForm_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "sales_product_category", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      link_type: "o",
      link_name: "shopping: product details: continue shopping"
    }));
    router.push("".concat(urlPrefix, "/products")).then(function () {
      window.scrollTo(0, 0);
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var handleViewCart = function handleViewCart() {
    closeOptions();
    (0,helperServices/* showSpinner */.yh)();
    analyticsUtag/* link */.p4(productDetailForm_objectSpread(productDetailForm_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "sales_product_category", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      link_type: "o",
      link_name: "shopping: devices: product details: view cart"
    }));
    router.push("".concat(urlPrefix, "/cart")).then(function () {
      window.scrollTo(0, 0);
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var getSelectedVariantForDeals = function getSelectedVariantForDeals() {
    var variant = selectedVariant && selectedVariant.product.sku ? selectedVariant.product.sku : productDetails.sku;
    return variant;
  };

  var goToUrl = function goToUrl() {
    analyticsUtag/* link */.p4(productDetailForm_objectSpread(productDetailForm_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "sales_order_discount", "sales_promo_name", "sales_product_category", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      link_type: "o",
      link_name: "shopping: devices: product details: get this deal"
    }));
    (0,helperServices/* showSpinner */.yh)();
    var dealRouter = features && features.pdpToDealBuilder ? "".concat(urlPrefix, "/deal-builder/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku) : "".concat(urlPrefix, "/deal-selection/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku);
    router.push(dealRouter).then(function () {
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var handleFindOut = function handleFindOut() {
    displayHideUpgradeModal(!showUpgradeModal);
  };

  var FindWhy = function FindWhy() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["You can't upgrade right now.", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        onClick: handleFindOut,
        className: (productDetailForm_module_default())["info-link"],
        children: "Find out why"
      })]
    });
  };

  var getCTAText = function getCTAText() {
    if (upgradeCheckDone) {
      infoText.text = labels/* default.upgrade.lbl_prod_upgrade_qualify_info */.Z.upgrade.lbl_prod_upgrade_qualify_info, infoText.icon = "".concat(imagePrefix, "/assets/images/icon-info.svg");
      infoText.className = "".concat((productDetailForm_module_default())["info-black"]);
      return promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : labels/* default.lbl_choose_upgrade_deal */.Z.lbl_choose_upgrade_deal;
    } else {
      if (userLoggedIn && (eligibleUpgradeList === null || eligibleUpgradeList === void 0 ? void 0 : eligibleUpgradeList.length) == 0) {
        infoText.text = FindWhy();
        infoText.icon = "".concat(imagePrefix, "/assets/images/icon-cross.svg");
        infoText.className = "".concat((productDetailForm_module_default())["info-red"]);
        return promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : labels/* default.lbl_choose_upgrade_deal */.Z.lbl_choose_upgrade_deal;
      } else {
        infoText.text = labels/* default.upgrade.lbl_prod_upgrade_due_info */.Z.upgrade.lbl_prod_upgrade_due_info;
        infoText.icon = "".concat(imagePrefix, "/assets/images/icon-info.svg");
        infoText.className = "".concat((productDetailForm_module_default())["info-black"]);
        return labels/* default.lbl_do_an_upgrade_check */.Z.lbl_do_an_upgrade_check;
      }
    }
  };

  var handleUpgrade = function handleUpgrade(val) {
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "shopping: devices: product details: ".concat(val),
      sales_promo_name: promotionTag ? promotionTag : ""
    });

    if (upgradeChecksEnabled) {
      if (val == "Do an upgrade check") {
        setDevicePrice({
          devicePrice: variantDealPrice,
          installment: Number(variantDeviceInstallment) // Need to update

        });

        if (!userLoggedIn && upgradeCheckDone === false && journeyStatus == upgradeService/* upgradeStages.OTP_ENRTY */.wv.OTP_ENRTY) {
          //this will only be done if there is a pending upgrade journey from other pages, to make sure that we will start with entering msisdn again
          //See ticket DCEC-13112 issue no. 2
          updateUnmaskedMsisdn("");
          updateJourneyStatus(null, upgradeService/* upgradeStages.NUMBER_ENRTY */.wv.NUMBER_ENRTY);
        }

        displayHideUpgradeModal(!showUpgradeModal);

        if (userLoggedIn) {
          if ((eligibleUpgradeList === null || eligibleUpgradeList === void 0 ? void 0 : eligibleUpgradeList.length) > 1) {
            updateJourneyStatus(null, upgradeService/* upgradeStages.ELIGIBLE_NUMBER_SELECT */.wv.ELIGIBLE_NUMBER_SELECT);
          } else if ((eligibleUpgradeList === null || eligibleUpgradeList === void 0 ? void 0 : eligibleUpgradeList.length) == 1) {
            var _eligibleUpgradeList$;

            fetchCreditFilters((_eligibleUpgradeList$ = eligibleUpgradeList[0]) === null || _eligibleUpgradeList$ === void 0 ? void 0 : _eligibleUpgradeList$.msisdn).then(function () {
              var _eligibleUpgradeList$2;

              updateJourneyStatus((_eligibleUpgradeList$2 = eligibleUpgradeList[0]) === null || _eligibleUpgradeList$2 === void 0 ? void 0 : _eligibleUpgradeList$2.resultCode, upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT);
            });
          }
        }

        var dealRouter = features && features.pdpToDealBuilder ? "".concat(urlPrefix, "/deal-builder/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku) : "".concat(urlPrefix, "/deal-selection/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku);
        updateUpgradeRedirect(dealRouter);
      } else {
        checkAffordability();
      }
    } else {
      (0,helperServices/* showSpinner */.yh)();
      router.push("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/shopping/upgrades-check")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var redirectToDealSelection = function redirectToDealSelection() {
    (0,helperServices/* showSpinner */.yh)();
    var dealRouter = features && features.pdpToDealBuilder ? "".concat(urlPrefix, "/deal-builder/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku) : "".concat(urlPrefix, "/deal-selection/").concat(productDetails.sku, "?id=").concat(getSelectedVariantForDeals(), "&buyOption=").concat(buyOptionSku);
    router.push(dealRouter).then(function () {
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var checkAffordability = function checkAffordability() {
    if ((creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.financeIndicator) === "Y" && Number(variantDealPrice) > Number(creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.total_monthly_payment)) {
      setShowAffordModal(true);
    } else if ((creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.financeIndicator) === "N" && (Number(variantDealPrice) > Number(creditFilters.total_monthly_payment) || Number(variantDeviceInstallment) > Number(creditFilters.deviceInstallment))) {
      setShowAffordModal(true);
    } else {
      redirectToDealSelection();
    }
  };

  (0,react.useEffect)(function () {
    if (checkIsDealAffordable && creditFilters !== null && creditFilters !== void 0 && creditFilters.total_monthly_payment) {
      checkIfdealQualifies(false);
      checkAffordability();
    }
  }, [checkIsDealAffordable]);

  var getSelectedValue = function getSelectedValue(code) {
    var _Object$entries$find;

    return (_Object$entries$find = Object.entries(selectedOptions).find(function (val) {
      return val[0] == code;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1];
  };

  function checkforDealData(sku, dealData) {
    var disabledSku = [labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option, labels/* default.lbl_custom_dropdown_upgrade_option */.Z.lbl_custom_dropdown_upgrade_option, labels/* default.lbl_custom_dropdown_upgrade_option_new_contract */.Z.lbl_custom_dropdown_upgrade_option_new_contract];

    if (Array.isArray(dealData) && disabledSku.includes(sku)) {
      if (dealData.length === 0) return true;
      if (dealData[0].min_price === null && dealData[0].deal_installment === null) return true;
      return false;
    }
  }

  var notStickyBar = function notStickyBar(notSticky) {
    if (notSticky) {
      document.body.classList.remove('sticky-bar');
    } else {
      document.body.classList.add('sticky-bar');
    }

    return notSticky;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (productDetailForm_module_default()).desktopSwatchInfo,
      children: [(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((productDetailForm_module_default()).desktopSwatchWrapper, " ").concat(optList.length > 1 ? 'multipleOptions' : ''),
        children: optList.map(function (opt, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
            items: Object.values(opt)[0],
            handleOnChange: function handleOnChange(label) {
              return handleSelectedColor(opt, label, optList);
            },
            selectedOption: selectedOptions && getSelectedValue(Object.keys(opt)),
            label: (0,helperServices/* getLabel */.id)(productDetails.configurable_options, Object.keys(opt))
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(productDetailIndicators_ProductDetailIndicators, {
        flag: true,
        className: (productDetailForm_module_default()).ProductIndicators,
        isLowStock: (0,helperServices/* checkIsLowStock */.yB)(getProductforBadge()),
        isOutOfStock: (0,helperServices/* checkStockQuantity */.LY)(selectedVariant !== null && selectedVariant !== void 0 && selectedVariant.product ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.product : productDetails),
        quantity: selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod2 = selectedVariant.product) === null || _selectedVariant$prod2 === void 0 ? void 0 : _selectedVariant$prod2.quantity : productDetails === null || productDetails === void 0 ? void 0 : productDetails.quantity,
        showShopCheck: showShopCheck,
        showModal: showModal,
        productDetails: productDetails,
        stockMessage: (selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod3 = selectedVariant.product) === null || _selectedVariant$prod3 === void 0 ? void 0 : _selectedVariant$prod3.stock_message) || (productDetails === null || productDetails === void 0 ? void 0 : productDetails.stock_message),
        selectedOption: buyOptionSku,
        isBuyOptioon: (buyOptions === null || buyOptions === void 0 ? void 0 : buyOptions.length) > 0 ? true : false,
        uniqueIndicationId: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku, "-Indication"),
        geoLocationIsAllowed: geoLocationIsAllowed,
        promotionTag: promotionTag,
        nearestStore: nearestStore,
        isStoreStockServiceDown: isStoreStockServiceDown
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (productDetailForm_module_default()).itemSwitcherWrapper,
      children: buyOptions !== null && buyOptions !== void 0 && buyOptions.length ? buyOptions === null || buyOptions === void 0 ? void 0 : buyOptions.map(function (option, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          onClick: function onClick() {
            return handleSelectOption(option === null || option === void 0 ? void 0 : option.title);
          },
          className: "".concat((productDetailForm_module_default()).itemSwitcher, " ").concat(option === null || option === void 0 ? void 0 : option.sku, " ").concat(checkforDealData(option === null || option === void 0 ? void 0 : option.sku, productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_data) ? (productDetailForm_module_default()).disabled : "", "\n            ").concat((option === null || option === void 0 ? void 0 : option.title) === buyOption ? (productDetailForm_module_default()).active : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "radio",
            name: "contract-type",
            checked: buyOption === option.title,
            id: "contract-type-".concat(index),
            disabled: checkforDealData(option === null || option === void 0 ? void 0 : option.sku, productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_data),
            className: "hidden"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "contract-type-".concat(index),
            children: (option === null || option === void 0 ? void 0 : option.sku) === 'once-off' ? 'Once-off' : (option === null || option === void 0 ? void 0 : option.sku) === 'upgrade' ? 'Upgrade' : 'New contract'
          })]
        }, index);
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((productDetailForm_module_default()).addInfoWrapper, " ").concat(buyOption !== "Get this product on a new contract" ? 'roundedLeft' : 'new-contract'),
      children: [(buyOptionSku === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option || !buyOptions) && /*#__PURE__*/(0,jsx_runtime.jsx)(productDetailPrice_ProductDetailPrice, {
        amount: currentPrice,
        prevAmount: oldPrice,
        saveAmount: discount,
        className: (productDetailForm_module_default()).textWhite,
        label: "Buy it today for only:"
      }), (buyOptionSku == labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option || buyOptionSku === labels/* default.lbl_custom_dropdown_upgrade_option */.Z.lbl_custom_dropdown_upgrade_option || buyOptionSku === labels/* default.lbl_custom_dropdown_upgrade_option_new_contract */.Z.lbl_custom_dropdown_upgrade_option_new_contract) && variantDealPrice ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (productDetailForm_module_default()).monthlySelectorWrapper,
          children: [hugeMonthlyArray.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-text": "48 Months",
            onClick: function onClick() {
              return setSelectedMonthlyInfo('48');
            },
            className: "".concat((productDetailForm_module_default()).monthlySelector, " ").concat(selectedMonthlyInfo === '48' ? (productDetailForm_module_default()).selectedMonthly : ''),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "48 months"
            })
          }) : '', bigMonthlyArray.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-text": "36 Months",
            onClick: function onClick() {
              return setSelectedMonthlyInfo('36');
            },
            className: "".concat((productDetailForm_module_default()).monthlySelector, " ").concat(selectedMonthlyInfo === '36' ? (productDetailForm_module_default()).selectedMonthly : ''),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "36 months"
            })
          }) : '', smallMonthlyArray.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-text": "24 Months",
            onClick: function onClick() {
              return setSelectedMonthlyInfo('24');
            },
            className: "".concat((productDetailForm_module_default()).monthlySelector, " ").concat(selectedMonthlyInfo === '24' ? (productDetailForm_module_default()).selectedMonthly : ''),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "24 months"
            })
          }) : '']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (productDetailForm_module_default()).whiteLabel,
          children: "Get it on contract starting from"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (productDetailForm_module_default())["deal-price"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (productDetailForm_module_default()).dealPrice,
            children: hugeMonthlyArray.length || bigMonthlyArray.length || smallMonthlyArray.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: ["R", function () {
                if (selectedMonthlyInfo === '36' && bigMonthlyArray.length) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [(0,helperServices/* numberFormat */.i8)(bigMonthlyArray[0].monthly_recurring), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["PM x ", bigMonthlyArray[0].payment_terms_label]
                    })]
                  });
                } else if (selectedMonthlyInfo === '48' && hugeMonthlyArray.length) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [(0,helperServices/* numberFormat */.i8)(hugeMonthlyArray[0].monthly_recurring), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["PM x ", hugeMonthlyArray[0].payment_terms_label]
                    })]
                  });
                } else {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [(0,helperServices/* numberFormat */.i8)(smallMonthlyArray[0].monthly_recurring), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["PM x ", smallMonthlyArray[0].payment_terms_label]
                    })]
                  });
                }
              }()]
            }) : 'Loading..'
          })
        }), (buyOptionSku === labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option || buyOptionSku === labels/* default.lbl_custom_dropdown_upgrade_option_new_contract */.Z.lbl_custom_dropdown_upgrade_option_new_contract) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: refNewContract,
          className: "".concat((productDetailForm_module_default()).formActions, " ").concat((productDetailForm_module_default()).formActionsContracts),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Button, {
            variant: "danger",
            className: "".concat((productDetailForm_module_default()).newButton, " ").concat(promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? (productDetailForm_module_default()).preOrderBtn : (productDetailForm_module_default()).addToCartBtn),
            block: true,
            id: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku, "-selectDealBtn"),
            onClick: function onClick() {
              return handleChooseDeal();
            },
            children: [" ", promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : 'Next: ' + labels/* default.lbl_select_deal */.Z.lbl_select_deal]
          })
        }), buyOptionSku && buyOptionSku === labels/* default.lbl_custom_dropdown_upgrade_option */.Z.lbl_custom_dropdown_upgrade_option && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: refUpgrade,
          className: "".concat((productDetailForm_module_default()).formActions, " ").concat((productDetailForm_module_default()).formActionsContracts),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Button, {
            variant: "danger",
            className: "".concat((productDetailForm_module_default()).upgradeButton, " ").concat(userLoggedIn && eligibleUpgradeList.length == 0 ? (productDetailForm_module_default()).disabled : (productDetailForm_module_default()).addToCartBtn),
            block: true,
            onClick: function onClick() {
              return handleUpgrade(getCTAText());
            },
            children: ["Next: ", getCTAText()]
          })
        })]
      }) : "", displayDiscountTimer ? /*#__PURE__*/(0,jsx_runtime.jsx)(promotionTimer_PromotionTimer, {
        date: date,
        flag: true
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "d-lg-block d-md-none"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [(buyOptionSku === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option || !buyOptions) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat(isInCart ? (productDetailForm_module_default()).addedToCartVisible : '', " ").concat(qtyValue === 1 || isInCart ? (productDetailForm_module_default()).formActionsWrapperPriceHidden : '', " ").concat((productDetailForm_module_default()).formActionsWrapper),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((productDetailForm_module_default()).qtyInfo, " ").concat(qtyValue > 1 || isInCart ? (productDetailForm_module_default()).qtyInfoShow : ''),
            children: ["Total: ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: ["R", (qtyValue * currentPrice).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })]
            }), isInCart && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
              variant: "danger",
              className: "".concat((productDetailForm_module_default()).viewCartButton, " ").concat(promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? (productDetailForm_module_default()).preOrderBtn : (productDetailForm_module_default()).addToCartBtn),
              block: true,
              disabled: stockFlag,
              onClick: handleViewCart,
              id: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku, "-AddToCartBtn"),
              children: "View my cart"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat(isInCart ? (productDetailForm_module_default()).addedToCartActionVisible : '', " ").concat(qtyValue === 1 ? (productDetailForm_module_default()).formActionsPriceHidden : '', " ").concat((productDetailForm_module_default()).formActions),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat((productDetailForm_module_default()).qtyWrapper),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                  return setQtyValue(parseInt(qtyValue) - 1 !== 0 ? parseInt(qtyValue) - 1 : 1);
                },
                className: "".concat(qtyValue === 1 || isInCart ? (productDetailForm_module_default()).qtyButtonDisabled : '', " ").concat((productDetailForm_module_default()).qtyButton, " ").concat((productDetailForm_module_default()).qtyButtonMinus)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                className: (productDetailForm_module_default()).qtyInput,
                type: Number,
                value: qtyValue
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: "".concat(isInCart ? (productDetailForm_module_default()).qtyButtonDisabled : '', " ").concat((productDetailForm_module_default()).qtyButton, " ").concat((productDetailForm_module_default()).qtyButtonPlus),
                onClick: function onClick() {
                  return setQtyValue(parseInt(qtyValue) + 1);
                }
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: ref,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
                variant: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? "danger" : "success",
                className: "".concat(promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? (productDetailForm_module_default()).preOrderBtn : (productDetailForm_module_default()).addToCartBtnStatic, " ").concat((productDetailForm_module_default()).addToCartBtnStatic, " ").concat(isInCart ? (productDetailForm_module_default()).addedToCartBtn : ''),
                block: true,
                disabled: stockFlag,
                onClick: handleAddToCart,
                id: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku, "-AddToCartBtn"),
                children: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: isInCart ? 'Added to cart' : 'Add to cart'
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(notStickyBar(!isTimedOut || isVisible) ? 'hidden' : (productDetailForm_module_default()).sticky_on_mobile),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (productDetailForm_module_default()).sticky_on_mobile_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (productDetailForm_module_default()).productStickyInfo,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (productDetailForm_module_default()).productStickyImage,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    src: selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod4 = selectedVariant.product) === null || _selectedVariant$prod4 === void 0 ? void 0 : (_selectedVariant$prod5 = _selectedVariant$prod4.thumbnail) === null || _selectedVariant$prod5 === void 0 ? void 0 : _selectedVariant$prod5.url,
                    width: 56,
                    height: 56
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (productDetailForm_module_default()).productStickyDetails,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (productDetailForm_module_default()).productStickyDetailsName,
                    children: selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod6 = selectedVariant.product) === null || _selectedVariant$prod6 === void 0 ? void 0 : _selectedVariant$prod6.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (productDetailForm_module_default()).productStickyDetailsOptions,
                    children: [selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$attr = selectedVariant.attributes[0]) === null || _selectedVariant$attr === void 0 ? void 0 : _selectedVariant$attr.label, (productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.length) > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      onClick: function onClick() {
                        return handleScrollToOptions();
                      },
                      className: (productDetailForm_module_default()).productStickyEit,
                      children: "Edit"
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (productDetailForm_module_default()).stickyPrice,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(productDetailPrice_ProductDetailPrice, {
                  amount: currentPrice < oldPrice ? qtyValue * currentPrice : qtyValue * oldPrice,
                  className: "textDark",
                  label: "Total"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "".concat((productDetailForm_module_default()).qtyWrapper, " ").concat((productDetailForm_module_default()).qtyWrapperOnWhite),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  onClick: function onClick() {
                    return setQtyValue(parseInt(qtyValue) - 1 !== 0 ? parseInt(qtyValue) - 1 : 1);
                  },
                  className: "".concat(isInCart ? (productDetailForm_module_default()).qtyButtonDisabled : '', " ").concat(qtyValue === 1 ? (productDetailForm_module_default()).qtyButtonDisabled : '', " ").concat((productDetailForm_module_default()).qtyButton, " ").concat((productDetailForm_module_default()).qtyButtonMinus)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  className: (productDetailForm_module_default()).qtyInput,
                  type: Number,
                  value: qtyValue
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  className: "".concat(isInCart ? (productDetailForm_module_default()).qtyButtonDisabled : '', " ").concat((productDetailForm_module_default()).qtyButton, " ").concat((productDetailForm_module_default()).qtyButtonPlus),
                  onClick: function onClick() {
                    return setQtyValue(parseInt(qtyValue) + 1);
                  }
                })]
              }), isInCart ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
                variant: "danger",
                className: "".concat((productDetailForm_module_default()).viewCartButton, " ").concat((productDetailForm_module_default()).addToCartBtn),
                block: true,
                disabled: stockFlag,
                onClick: handleViewCart,
                id: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku, "-AddToCartBtn"),
                children: "View my cart"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Button, {
                variant: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? "danger" : "success",
                className: "".concat(promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? (productDetailForm_module_default()).preOrderBtn : (productDetailForm_module_default()).addToCartBtn, " ").concat((productDetailForm_module_default()).addToCartBtn, " ").concat(isInCart ? (productDetailForm_module_default()).addedToCartBtn : ''),
                block: true,
                disabled: stockFlag,
                onClick: handleAddToCart,
                id: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku, "-AddToCartBtn"),
                children: promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: isInCart ? 'Added to cart' : 'Add to cart'
                })
              })]
            })
          })]
        }), buyOptionSku && (buyOptionSku === labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option || buyOptionSku === labels/* default.lbl_custom_dropdown_upgrade_option_new_contract */.Z.lbl_custom_dropdown_upgrade_option_new_contract) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat(notStickyBar(!isTimedOut || isNewVisible) ? 'hidden' : (productDetailForm_module_default()).sticky_on_mobile),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (productDetailForm_module_default()).sticky_on_mobile_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (productDetailForm_module_default()).productStickyInfo,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (productDetailForm_module_default()).productStickyImage,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod7 = selectedVariant.product) === null || _selectedVariant$prod7 === void 0 ? void 0 : (_selectedVariant$prod8 = _selectedVariant$prod7.thumbnail) === null || _selectedVariant$prod8 === void 0 ? void 0 : _selectedVariant$prod8.url,
                  width: 56,
                  height: 56
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (productDetailForm_module_default()).productStickyDetails,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (productDetailForm_module_default()).productStickyDetailsName,
                  children: selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod9 = selectedVariant.product) === null || _selectedVariant$prod9 === void 0 ? void 0 : _selectedVariant$prod9.name
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (productDetailForm_module_default()).productStickyDetailsOptions,
                  children: [selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$attr2 = selectedVariant.attributes[0]) === null || _selectedVariant$attr2 === void 0 ? void 0 : _selectedVariant$attr2.label, (productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.length) > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    onClick: function onClick() {
                      return handleScrollToOptions();
                    },
                    className: (productDetailForm_module_default()).productStickyEit,
                    children: "Edit"
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (productDetailForm_module_default()).stickyPrice,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (productDetailForm_module_default()).priceLabel,
                children: "Starting from"
              }), function () {
                if (selectedMonthlyInfo === '36' && bigMonthlyArray.length) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: (productDetailForm_module_default()).priceBold,
                      children: ["R", (0,helperServices/* numberFormat */.i8)(bigMonthlyArray[0].monthly_recurring)]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["PM x ", bigMonthlyArray[0].payment_terms_label]
                    })]
                  });
                } else if (selectedMonthlyInfo === '48' && hugeMonthlyArray.length) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: (productDetailForm_module_default()).priceBold,
                      children: ["R", (0,helperServices/* numberFormat */.i8)(hugeMonthlyArray[0].monthly_recurring)]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["PM x ", hugeMonthlyArray[0].payment_terms_label]
                    })]
                  });
                } else if (selectedMonthlyInfo === '24' && smallMonthlyArray.length) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: (productDetailForm_module_default()).priceBold,
                      children: ["R", (0,helperServices/* numberFormat */.i8)(smallMonthlyArray[0].monthly_recurring)]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["PM x ", smallMonthlyArray[0].payment_terms_label]
                    })]
                  });
                }
              }()]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Button, {
              variant: "danger",
              className: "".concat((productDetailForm_module_default()).newButton, " ").concat(promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? (productDetailForm_module_default()).preOrderBtn : (productDetailForm_module_default()).addToCartBtn, " upgrade-button"),
              block: true,
              id: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku, "-selectDealBtn"),
              onClick: function onClick() {
                return handleChooseDeal();
              },
              children: [promotionTag && promotionTag === types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? '' : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Next: "
              }), promotionTag && promotionTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : labels/* default.lbl_select_deal */.Z.lbl_select_deal]
            })]
          })
        }), buyOptionSku && buyOptionSku === labels/* default.lbl_custom_dropdown_upgrade_option */.Z.lbl_custom_dropdown_upgrade_option && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(notStickyBar(!isTimedOut || isUpgradeVisible) ? 'hidden' : (productDetailForm_module_default()).sticky_on_mobile),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (productDetailForm_module_default()).sticky_on_mobile_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (productDetailForm_module_default()).productStickyInfo,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (productDetailForm_module_default()).productStickyImage,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    src: selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod10 = selectedVariant.product) === null || _selectedVariant$prod10 === void 0 ? void 0 : (_selectedVariant$prod11 = _selectedVariant$prod10.thumbnail) === null || _selectedVariant$prod11 === void 0 ? void 0 : _selectedVariant$prod11.url,
                    width: 56,
                    height: 56
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (productDetailForm_module_default()).productStickyDetails,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (productDetailForm_module_default()).productStickyDetailsName,
                    children: selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod12 = selectedVariant.product) === null || _selectedVariant$prod12 === void 0 ? void 0 : _selectedVariant$prod12.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (productDetailForm_module_default()).productStickyDetailsOptions,
                    children: [selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$attr3 = selectedVariant.attributes[0]) === null || _selectedVariant$attr3 === void 0 ? void 0 : _selectedVariant$attr3.label, (productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.length) > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      onClick: function onClick() {
                        return handleScrollToOptions();
                      },
                      className: (productDetailForm_module_default()).productStickyEit,
                      children: "Edit"
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (productDetailForm_module_default()).stickyPrice,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (productDetailForm_module_default()).priceLabel,
                  children: "Starting from"
                }), function () {
                  if (selectedMonthlyInfo === '36' && bigMonthlyArray.length) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: (productDetailForm_module_default()).priceBold,
                        children: ["R", (0,helperServices/* numberFormat */.i8)(bigMonthlyArray[0].monthly_recurring)]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        children: ["PM x ", bigMonthlyArray[0].payment_terms_label]
                      })]
                    });
                  } else if (selectedMonthlyInfo === '48' && hugeMonthlyArray.length) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: (productDetailForm_module_default()).priceBold,
                        children: ["R", (0,helperServices/* numberFormat */.i8)(hugeMonthlyArray[0].monthly_recurring)]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        children: ["PM x ", hugeMonthlyArray[0].payment_terms_label]
                      })]
                    });
                  } else if (selectedMonthlyInfo === '24' && smallMonthlyArray.length) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: (productDetailForm_module_default()).priceBold,
                        children: ["R", (0,helperServices/* numberFormat */.i8)(smallMonthlyArray[0].monthly_recurring)]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        children: ["PM x ", smallMonthlyArray[0].payment_terms_label]
                      })]
                    });
                  }
                }()]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Button, {
                variant: "danger",
                className: "".concat((productDetailForm_module_default()).newButton, " ").concat(userLoggedIn && eligibleUpgradeList.length == 0 ? (productDetailForm_module_default()).disabled : (productDetailForm_module_default()).addToCartBtn, " upgrade-button"),
                block: true,
                onClick: function onClick() {
                  return handleUpgrade(getCTAText());
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Next:"
                }), " ", getCTAText()]
              })]
            })
          })
        })]
      })]
    }), buyOptionSku === labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option && recommendedPlans.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((productDetailForm_module_default()).specialOffersWrapper, " ").concat(selectedMonthlyInfo === '48' && recommendedPlans48.length === 0 ? 'hidden' : '', " ").concat(selectedMonthlyInfo === '24' && recommendedPlans24.length === 0 ? 'hidden' : '', " ").concat(selectedMonthlyInfo === '36' && recommendedPlans36.length === 0 ? 'hidden' : ''),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (productDetailForm_module_default()).specialOffersWrapperTitle,
        children: "Check out these special offers:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (productDetailForm_module_default()).carouselWrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((OwlCarousel_default()), {
          ref: function ref(c) {
            return productCarousel = c;
          },
          options: carouselOptions,
          children: recommendedPlans.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              "data-key": index,
              className: "".concat(index == 1 ? (productDetailForm_module_default()).carouselPlanSpecial : '', " ").concat((productDetailForm_module_default()).carouselPlan),
              children: [index === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (productDetailForm_module_default()).redHotDeal,
                children: "On Promotion"
              }) : '', index === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (productDetailForm_module_default()).lowestDeal,
                children: "Lowest price"
              }) : '', index === 2 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (productDetailForm_module_default()).betValue,
                children: "Best value for money"
              }) : '', index === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (productDetailForm_module_default()).packageWrapperPromotionElement
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (productDetailForm_module_default()).planInner,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (productDetailForm_module_default()).priceWrapper,
                  children: ["R", (0,helperServices/* numberFormat */.i8)(item.monthly_recurring), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: ["PM x ", item.payment_terms_label]
                  }), index == 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    className: "".concat(item.old_monthly_recurring ? 'block' : 'hidden', " ", ' min-h-[20px] leading-[20px] text-base font-inter-medium text-[#6D6F81] w-full'),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["Was R", (0,helperServices/* numberFormat */.i8)(item.old_monthly_recurring), " PM"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: (productDetailForm_module_default()).youSave,
                      children: ["You save R", item.old_monthly_recurring - item.monthly_recurring, "!"]
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (productDetailForm_module_default()).planOfferItems,
                  children: [(item === null || item === void 0 ? void 0 : item.airtime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (productDetailForm_module_default()).airtime,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
                      children: ["R", item === null || item === void 0 ? void 0 : item.airtime]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: "Airtime"
                    })]
                  }), (item === null || item === void 0 ? void 0 : item.promo_data) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (productDetailForm_module_default()).data,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                      children: (0,dealBuilderUtils/* formatPromoData */.j)(item === null || item === void 0 ? void 0 : item.promo_data)
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: "Data"
                    })]
                  }), (item === null || item === void 0 ? void 0 : item.minutes_label) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (productDetailForm_module_default()).minutes,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
                      children: [item === null || item === void 0 ? void 0 : item.minutes_label, " ", (item === null || item === void 0 ? void 0 : item.minutes_label) !== 'Unlimited' ? 'min' : '']
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: "Voice"
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  onClick: function onClick() {
                    return handleGetDeal(item.sku);
                  },
                  className: (productDetailForm_module_default()).getThisDeal,
                  children: "Get this deal"
                })]
              })]
            }, index);
          })
        })
      })]
    }) : '', showAffordModal && /*#__PURE__*/(0,jsx_runtime.jsx)(AffordabilityContainer/* default */.Z, {
      showModal: showAffordModal,
      resultCode: labels/* default.upgrade.errorCodes.code_product_not_affordable */.Z.upgrade.errorCodes.code_product_not_affordable,
      toggleModal: function toggleModal() {
        return setShowAffordModal(false);
      }
    })]
  });
};

var productDetailForm_mapStateToProps = function mapStateToProps(state) {
  return {
    showUpgradeModal: state.upgrade.showModal,
    upgradeCheckDone: state.upgrade.upgradeCheckDone,
    checkIsDealAffordable: state.upgrade.checkIsDealAffordable,
    creditFilters: state.upgrade.creditFilters,
    eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
    allUpgradeData: state.upgrade.allUpgradesData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    journeyStatus: state.upgrade.upgradeStatus
  };
};

/* harmony default export */ var productDetailForm = ((0,DependencyHelper.connect)(productDetailForm_mapStateToProps, {
  addBundleProductToGuestCart: cartAction/* addBundleProductToGuestCart */.HJ,
  addSimpleProductToGuestCart: cartAction/* addSimpleProductToGuestCart */.a1,
  addConfigurableToGuestCart: cartAction/* addConfigurableToGuestCart */.bc,
  syncUserProfile: userProfileAction/* syncUserProfile */.c,
  resetSyncUserProfile: userProfileAction/* resetSyncUserProfile */.h,
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  updateUpgradeRedirect: upgradeAction/* updateUpgradeRedirect */.z9,
  checkIfdealQualifies: upgradeAction/* checkIfdealQualifies */.RZ,
  updateJourneyStatus: upgradeAction/* updateJourneyStatus */.aI,
  updateSelectedData: upgradeAction/* updateSelectedData */.x$,
  setDevicePrice: upgradeAction/* setDevicePrice */.kb,
  fetchCreditFilters: upgradeAction/* fetchCreditFilters */.QV,
  updateUnmaskedMsisdn: upgradeAction/* updateUnmaskedMsisdn */.c7
})(ProductDetailForm));
// EXTERNAL MODULE: ./components/atoms/label/Label.jsx
var Label = __webpack_require__(63703);
// EXTERNAL MODULE: ./components/molecules/productDetailsPromotions/productDetailsPromotions.module.scss
var productDetailsPromotions_module = __webpack_require__(96421);
var productDetailsPromotions_module_default = /*#__PURE__*/__webpack_require__.n(productDetailsPromotions_module);
// EXTERNAL MODULE: ./components/atoms/linkRoute/LinkRoute.jsx
var LinkRoute = __webpack_require__(80286);
;// CONCATENATED MODULE: ./components/molecules/productDetailsPromotions/ProductDetailsPromotions.jsx













var ProductDetailsPromotions = function ProductDetailsPromotions(_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      tagText = _ref.tagText,
      description = _ref.description,
      isPromotionTagLink = _ref.isPromotionTagLink,
      promotionTag = _ref.promotionTag,
      uniquePromoId = _ref.uniquePromoId,
      descriptionTime = _ref.descriptionTime,
      promotionLink = _ref.promotionLink,
      flag = _ref.flag,
      labelColor = _ref.labelColor;

  var generateVariantStyle = function generateVariantStyle() {
    return variant ? (productDetailsPromotions_module_default())["promotion--" + variant] : "";
  };

  var isPreOrder = tagText == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? true : false; // For Filter with on the appropriate promotion on product list page

  var createPromotionFilter = function createPromotionFilter(value, label) {
    return value + ":" + label;
  };

  var env = (config_default()).env;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  return tagText || description || promotionLink ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
      uniqueLabelId: uniquePromoId,
      children: "Promotions:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((productDetailsPromotions_module_default()).promotion, " mt-s mb-l ").concat(generateVariantStyle()),
      children: [tagText && /*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
        className: "".concat((productDetailsPromotions_module_default()).promotion__tag),
        text: isPreOrder ? labels/* default.lbl_pre_order_online_exclusive_tag */.Z.lbl_pre_order_online_exclusive_tag : tagText,
        labelColor: labelColor
      }), isPromotionTagLink || promotionLink ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: promotionLink !== null && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkRoute/* default */.Z, {
            href: promotionLink ? (0,helperServices/* isExternalUrl */.xf)(promotionLink) ? "".concat(promotionLink) : "".concat(urlPrefix, "/").concat(promotionLink) : "".concat(urlPrefix, "/deals"),
            as: promotionLink ? null : "".concat(urlPrefix, "/deals?promotions=").concat(createPromotionFilter(promotionTag, variant)),
            text: isPreOrder ? "" : labels/* default.lbl_promotion_tag_link */.Z.lbl_promotion_tag_link,
            className: "".concat(isPreOrder ? "" : (productDetailsPromotions_module_default()).promotion__description__link)
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            children: ["\xA0", isPreOrder ? "" : labels/* default.lbl_promotion_tag_text */.Z.lbl_promotion_tag_text]
          })]
        })
      }) : !flag ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (productDetailsPromotions_module_default()).promotion__description,
        children: [description, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (productDetailsPromotions_module_default()).description_font,
          children: descriptionTime
        })]
      }) : ""]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {
      className: "d-none d-lg-block product-details-bottom-hr"
    })]
  }) : "";
};

ProductDetailsPromotions.defaultProps = {
  className: "",
  variant: "",
  promotionTag: ""
};
/* harmony default export */ var productDetailsPromotions_ProductDetailsPromotions = ((/* unused pure expression or super */ null && (ProductDetailsPromotions)));
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/vaimo/productDetailsBody/productDetailsBody.module.scss
var productDetailsBody_module = __webpack_require__(34149);
var productDetailsBody_module_default = /*#__PURE__*/__webpack_require__.n(productDetailsBody_module);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./components/atoms/tag/Tag.jsx
var Tag = __webpack_require__(4648);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/vaimo/productDetailsBody/ProductDetailsBody.jsx



function ProductDetailsBody_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductDetailsBody_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductDetailsBody_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductDetailsBody_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





















var ProductDetailsBody_env = (config_default()).env;
var urlPrefix = (config_default()).envConfigs[ProductDetailsBody_env].shoppingUrlPrefix;
var ProductDetailsBody_imagePrefix = (config_default()).envConfigs[ProductDetailsBody_env].imagePrefix;





var ProductDetailsBody = function ProductDetailsBody(_ref) {
  var _selectedVariant$prod20, _selectedVariant$prod21, _productDetails$promo3;

  var productDetails = _ref.productDetails,
      defaultVariant = _ref.defaultVariant,
      selectedVariant = _ref.selectedVariant,
      getVariant = _ref.getVariant,
      buyOptions = _ref.buyOptions,
      buyOptionTitle = _ref.buyOptionTitle,
      getBuyOptionType = _ref.getBuyOptionType,
      buyOptionId = _ref.buyOptionId,
      optList = _ref.optList,
      upgradeChecksEnabled = _ref.upgradeChecksEnabled,
      triggerCallback = _ref.triggerCallback,
      showSnackBarEvent = _ref.showSnackBarEvent,
      closeSnackBarEvent = _ref.closeSnackBarEvent,
      isEligible = _ref.isEligible,
      showModal = _ref.showModal,
      geoLocationIsAllowed = _ref.geoLocationIsAllowed,
      nearestStore = _ref.nearestStore,
      isStoreStockServiceDown = _ref.isStoreStockServiceDown,
      brand = _ref.brand,
      brandId = _ref.brandId;

  var _useState = (0,react.useState)([]),
      products = _useState[0],
      setProducts = _useState[1];

  var _useState2 = (0,react.useState)([]),
      rvProducts = _useState2[0],
      setRVProducts = _useState2[1]; //handle recently viewed products


  var _useState3 = (0,react.useState)(optList),
      optListCopy = _useState3[0],
      setOptListCopy = _useState3[1];

  var _useState4 = (0,react.useState)(optList),
      optListCopyForDeal = _useState4[0],
      setOptListCopyForDeal = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      listData = _useState5[0],
      setList = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      filterVariantsData = _useState6[0],
      setFilterVariantsData = _useState6[1];

  var _useState7 = (0,react.useState)(),
      isStock = _useState7[0],
      setIsStock = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      shareTooltip = _useState8[0],
      setShareTooltip = _useState8[1];

  var _useState9 = (0,react.useState)('Copy Link'),
      shareLabel = _useState9[0],
      setShareLabel = _useState9[1];

  var _useState10 = (0,react.useState)(null),
      selectedOptions = _useState10[0],
      setSelectedOptions = _useState10[1];

  var _useState11 = (0,react.useState)(""),
      buyOption = _useState11[0],
      setBuyOption = _useState11[1];

  var _useState12 = (0,react.useState)(""),
      buyOptionSku = _useState12[0],
      setBuyOptionSku = _useState12[1];

  var _useState13 = (0,react.useState)(""),
      buyOptionTypeId = _useState13[0],
      setBuyOptionTypeId = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      checkforId = _useState14[0],
      setCheckForId = _useState14[1];

  var _useState15 = (0,react.useState)(""),
      promotionAnalytics = _useState15[0],
      setPromotionAnalytics = _useState15[1];

  var _useState16 = (0,react.useState)(false),
      videoModalOpened = _useState16[0],
      setVideoModalOpened = _useState16[1];

  var handleSelectedOption = function handleSelectedOption(value) {
    setSelectedOptions(value);
  };

  (0,react.useEffect)(function () {
    getBuyOptionType(buyOptionSku);
  }, [buyOptionSku]);
  (0,react.useEffect)(function () {
    if (productDetails && productDetails.configurable_options && buyOptionSku === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option) {
      setFilterVariantsData([]);
      var optListData = optListOptions(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options);

      if (optListData) {
        var initialObject = Object.values(optListData)[0];

        if (initialObject) {
          var _Object$values$, _Object$values$$;

          updateAttributes(Object.keys(initialObject)[0], (_Object$values$ = Object.values(initialObject)[0]) === null || _Object$values$ === void 0 ? void 0 : (_Object$values$$ = _Object$values$[0]) === null || _Object$values$$ === void 0 ? void 0 : _Object$values$$.label, optListData);
        }

        var rObj = {};
        optListData === null || optListData === void 0 ? void 0 : optListData.forEach(function (obj) {
          var _a$;

          var a = Object.values(obj)[0];
          rObj[Object.keys(obj)] = (_a$ = a[0]) === null || _a$ === void 0 ? void 0 : _a$.label;
        });
        handleSelectedOption(rObj);
      }
    }

    if (productDetails && productDetails.configurable_options && buyOptionSku !== labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option) {
      setFilterVariantsData([]);
      var dealProductId = productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_data.map(function (deal) {
        return deal === null || deal === void 0 ? void 0 : deal.product_id;
      });
      var variantId = productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.map(function (variant) {
        var _variant$product;

        return variant === null || variant === void 0 ? void 0 : (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.id;
      });

      var _checkforId = dealProductId.every(function (e) {
        return variantId.includes(e);
      }) && variantId.every(function (e) {
        return dealProductId.includes(e);
      });

      if (_checkforId) {
        var _optListData = optListOptions(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options);

        var _initialObject = Object.values(_optListData)[0];

        if (_initialObject) {
          var _Object$values$2, _Object$values$2$;

          updateAttributes(Object.keys(_initialObject)[0], (_Object$values$2 = Object.values(_initialObject)[0]) === null || _Object$values$2 === void 0 ? void 0 : (_Object$values$2$ = _Object$values$2[0]) === null || _Object$values$2$ === void 0 ? void 0 : _Object$values$2$.label, _optListData);
        }

        var _rObj = {};
        _optListData === null || _optListData === void 0 ? void 0 : _optListData.forEach(function (obj) {
          var _a$2;

          var a = Object.values(obj)[0];
          _rObj[Object.keys(obj)] = (_a$2 = a[0]) === null || _a$2 === void 0 ? void 0 : _a$2.label;
        });
        handleSelectedOption(_rObj);
        setCheckForId(_checkforId);
      } else {
        var filterVariants = productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.filter(function (variant) {
          return productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_data.some(function (deal) {
            var _variant$product2;

            return (variant === null || variant === void 0 ? void 0 : (_variant$product2 = variant.product) === null || _variant$product2 === void 0 ? void 0 : _variant$product2.id) === deal.product_id;
          });
        });
        setFilterVariantsData(filterVariants);
        var attrList = [];

        var configValues = function configValues(attrCode, label) {
          var valObj = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options.find(function (configOption) {
            return attrCode === configOption.attribute_code;
          });
          return valObj.values.find(function (val) {
            return val.label === label;
          });
        };

        var _iterator = _createForOfIteratorHelper(filterVariants),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var filterVariant = _step.value;

            var _iterator2 = _createForOfIteratorHelper(filterVariant.attributes),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var attr = _step2.value;
                attrList.push(configValues(attr.code, attr.label));
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var list = [];

        if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable) {
          var productData;

          try {
            var _productDetails$confi, _productDetails$confi2, _productDetails$confi3, _productDetails$confi4;

            // window.outerWidth <= MOBILE_WIDTH
            if ((productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$confi = productDetails.configurable_options) === null || _productDetails$confi === void 0 ? void 0 : (_productDetails$confi2 = _productDetails$confi[1]) === null || _productDetails$confi2 === void 0 ? void 0 : _productDetails$confi2.position) > (productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$confi3 = productDetails.configurable_options) === null || _productDetails$confi3 === void 0 ? void 0 : (_productDetails$confi4 = _productDetails$confi3[0]) === null || _productDetails$confi4 === void 0 ? void 0 : _productDetails$confi4.position)) {
              productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options.sort(function (a, b) {
                return b.position - a.position;
              });
            } else {
              productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options;
            }
          } catch (error) {
            productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options;
          }

          var optionsList = (0,helperServices/* configurableOptions */.Lv)(productData);
          optionsList.forEach(function (option) {
            var opt = (0,helperServices/* options */.YM)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options, option);
            var filterVariants = opt.filter(function (opt) {
              return attrList.some(function (att) {
                return opt.label === att.label;
              });
            });
            var some = {};
            some[option] = filterVariants;
            list.push(some);
          });
        }

        setList(list);
        var _initialObject2 = Object.values(list)[0];

        if (_initialObject2) {
          var _Object$values$3, _Object$values$3$;

          updateAttributes(Object.keys(_initialObject2)[0], (_Object$values$3 = Object.values(_initialObject2)[0]) === null || _Object$values$3 === void 0 ? void 0 : (_Object$values$3$ = _Object$values$3[0]) === null || _Object$values$3$ === void 0 ? void 0 : _Object$values$3$.label, list);
        }

        var _rObj2 = {};
        list === null || list === void 0 ? void 0 : list.forEach(function (obj) {
          var _a$3;

          var a = Object.values(obj)[0];
          _rObj2[Object.keys(obj)] = (_a$3 = a[0]) === null || _a$3 === void 0 ? void 0 : _a$3.label;
        });
        handleSelectedOption(_rObj2);
      }
    }
  }, [productDetails, buyOptionSku, optList]);

  var handleOptionClick1 = function handleOptionClick1(code, label, optLists) {
    var newOption = {};

    if (optLists.map(function (opt) {
      return Object.keys(opt)[0];
    })[0] == code) {
      updateAttributes(code, label, optLists);
    }

    newOption[code[0]] = label;
    optLists.forEach(function (list) {
      if (Object.keys(list)[0] != code) {
        var filteredValues = Object.values(list)[0].map(function (elabel) {
          return elabel.label;
        });
        var selectedColorValue = filteredValues.filter(function (item) {
          return item == selectedOptions.color;
        });
        var selectedFilteredValue = filteredValues.filter(function (item) {
          return item == (selectedOptions.internal_storage || selectedOptions.screen_size_pixels);
        });
        newOption[Object.keys(list)[0]] = code != "color" ? selectedColorValue[0] : selectedFilteredValue && selectedFilteredValue.length ? selectedFilteredValue[0] : filteredValues[0];

        if (filteredValues.indexOf(selectedOptions[Object.keys(list)[0]]) === -1) {
          newOption[Object.keys(list)[0]] = filteredValues[0];
        }
      }
    });
    setSelectedOptions(newOption);
  };

  var updateAttributes = function updateAttributes(code, label, optionsList) {
    var list = [];
    var filterVariantData = [];
    var attrList = []; // when deal data and varient data is different implementation

    if (buyOptionSku !== labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option && checkforId !== true && buyOptionSku !== "") {
      filterVariantData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.filter(function (variant) {
        return productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_data.some(function (deal) {
          var _variant$product3;

          return (variant === null || variant === void 0 ? void 0 : (_variant$product3 = variant.product) === null || _variant$product3 === void 0 ? void 0 : _variant$product3.id) === deal.product_id;
        });
      });

      var configValues = function configValues(attrCode, label) {
        var valObj = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options.find(function (configOption) {
          return attrCode === configOption.attribute_code;
        });
        return valObj.values.find(function (val) {
          return val.label === label;
        });
      };

      var _iterator3 = _createForOfIteratorHelper(filterVariantData),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var filterVariant = _step3.value;

          var _iterator4 = _createForOfIteratorHelper(filterVariant.attributes),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var attr = _step4.value;
              attrList.push(configValues(attr.code, attr.label));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable) {
        var productData;

        try {
          var _productDetails$confi5, _productDetails$confi6, _productDetails$confi7, _productDetails$confi8;

          // window.outerWidth <= MOBILE_WIDTH
          if ((productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$confi5 = productDetails.configurable_options) === null || _productDetails$confi5 === void 0 ? void 0 : (_productDetails$confi6 = _productDetails$confi5[1]) === null || _productDetails$confi6 === void 0 ? void 0 : _productDetails$confi6.position) > (productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$confi7 = productDetails.configurable_options) === null || _productDetails$confi7 === void 0 ? void 0 : (_productDetails$confi8 = _productDetails$confi7[0]) === null || _productDetails$confi8 === void 0 ? void 0 : _productDetails$confi8.position)) {
            productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options.sort(function (a, b) {
              return b.position - a.position;
            });
          } else {
            productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options;
          }
        } catch (error) {
          productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options;
        }

        var _optionsList = (0,helperServices/* configurableOptions */.Lv)(productData);

        _optionsList.forEach(function (option) {
          var opt = (0,helperServices/* options */.YM)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options, option);
          var filterVariants = opt.filter(function (opt) {
            return attrList.some(function (att) {
              return opt.label === att.label;
            });
          });
          var some = {};
          some[option] = filterVariants;
          list.push(some);
        });
      }
    } // TODO: Clean up - remove for each


    var filteredVariantValue = [];

    if (buyOptionSku === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option || checkforId === true) {
      productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.forEach(function (variant) {
        variant.attributes.forEach(function (attr) {
          if (attr.code == code && attr.label == label) {
            filteredVariantValue.push(variant);
          }
        });
      });
    } else {
      filterVariantData.forEach(function (variant) {
        variant.attributes.forEach(function (attr) {
          if (attr.code == code && attr.label == label) {
            filteredVariantValue.push(variant);
          }
        });
      });
    }

    var optValuesAtVariantLevel = filteredVariantValue.reduce(function (acc, item) {
      return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(item.attributes.filter(function (variant) {
        return variant.code !== code;
      })));
    }, []);
    filteredVariantValue.forEach(function (filteredVariant) {
      filteredVariant === null || filteredVariant === void 0 ? void 0 : filteredVariant.attributes.forEach(function (variant) {
        if (variant.code != code) {
          // 1st: fetch all values of matched variant code from optList
          var optionData = [];

          if (filterVariantData.length > 0 && buyOptionSku !== labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option && buyOptionSku !== "") {
            optionData = list && list.length > 0 ? list : _optionsList2;
          } else {
            optionData = optListOptions(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options);
          }

          var getVariantCodeAtOpt = optionData.filter(function (opt) {
            return Object.keys(opt)[0] === variant.code;
          });
          var optListFilterValuesByCode = Object.values(getVariantCodeAtOpt[0])[0]; // 2nd: Get filtered varaints for selected option
          // let optValuesAtVariantLevel = filteredVariant.attributes.filter(
          //   (d) => d.code == variant.code
          // );
          // 3rd: Compare with optValuesAtVariantLevel, Remove not matched varaints from optListFilterValuesByCode

          var newShallowOFVaraint = [];
          optListFilterValuesByCode.forEach(function (val) {
            var filteredVariantOutput = optValuesAtVariantLevel.filter(function (variant) {
              return variant.label == val.label;
            });

            if (filteredVariantOutput.length) {
              newShallowOFVaraint.push(val);
            }
          }); // 4th: Update required object of OptList with final filtered data

          var objects = optListOptions(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options);
          var _optionsList2 = [];

          if (filterVariantData.length > 0 && buyOptionSku !== labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option && buyOptionSku !== "") {
            _optionsList2 = list && list.length > 0 ? list : _optionsList2;
          } else {
            _optionsList2 = objects && objects.length > 0 ? objects : _optionsList2;
          }

          _optionsList2.map(function (copy) {
            if (Object.keys(copy)[0] == variant.code) {
              return copy[Object.keys(copy)[0]] = newShallowOFVaraint;
            }
          });

          setOptListCopy(_optionsList2);
          setOptListCopyForDeal(_optionsList2);
        } else {
          setOptListCopy(optionsList);
          setOptListCopyForDeal(optionsList);
        }
      });
    });
  };

  var optListOptions = function optListOptions(value) {
    if (!(value !== null && value !== void 0 && value.length)) {
      return [];
    }

    var arrValue;

    try {
      var _value$, _value$2;

      // window.outerWidth <= MOBILE_WIDTH
      if ((value === null || value === void 0 ? void 0 : (_value$ = value[1]) === null || _value$ === void 0 ? void 0 : _value$.position) > (value === null || value === void 0 ? void 0 : (_value$2 = value[0]) === null || _value$2 === void 0 ? void 0 : _value$2.position)) {
        arrValue = value.sort(function (a, b) {
          return b.position - a.position;
        });
      } else {
        arrValue = value;
      }
    } catch (error) {
      arrValue = value;
    }

    return (0,helperServices/* configurableOptions */.Lv)(arrValue).map(function (option, index) {
      return (0,defineProperty/* default */.Z)({}, option, (0,helperServices/* options */.YM)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options, option));
    });
  };

  var handleSelectedBuyOption = function handleSelectedBuyOption(value) {
    var _productDetails$categ;

    if (buyOptionSku === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option || checkforId === true) {
      var objects = optListOptions(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options);
      var initialObject = Object.values(objects)[0];

      if (initialObject) {
        var _Object$values$4, _Object$values$4$;

        updateAttributes(Object.keys(initialObject)[0], (_Object$values$4 = Object.values(initialObject)[0]) === null || _Object$values$4 === void 0 ? void 0 : (_Object$values$4$ = _Object$values$4[0]) === null || _Object$values$4$ === void 0 ? void 0 : _Object$values$4$.label, objects);
      }

      var rObj = {};
      objects === null || objects === void 0 ? void 0 : objects.forEach(function (obj) {
        var _a$4;

        var a = Object.values(obj)[0];
        rObj[Object.keys(obj)] = (_a$4 = a[0]) === null || _a$4 === void 0 ? void 0 : _a$4.label;
      });
      handleSelectedOption(rObj);
    } else {
      var productVariants = (productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants) || [];
      var filterVariants = productVariants.filter(function (variant) {
        return productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_data.some(function (deal) {
          var _variant$product4;

          return (variant === null || variant === void 0 ? void 0 : (_variant$product4 = variant.product) === null || _variant$product4 === void 0 ? void 0 : _variant$product4.id) === deal.product_id;
        });
      });
      var attrList = [];

      var configValues = function configValues(attrCode, label) {
        var valObj = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options.find(function (configOption) {
          return attrCode === configOption.attribute_code;
        });
        return valObj.values.find(function (val) {
          return val.label === label;
        });
      };

      var _iterator5 = _createForOfIteratorHelper(filterVariants),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var filterVariant = _step5.value;

          var _iterator6 = _createForOfIteratorHelper(filterVariant.attributes),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var attr = _step6.value;
              attrList.push(configValues(attr.code, attr.label));
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var list = [];

      if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable) {
        var productData;

        try {
          var _productDetails$confi9, _productDetails$confi10, _productDetails$confi11, _productDetails$confi12;

          // window.outerWidth <= MOBILE_WIDTH
          if ((productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$confi9 = productDetails.configurable_options) === null || _productDetails$confi9 === void 0 ? void 0 : (_productDetails$confi10 = _productDetails$confi9[1]) === null || _productDetails$confi10 === void 0 ? void 0 : _productDetails$confi10.position) > (productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$confi11 = productDetails.configurable_options) === null || _productDetails$confi11 === void 0 ? void 0 : (_productDetails$confi12 = _productDetails$confi11[0]) === null || _productDetails$confi12 === void 0 ? void 0 : _productDetails$confi12.position)) {
            productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options.sort(function (a, b) {
              return b.position - a.position;
            });
          } else {
            productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options;
          }
        } catch (error) {
          productData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options;
        }

        var optionsList = (0,helperServices/* configurableOptions */.Lv)(productData);
        optionsList.forEach(function (option) {
          var opt = (0,helperServices/* options */.YM)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options, option);
          var filterVariants = opt.filter(function (opt) {
            return attrList.some(function (att) {
              return opt.label === att.label;
            });
          });
          var some = {};
          some[option] = filterVariants;
          list.push(some);
        });
      }

      var _initialObject3 = Object.values(list)[0];

      if (_initialObject3) {
        var _Object$values$5, _Object$values$5$;

        updateAttributes(Object.keys(_initialObject3)[0], (_Object$values$5 = Object.values(_initialObject3)[0]) === null || _Object$values$5 === void 0 ? void 0 : (_Object$values$5$ = _Object$values$5[0]) === null || _Object$values$5$ === void 0 ? void 0 : _Object$values$5$.label, list);
      }

      var _rObj3 = {};
      list === null || list === void 0 ? void 0 : list.forEach(function (obj) {
        var _a$5;

        var a = Object.values(obj)[0];
        _rObj3[Object.keys(obj)] = (_a$5 = a[0]) === null || _a$5 === void 0 ? void 0 : _a$5.label;
      });
      handleSelectedOption(_rObj3);
    }

    var matchedSku = buyOptions.filter(function (option) {
      return option.title === value;
    });
    var optionSku = matchedSku.length ? matchedSku[0].sku : buyOptionSku;
    getBuyOptionType(optionSku);
    setBuyOption(value);
    setBuyOptionSku(optionSku);
    setBuyOptionTypeId(matchedSku.length ? matchedSku[0].option_type_id : buyOptionTypeId);
    analyticsUtag/* link */.p4(ProductDetailsBody_objectSpread(ProductDetailsBody_objectSpread(ProductDetailsBody_objectSpread({}, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type"])), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: devices: product details: contract type filter",
      filter_query: value,
      page_name: "shopping: devices: product details",
      sales_product_category: [productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$categ = productDetails.categories[0]) === null || _productDetails$categ === void 0 ? void 0 : _productDetails$categ.name],
      sales_product_id: [productDetails === null || productDetails === void 0 ? void 0 : productDetails.name],
      sales_promo_name: [productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label]
    }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type"])), {}, {
      page_site_section_lvl_1: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.name),
      page_site_section_lvl_2: "All products",
      page_site_section_lvl_3: "Home"
    }));
  };

  var setCookieProducts = function setCookieProducts() {
    var cookieValue, parsedCookie;
    cookieValue = DependencyHelper.Cookie.get("products");

    if (cookieValue) {
      parsedCookie = JSON.parse(cookieValue);
    }

    if (!productDetails) {
      setProducts((0,toConsumableArray/* default */.Z)(parsedCookie));
      return;
    }

    if (parsedCookie && parsedCookie.length === 4 && parsedCookie.every(function (product) {
      return product.sku !== productDetails.sku;
    })) {
      parsedCookie.pop();
    }

    if (!cookieValue || parsedCookie.length === 0) {
      setProducts([productDetails]);
    }

    if (parsedCookie && parsedCookie.length > 0) {
      var productInCookie = parsedCookie.some(function (product) {
        return product.sku === productDetails.sku;
      });
      var product = parsedCookie.find(function (cookieProduct) {
        return cookieProduct.sku === productDetails.sku;
      });
      var otherCookie = parsedCookie.filter(function (cookieProduct) {
        return cookieProduct.sku !== productDetails.sku;
      });
      productInCookie ? setProducts([Object.assign(product, productDetails)].concat((0,toConsumableArray/* default */.Z)(otherCookie))) : setProducts([productDetails].concat((0,toConsumableArray/* default */.Z)(parsedCookie)));
    }
  };

  var setCookieRecentlyViewedProducts = function setCookieRecentlyViewedProducts() {
    var cookieValue, parsedCookie;
    cookieValue = DependencyHelper.Cookie.get("rv_products");

    if (cookieValue) {
      parsedCookie = JSON.parse(cookieValue);
    }

    if (!productDetails) {
      setRVProducts((0,toConsumableArray/* default */.Z)(parsedCookie));
      return;
    }

    if (parsedCookie && parsedCookie.length === 4 && parsedCookie.every(function (product) {
      return product.sku !== productDetails.sku;
    })) {
      parsedCookie.pop();
    }

    if (!cookieValue || parsedCookie.length === 0) {
      setRVProducts([productDetails]);
    }

    if (parsedCookie && parsedCookie.length > 0) {
      var productInCookie = parsedCookie.some(function (product) {
        return product.sku === productDetails.sku;
      });
      var product = parsedCookie.find(function (cookieProduct) {
        return cookieProduct.sku === productDetails.sku;
      });
      var otherCookie = parsedCookie.filter(function (cookieProduct) {
        return cookieProduct.sku !== productDetails.sku;
      });
      productInCookie ? setRVProducts([Object.assign(product, productDetails)].concat((0,toConsumableArray/* default */.Z)(otherCookie))) : setRVProducts([productDetails].concat((0,toConsumableArray/* default */.Z)(parsedCookie)));
    }
  };

  (0,react.useEffect)(function () {
    if (products && products.length) {
      var productCookie = products.map(function (product) {
        var variantConfig;
        var obj = {
          sku: product.sku
        };

        if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && selectedVariant && product.sku === productDetails.sku) {
          obj.variantConfig = ProductDetailsBody_objectSpread(ProductDetailsBody_objectSpread({}, selectedOptions), {}, {
            sku: productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku
          });
        } else {
          variantConfig = product && product.variantConfig ? product.variantConfig : null;
          obj.variantConfig = variantConfig;
        }

        return obj;
      });
      (0,helperServices/* setCookieConsentWrapper */.ol)("products_cookie", [config.cookie_category.strictly_necessary], "document.cookie='products=".concat(encodeURIComponent(JSON.stringify(productCookie).replace(/'/g, "\\'")), ";path=/'"));
    }
  }, [products]);
  (0,react.useEffect)(function () {
    if (rvProducts && rvProducts.length) {
      var productCookie = products.map(function (product) {
        var variantConfig;
        var obj = {
          sku: product.sku
        };

        if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && selectedVariant && product.sku === productDetails.sku) {
          obj.variantConfig = ProductDetailsBody_objectSpread(ProductDetailsBody_objectSpread({}, selectedOptions), {}, {
            sku: productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku
          });
        } else {
          variantConfig = product && product.variantConfig ? product.variantConfig : null;
          obj.variantConfig = variantConfig;
        }

        return obj;
      });
      (0,helperServices/* setCookieConsentWrapper */.ol)("products_rv_cookie", [config.cookie_category.strictly_necessary], "document.cookie='rv_products=".concat(encodeURIComponent(JSON.stringify(productCookie).replace(/'/g, "\\'")), ";path=/'"));
    }
  }, [rvProducts]);

  var getProductforBadge = function getProductforBadge() {
    if (selectedVariant) {
      return selectedVariant.product;
    }

    if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle) {
      var _productDetails$items, _productDetails$items2;

      return productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$items = productDetails.items[0]) === null || _productDetails$items === void 0 ? void 0 : (_productDetails$items2 = _productDetails$items.options[0]) === null || _productDetails$items2 === void 0 ? void 0 : _productDetails$items2.product;
    }

    if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple) {
      return productDetails;
    }
  }; // refactoring to stateless component


  var isConfigurable = function isConfigurable(productDetails) {
    var _productDetails$confi13;

    return productDetails.__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && (productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$confi13 = productDetails.configurable_options) === null || _productDetails$confi13 === void 0 ? void 0 : _productDetails$confi13.length) > 0;
  };

  var getPromoInfo = function getPromoInfo() {
    // check if has variants
    var promoData = {};

    if (isConfigurable(productDetails)) {
      var _selectedVariant$prod, _selectedVariant$prod2, _selectedVariant$prod3, _selectedVariant$prod4, _selectedVariant$prod5, _selectedVariant$prod6, _selectedVariant$prod7, _selectedVariant$prod8, _selectedVariant$prod9, _selectedVariant$prod10, _selectedVariant$prod11, _productDetails$promo, _selectedVariant$prod12, _selectedVariant$prod13;

      setPromotionAnalytics(selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod = selectedVariant.product) === null || _selectedVariant$prod === void 0 ? void 0 : _selectedVariant$prod.badges_label);
      promoData.promoTag = selectedVariant !== null && selectedVariant !== void 0 && (_selectedVariant$prod2 = selectedVariant.product) !== null && _selectedVariant$prod2 !== void 0 && _selectedVariant$prod2.badges_label ? selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod3 = selectedVariant.product) === null || _selectedVariant$prod3 === void 0 ? void 0 : _selectedVariant$prod3.badges_label : productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label;
      promoData.promotionLink = selectedVariant !== null && selectedVariant !== void 0 && (_selectedVariant$prod4 = selectedVariant.product) !== null && _selectedVariant$prod4 !== void 0 && _selectedVariant$prod4.promotion_link ? selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod5 = selectedVariant.product) === null || _selectedVariant$prod5 === void 0 ? void 0 : _selectedVariant$prod5.promotion_link : productDetails === null || productDetails === void 0 ? void 0 : productDetails.promotion_link;
      promoData.promoId = selectedVariant !== null && selectedVariant !== void 0 && (_selectedVariant$prod6 = selectedVariant.product) !== null && _selectedVariant$prod6 !== void 0 && _selectedVariant$prod6.badges ? selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod7 = selectedVariant.product) === null || _selectedVariant$prod7 === void 0 ? void 0 : _selectedVariant$prod7.badges : productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges;
      promoData.promoEndDate = selectedVariant !== null && selectedVariant !== void 0 && (_selectedVariant$prod8 = selectedVariant.product) !== null && _selectedVariant$prod8 !== void 0 && (_selectedVariant$prod9 = _selectedVariant$prod8.promotions) !== null && _selectedVariant$prod9 !== void 0 && _selectedVariant$prod9.end_date ? selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod10 = selectedVariant.product) === null || _selectedVariant$prod10 === void 0 ? void 0 : (_selectedVariant$prod11 = _selectedVariant$prod10.promotions) === null || _selectedVariant$prod11 === void 0 ? void 0 : _selectedVariant$prod11.end_date : productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$promo = productDetails.promotions) === null || _productDetails$promo === void 0 ? void 0 : _productDetails$promo.end_date;
      promoData.promoTagColor = selectedVariant !== null && selectedVariant !== void 0 && (_selectedVariant$prod12 = selectedVariant.product) !== null && _selectedVariant$prod12 !== void 0 && _selectedVariant$prod12.badges_swatch ? selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod13 = selectedVariant.product) === null || _selectedVariant$prod13 === void 0 ? void 0 : _selectedVariant$prod13.badges_swatch : productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_swatch;
    } else {
      var _productDetails$promo2;

      setPromotionAnalytics(productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label);
      promoData.promoTag = productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label;
      promoData.promotionLink = productDetails === null || productDetails === void 0 ? void 0 : productDetails.promotion_link;
      promoData.promoId = productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges;
      promoData.promoEndDate = productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$promo2 = productDetails.promotions) === null || _productDetails$promo2 === void 0 ? void 0 : _productDetails$promo2.end_date;
      promoData.promoTagColor = productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_swatch;
    }

    return promoData;
  };

  var getAmounts = function getAmounts() {
    var amountData = {};

    if (isConfigurable(productDetails)) {
      var _selectedVariant$prod14;

      amountData.currentPrice = selectedVariant ? (0,helperServices/* getNestedObjectValue */.R3)(selectedVariant, ["product", "price_range", "maximum_price", "final_price", "value"]) : null;
      amountData.oldPrice = selectedVariant ? (0,helperServices/* getNestedObjectValue */.R3)(selectedVariant, ["product", "price_range", "maximum_price", "regular_price", "value"]) : null;
      amountData.discount = selectedVariant ? (0,helperServices/* getNestedObjectValue */.R3)(selectedVariant, ["product", "price_range", "maximum_price", "discount", "amount_off"]) : null;
      var variantId = selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod14 = selectedVariant.product) === null || _selectedVariant$prod14 === void 0 ? void 0 : _selectedVariant$prod14.id;
      var variantDealData = productDetails === null || productDetails === void 0 ? void 0 : productDetails.deal_data.filter(function (obj) {
        return obj.product_id === variantId;
      });

      if (variantDealData.length > 0) {
        var _variantDealData$, _variantDealData$2;

        amountData.variantDealPrice = Math.round((_variantDealData$ = variantDealData[0]) === null || _variantDealData$ === void 0 ? void 0 : _variantDealData$.min_price);
        amountData.variantDeviceInstallment = Math.round((_variantDealData$2 = variantDealData[0]) === null || _variantDealData$2 === void 0 ? void 0 : _variantDealData$2.deal_installment);
      }
    } else {
      var _productDetails$deal_, _productDetails$deal_2;

      amountData.currentPrice = Math.round((0,helperServices/* getNestedObjectValue */.R3)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.price_range, ["maximum_price", "final_price", "value"]));
      amountData.oldPrice = Math.round((0,helperServices/* getNestedObjectValue */.R3)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.price_range, ["maximum_price", "regular_price", "value"]));
      amountData.discount = Math.round((0,helperServices/* getNestedObjectValue */.R3)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.price_range, ["maximum_price", "discount", "amount_off"]));
      amountData.variantDealPrice = Math.round(productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$deal_ = productDetails.deal_data[0]) === null || _productDetails$deal_ === void 0 ? void 0 : _productDetails$deal_.min_price);
      amountData.variantDeviceInstallment = Math.round(productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$deal_2 = productDetails.deal_data[0]) === null || _productDetails$deal_2 === void 0 ? void 0 : _productDetails$deal_2.deal_installment);
    }

    return amountData;
  };

  var showDiscountTimer = function showDiscountTimer() {
    if (isConfigurable(productDetails)) {
      var _selectedVariant$prod15;

      return (0,helperServices/* isDiscountTimerApplicable */.iw)(selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod15 = selectedVariant.product) === null || _selectedVariant$prod15 === void 0 ? void 0 : _selectedVariant$prod15.promotions);
    } else {
      return (0,helperServices/* isDiscountTimerApplicable */.iw)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.promotions);
    }
  };

  var getMediaGallery = function getMediaGallery() {
    var mediaGallery = [];

    if (isConfigurable(productDetails)) {
      var _selectedVariant$prod16, _selectedVariant$prod17, _selectedVariant$prod18;

      mediaGallery = selectedVariant && (selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod16 = selectedVariant.product) === null || _selectedVariant$prod16 === void 0 ? void 0 : (_selectedVariant$prod17 = _selectedVariant$prod16.media_gallery) === null || _selectedVariant$prod17 === void 0 ? void 0 : _selectedVariant$prod17.length) > 0 ? selectedVariant.product.media_gallery.sort(function (image1, image2) {
        return (image1 === null || image1 === void 0 ? void 0 : image1.position) - (image2 === null || image2 === void 0 ? void 0 : image2.position);
      }).slice(0, 8) : selectedVariant !== null && selectedVariant !== void 0 && (_selectedVariant$prod18 = selectedVariant.product) !== null && _selectedVariant$prod18 !== void 0 && _selectedVariant$prod18.image ? [selectedVariant.product.image] : [];
    } else {
      mediaGallery = productDetails && productDetails.media_gallery.length > 0 ? productDetails.media_gallery.sort(function (image1, image2) {
        return (image1 === null || image1 === void 0 ? void 0 : image1.position) - (image2 === null || image2 === void 0 ? void 0 : image2.position);
      }).slice(0, 8) : productDetails !== null && productDetails !== void 0 && productDetails.image ? [productDetails.image] : [];
    }

    return mediaGallery;
  };

  var renderDeliveryReturn = function renderDeliveryReturn() {
    var showConfigurable = (selectedVariant || defaultVariant) && (productDetails === null || productDetails === void 0 ? void 0 : productDetails["__typename"]) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable;
    var showSimple = (productDetails === null || productDetails === void 0 ? void 0 : productDetails["__typename"]) === labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple;
    var toRender = false;
    var content = '';

    if (showConfigurable) {
      var _selectedVariant$prod19;

      toRender = true;
      content = selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod19 = selectedVariant.product) === null || _selectedVariant$prod19 === void 0 ? void 0 : _selectedVariant$prod19.delivery_and_return;
    }

    if (showSimple) {
      toRender = true;
      content = productDetails === null || productDetails === void 0 ? void 0 : productDetails.delivery_and_return;
    }

    return toRender && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (productDetailsBody_module_default()).deliveryOption,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      })
    });
  };

  var _useState17 = (0,react.useState)({
    promoTag: "",
    promoId: "",
    promotionLink: "",
    promoEndDate: null,
    mediaGallery: [],
    displayDiscountTimer: null,
    showShopCheck: false
  }),
      bodyState = _useState17[0],
      setBodyState = _useState17[1];

  var router = (0,DependencyHelper.useRouter)();

  var setDefaultBuyOption = function setDefaultBuyOption(optionSku) {
    var _buyOptions$optionInd, _buyOptions$optionInd2, _buyOptions$optionInd3, _buyOptions$optionInd4;

    var optionIndex = buyOptions === null || buyOptions === void 0 ? void 0 : buyOptions.findIndex(function (option) {
      return option.sku.includes(optionSku);
    });
    getBuyOptionType(buyOptions === null || buyOptions === void 0 ? void 0 : (_buyOptions$optionInd = buyOptions[optionIndex]) === null || _buyOptions$optionInd === void 0 ? void 0 : _buyOptions$optionInd.sku);
    setBuyOption(buyOptions === null || buyOptions === void 0 ? void 0 : (_buyOptions$optionInd2 = buyOptions[optionIndex]) === null || _buyOptions$optionInd2 === void 0 ? void 0 : _buyOptions$optionInd2.title);
    setBuyOptionSku(buyOptions === null || buyOptions === void 0 ? void 0 : (_buyOptions$optionInd3 = buyOptions[optionIndex]) === null || _buyOptions$optionInd3 === void 0 ? void 0 : _buyOptions$optionInd3.sku);
    setBuyOptionTypeId(buyOptions === null || buyOptions === void 0 ? void 0 : (_buyOptions$optionInd4 = buyOptions[optionIndex]) === null || _buyOptions$optionInd4 === void 0 ? void 0 : _buyOptions$optionInd4.option_type_id);
  };

  var scrollToSpecs = function scrollToSpecs() {
    var element = document.getElementById('specifications'),
        offset = 180,
        elementPosition = element.getBoundingClientRect().top,
        offsetPosition = elementPosition + window.pageYOffset - offset;
    element.click();
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  var openVideoModal = function openVideoModal(status) {
    if (status) {
      document.querySelector('body').classList.add('no-scroll');
    } else {
      document.querySelector('body').classList.remove('no-scroll');
    }

    setVideoModalOpened(status);
  };

  var shareUrl = function shareUrl() {
    var url = window.location.href;
    var tempInput = document.createElement('textarea');
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    setShareLabel('Copied');
    setTimeout(function () {
      setShareLabel('Copy link');
      setShareTooltip(false);
    }, 3000);
  };

  (0,react.useEffect)(function () {
    var _productDetails$deal_3, _productDetails$deal_4, _productDetails$deal_5, _router$query;

    if (productDetails) {
      setCookieProducts();
      setCookieRecentlyViewedProducts();
    }

    var filteredVariants = [];
    var isStockList = []; // simple product

    if ((productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$deal_3 = productDetails.deal_data) === null || _productDetails$deal_3 === void 0 ? void 0 : _productDetails$deal_3.length) > 0 && productDetails !== null && productDetails !== void 0 && (_productDetails$deal_4 = productDetails.deal_data[0]) !== null && _productDetails$deal_4 !== void 0 && _productDetails$deal_4.min_price && productDetails !== null && productDetails !== void 0 && (_productDetails$deal_5 = productDetails.deal_data[0]) !== null && _productDetails$deal_5 !== void 0 && _productDetails$deal_5.deal_installment && isEligible) {
      setDefaultBuyOption("upgrade");
    } else if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.monthlyPrice) {
      setDefaultBuyOption("contract");
    } else {
      setDefaultBuyOption("once-off");
    } // configurable product


    if (productDetails !== null && productDetails !== void 0 && productDetails.variants && productDetails !== null && productDetails !== void 0 && productDetails.variants.length) {
      var _productDetails$varia;

      productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$varia = productDetails.variants) === null || _productDetails$varia === void 0 ? void 0 : _productDetails$varia.forEach(function (variant) {
        filteredVariants.push(variant.product);
      });
      filteredVariants.map(function (stock) {
        isStockList.push(stock.stock_status);
      });
      var dataflag = (0,helperServices/* checkStockQuantity */.LY)(productDetails);

      if (dataflag === false) {
        setIsStock(false);
      } else {
        var _productDetails$deal_6, _productDetails$deal_7, _productDetails$deal_8;

        setIsStock(true);

        if (isEligible) {
          setDefaultBuyOption("upgrade");
        } else if ((productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$deal_6 = productDetails.deal_data) === null || _productDetails$deal_6 === void 0 ? void 0 : _productDetails$deal_6.length) > 0 && productDetails !== null && productDetails !== void 0 && (_productDetails$deal_7 = productDetails.deal_data[0]) !== null && _productDetails$deal_7 !== void 0 && _productDetails$deal_7.min_price && productDetails !== null && productDetails !== void 0 && (_productDetails$deal_8 = productDetails.deal_data[0]) !== null && _productDetails$deal_8 !== void 0 && _productDetails$deal_8.deal_installment) {
          setDefaultBuyOption("contract");
        } else {
          setDefaultBuyOption("once-off");
        }
      }
    }
  }, [productDetails]);
  (0,react.useEffect)(function () {
    if (productDetails || selectedVariant) {
      setBodyState(ProductDetailsBody_objectSpread(ProductDetailsBody_objectSpread(ProductDetailsBody_objectSpread(ProductDetailsBody_objectSpread({}, bodyState), getPromoInfo()), getAmounts()), {}, {
        mediaGallery: getMediaGallery(),
        displayDiscountTimer: showDiscountTimer()
      }));
    }
  }, [selectedVariant]);
  (0,react.useEffect)(function () {
    if (selectedOptions) {
      var newVariant = (0,helperServices/* getSelectedVariant */.c)(productDetails.variants, selectedOptions);

      if (newVariant) {
        getVariant(newVariant);
      }
    }
  }, [selectedOptions]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (productDetailsBody_module_default()).wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (productDetailsBody_module_default())["wrapper-device"],
        children: [bodyState.promoTag && bodyState.promoLink != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "absolute left-6 xl:left-4 xl:top-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
            label: bodyState.promoTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_pre_order_online_exclusive_tag */.Z.lbl_pre_order_online_exclusive_tag : bodyState.promoTag,
            variant: (0,helperServices/* getBadgeName */.n_)(bodyState.promoTag),
            labelColor: bodyState.promoTagColor,
            className: "".concat((productDetailsBody_module_default())["offer-style"], " text-center")
          })
        }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)(productViewer_ProductViewer, {
          mediaGallery: bodyState.mediaGallery,
          className: (productDetailsBody_module_default())["product-viewer"],
          sku: productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((productDetailsBody_module_default())["product-details"]),
        children: [brand && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (productDetailsBody_module_default()).brandLogo,
          href: "".concat(urlPrefix, "/products?brands=").concat((brandId === null || brandId === void 0 ? void 0 : brandId.toString()) + ":" + brand),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: 120,
            height: 130,
            alt: brand,
            src: "".concat(ProductDetailsBody_imagePrefix, "/assets/images/brands/").concat(brand.toLowerCase().trim(), ".png"),
            onError: function onError(e) {
              e.target.onError = null;
              e.target.parentNode.classList.add('no-brand-found');
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (productDetailsBody_module_default()).shareWrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return setShareTooltip(!shareTooltip);
            },
            className: "".concat((productDetailsBody_module_default()).shareButton, " ").concat(shareTooltip ? 'bg-[#EBEDEF]' : '')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(shareTooltip ? 'block' : 'hidden', " share-tooltip"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onClick: function onClick() {
                return shareUrl();
              },
              children: shareLabel
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (productDetailsBody_module_default()).titleContainer,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
            id: "".concat(productDetails === null || productDetails === void 0 ? void 0 : productDetails.name.replace(brand, ''), "-ProductNameHeader"),
            text: productDetails === null || productDetails === void 0 ? void 0 : productDetails.name.replace(brand, ''),
            className: "".concat((productDetailsBody_module_default())["product-details-heading"], " !font-VodafoneExB !text-[#08081B] !text-[32px] xl:!text-[64px] !leading-[38px] xl:!leading-[78px]")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (productDetailsBody_module_default()).productPrice,
          children: ["From ", /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
            displayType: "text",
            value: (0,helperServices/* numberFormat */.i8)(bodyState.variantDealPrice),
            prefix: 'R',
            thousandSeparator: true
          }), " PM / ", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
            displayType: "text",
            value: (0,helperServices/* numberFormat */.i8)(bodyState.currentPrice),
            prefix: 'R',
            thousandSeparator: true
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (productDetailsBody_module_default()).productActionShortcuts,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return scrollToSpecs();
            },
            className: (productDetailsBody_module_default()).viewSpecsShortcut,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "View specs"
            })
          }), productDetails.video_url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return openVideoModal(true);
            },
            className: (productDetailsBody_module_default()).videoShortcut,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Watch video"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(productDetailForm, {
          optList: buyOptionSku === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option ? optListCopy : optListCopyForDeal,
          selectedVariant: selectedVariant,
          productDetails: productDetails,
          handleOptionClick1: handleOptionClick1,
          currentPrice: bodyState.currentPrice,
          oldPrice: bodyState.oldPrice,
          discount: bodyState.discount,
          variantDealPrice: bodyState.variantDealPrice,
          variantDeviceInstallment: bodyState.variantDeviceInstallment,
          buyOption: buyOption,
          buyOptions: buyOptions,
          buyOptionSku: buyOptionSku,
          buyOptionTitle: buyOptionTitle,
          handleSelectedBuyOption: handleSelectedBuyOption,
          buyOptionId: buyOptionId,
          buyOptionTypeId: buyOptionTypeId,
          displayDiscountTimer: bodyState.displayDiscountTimer,
          date: productDetails.__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable ? (0,helperServices/* convertToCorrectDateFormat */.GI)(selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod20 = selectedVariant.product) === null || _selectedVariant$prod20 === void 0 ? void 0 : (_selectedVariant$prod21 = _selectedVariant$prod20.promotions) === null || _selectedVariant$prod21 === void 0 ? void 0 : _selectedVariant$prod21.end_date) : (0,helperServices/* convertToCorrectDateFormat */.GI)(productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$promo3 = productDetails.promotions) === null || _productDetails$promo3 === void 0 ? void 0 : _productDetails$promo3.end_date),
          selectedOptions: selectedOptions,
          upgradeChecksEnabled: upgradeChecksEnabled,
          triggerCallback: triggerCallback,
          showSnackBarEvent: showSnackBarEvent,
          closeSnackBarEvent: closeSnackBarEvent,
          promotionTag: bodyState.promoTag,
          showShopCheck: bodyState.showShopCheck,
          geoLocationIsAllowed: geoLocationIsAllowed,
          nearestStore: nearestStore,
          isStoreStockServiceDown: isStoreStockServiceDown
        }), productDetails.video_url && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((productDetailsBody_module_default()).videoModalOverlay, " ").concat(videoModalOpened ? 'block' : 'hidden')
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((productDetailsBody_module_default()).videoModal, " ").concat(videoModalOpened ? 'block' : 'hidden'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onClick: function onClick() {
                return openVideoModal(false);
              },
              className: (productDetailsBody_module_default()).videoModalClose,
              children: "Close Video"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (productDetailsBody_module_default()).videoModalContent,
              children: videoModalOpened && /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
                src: productDetails.video_url,
                controls: true,
                autoPlay: true,
                muted: true
              })
            })]
          })]
        }), productDetails.pdp_best_features && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (productDetailsBody_module_default()).deliveryOptionsWrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (productDetailsBody_module_default()).deliveryInfoTitle,
            children: "Best features"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (productDetailsBody_module_default()).specialFeaturesWrapper,
            children: (0,lib/* default */.ZP)(productDetails.pdp_best_features)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (productDetailsBody_module_default()).deliveryOptionsWrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (productDetailsBody_module_default()).deliveryInfoTitle,
            children: "Delivery options"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((productDetailsBody_module_default()).deliveryOptionsWapper, " ").concat((productDetailsBody_module_default()).cncOptionsWrapper),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (productDetailsBody_module_default()).deliveryOptionTitle,
              children: "Delivery to an address"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (productDetailsBody_module_default()).deliveryOptionDescription,
              children: "Delivered anywhere in SA within 2 days of placing your order. Delivery costs based on your location."
            })]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var productDetailsBody_ProductDetailsBody = (ProductDetailsBody);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/molecules/pageError/pageError.jsx
var pageError = __webpack_require__(66115);
// EXTERNAL MODULE: ./utils/handleGeoLocation.js
var handleGeoLocation = __webpack_require__(17028);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./Redux/actions/navAction.js
var navAction = __webpack_require__(42220);
// EXTERNAL MODULE: ./components/molecules/errorToolTip/ErrorTooltip.jsx
var ErrorTooltip = __webpack_require__(94029);
// EXTERNAL MODULE: ./Redux/actions/geoLocationAction.js
var geoLocationAction = __webpack_require__(28935);
// EXTERNAL MODULE: ./Redux/actions/getHelpAction.js
var getHelpAction = __webpack_require__(87524);
;// CONCATENATED MODULE: ./pages/shopping/product-details/[id].js



function _id_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _id_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _id_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _id_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


























var ProductDetailsHeader = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2041).then(__webpack_require__.bind(__webpack_require__, 22041));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22041)];
    }
  }
});
var ProductDetailsFooterTop = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2065).then(__webpack_require__.bind(__webpack_require__, 92065));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(92065)];
    }
  }
});

var ProductDetailsPage = function ProductDetailsPage(props) {
  var _props$geoLocation, _getCustomDropDown, _getCustomDropDown$va, _getCustomDropDown2, _getCustomDropDown3, _getCustomDropDown4, _props$geoLocation2, _getCustomDropDown5, _getSortedOptions, _getSortedOptions$, _getCustomDropDown6;

  var _useState = (0,react.useState)(null),
      selectedVariant = _useState[0],
      setSelectedVariant = _useState[1];

  var _useState2 = (0,react.useState)(true),
      defaultVariant = _useState2[0],
      setDafaultVariant = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      selectedBuyOptionType = _useState3[0],
      setSelectedBuyOptionType = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      analytics = _useState5[0],
      setAnalytics = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      productDetails = _useState6[0],
      setProductDetails = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      showError = _useState7[0],
      setShowError = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      optList = _useState8[0],
      setOptList = _useState8[1];

  var router = (0,DependencyHelper.useRouter)();
  var query = router.query;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var shoppingUrlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;

  var _useState9 = (0,react.useState)(false),
      refreshUser = _useState9[0],
      setRefreshUser = _useState9[1];

  var _useState10 = (0,react.useState)(),
      isUserProfileSync = _useState10[0],
      setIsUserProfileSync = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      isModalOpen = _useState11[0],
      setShowModal = _useState11[1];

  var _useState12 = (0,react.useState)({
    visible: false,
    message: ""
  }),
      showSnackBar = _useState12[0],
      setShowSnackBar = _useState12[1];

  var loginUrl = (config_default()).envConfigs[env].DIDLoginUrl;

  var _useState13 = (0,react.useState)(""),
      redirectURL = _useState13[0],
      setRedirectURL = _useState13[1];

  var _useState14 = (0,react.useState)(true),
      upgradeChecksEnabled = _useState14[0],
      setUpgradeChecksEnabled = _useState14[1];

  var _useState15 = (0,react.useState)(true),
      isClickndCollectFeatureEnabled = _useState15[0],
      setIsClickndCollectFeatureEnabled = _useState15[1];

  var _useState16 = (0,react.useState)([]),
      storeAddress = _useState16[0],
      populateStoreList = _useState16[1];

  var _useState17 = (0,react.useState)(undefined),
      nearestStore = _useState17[0],
      setNearestStore = _useState17[1];

  var _useState18 = (0,react.useState)(true),
      serviceDown = _useState18[0],
      setServiceDown = _useState18[1];

  function featuresCheck() {
    return _featuresCheck.apply(this, arguments);
  }

  function _featuresCheck() {
    _featuresCheck = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var featuresResult;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return ajaxServices/* default.httpGet */.Z.httpGet("featureBaseUrl", "", "api", "features");

            case 3:
              featuresResult = _context2.sent;
              setUpgradeChecksEnabled((featuresResult === null || featuresResult === void 0 ? void 0 : featuresResult.upgradeChecksEnabled) || false);
              setIsClickndCollectFeatureEnabled((featuresResult === null || featuresResult === void 0 ? void 0 : featuresResult.clickAndCollect) || false);
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.log("deal-details: features : error: ", _context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return _featuresCheck.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var result, _result$products, _result$errors, _result$errors2, _result$errors2$;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.productCalled = true;
                setShowError(false);
                (0,helperServices/* showSpinner */.yh)();
                _context.next = 5;
                return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* ProductDetails */.f4, {
                  id: query && query.id ? query.id.toString() : ""
                }, "", true);

              case 5:
                result = _context.sent;

                if (result && result.products && result.products.items && result.products.items.length) {
                  window.productCalled = false;
                  setProductDetails(result.products.items[0]);
                  setLoaded(false);
                  setAnalytics(false);
                } else {
                  setShowError(true);
                  setProductDetails((_result$products = result.products) === null || _result$products === void 0 ? void 0 : _result$products.items[0]);
                  analyticsUtag/* link */.p4({
                    page_name: "shopping: devices: product details",
                    page_form_event: "error",
                    page_errors: "".concat(labels/* default.lbl_menu_top.lbl_product_404_heading */.Z.lbl_menu_top.lbl_product_404_heading, ". ").concat(labels/* default.lbl_menu_top.lbl_product_404_description */.Z.lbl_menu_top.lbl_product_404_description),
                    page_errors_code: "pdp-m-p-pd-".concat(result === null || result === void 0 ? void 0 : result.status)
                  });
                  window.productCalled = false;
                }

                if (result && result.errors) {
                  window.productCalled = false;
                  analyticsUtag/* link */.p4({
                    page_name: "shopping: devices: product details",
                    page_form_event: "error",
                    page_errors: "".concat((_result$errors = result.errors) !== null && _result$errors !== void 0 && _result$errors[0] ? (_result$errors2 = result.errors) === null || _result$errors2 === void 0 ? void 0 : (_result$errors2$ = _result$errors2[0]) === null || _result$errors2$ === void 0 ? void 0 : _result$errors2$.message : ""),
                    page_errors_code: "pdp-m-p-pd-".concat(result === null || result === void 0 ? void 0 : result.status)
                  });
                }

                window.scrollTo(0, 0);
                (0,helperServices/* hideSpinner */.v3)();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    setIsUserProfileSync();
    props === null || props === void 0 ? void 0 : props.resetSyncUserProfile();
    setRefreshUser(false);
    closeSnackBar();

    if (!window.productCalled) {
      fetchData();
    }
  }, [query === null || query === void 0 ? void 0 : query.id]);
  (0,react.useEffect)(function () {
    if (productDetails) {
      var _productDetails$varia;

      setSelectedVariant(productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$varia = productDetails.variants) === null || _productDetails$varia === void 0 ? void 0 : _productDetails$varia[0]);
      var list = [];

      if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable) {
        var _productDetails$varia2;

        var optionsList = (0,helperServices/* configurableOptions */.Lv)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options);
        var filteredVariants = [];
        var isStockList = [];
        productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$varia2 = productDetails.variants) === null || _productDetails$varia2 === void 0 ? void 0 : _productDetails$varia2.forEach(function (variant) {
          filteredVariants.push(variant.product);
        });
        filteredVariants.map(function (stock) {
          isStockList.push(stock.stock_status);
        });
        optionsList.forEach(function (option) {
          var opt = (0,helperServices/* options */.YM)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.configurable_options, option);
          var some = {};
          some[option] = opt;
          list.push(some);
        });
        setOptList(list);
      }
    }
  }, [productDetails]);
  (0,react.useEffect)(function () {
    // fetch user location for store stock check
    if (isClickndCollectFeatureEnabled) {
      if (productDetails && (productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label) != types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER) {
        getUserLocation(productDetails.sku);
      }
    }
  }, [productDetails, isClickndCollectFeatureEnabled]);
  var productName, category, categoryId, buyOptionType;

  if (productDetails && Object.prototype.hasOwnProperty.call(productDetails, "name")) {
    productName = productDetails.name;
  }

  if (productDetails && productDetails.categories && productDetails.categories.length > 0) {
    category = productDetails.categories[0].name;
    categoryId = productDetails.categories[0].id;
  }

  var getFinalPrice = function getFinalPrice(priceRange) {
    return priceRange.maximum_price.final_price.value;
  };

  var updateBuyOptionType = function updateBuyOptionType(buyOption) {
    buyOptionType = buyOption;
    setSelectedBuyOptionType(buyOptionType);
  };

  var updateSelectedVariant = function updateSelectedVariant(variant) {
    setSelectedVariant(variant);
    setDafaultVariant(false);
  };

  var dynamicRoute = (0,helperServices/* dynamicBreadCrumb */.sz)();
  (0,react.useEffect)(function () {
    var pages = Object.keys(dynamicRoute);

    if (!loaded && pages.length && productDetails) {
      var flag = null;

      if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable) {
        var maxQuantity = productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants.reduce(function (prev, current) {
          var _current$product, _prev$product;

          if (+((_current$product = current.product) === null || _current$product === void 0 ? void 0 : _current$product.quantity) > +((_prev$product = prev.product) === null || _prev$product === void 0 ? void 0 : _prev$product.quantity)) {
            return current;
          } else {
            return prev;
          }
        });

        if (maxQuantity !== null) {
          var _maxQuantity$product;

          flag = maxQuantity === null || maxQuantity === void 0 ? void 0 : (_maxQuantity$product = maxQuantity.product) === null || _maxQuantity$product === void 0 ? void 0 : _maxQuantity$product.badges_label;
        } else {
          flag = productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label;
        }
      } else {
        flag = productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label;
      }

      setLoaded(true);

      if (productDetails) {
        if (!analytics) {
          var _category, _productDetails$name, _productDetails$name2, _productDetails$stock, _productDetails$stock2;

          var userMetaData = analyticsUtag/* getProfileData */.$y(props.userLoggedIn, props.profileData);

          var analyticsData = _id_objectSpread({
            page_event: "view",
            page_name: "shopping: devices: product details",
            page_channel: "shopping",
            page_master_tab: "personal",
            sales_event: "view",
            sales_order_discount: [(0,helperServices/* getAmountOffValue */.Dd)(productDetails)],
            sales_product_category: [(_category = category) === null || _category === void 0 ? void 0 : _category.toString()],
            sales_product_id: [productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$name = productDetails.name) === null || _productDetails$name === void 0 ? void 0 : _productDetails$name.toString()],
            sales_product_price: [getFinalPrice(productDetails === null || productDetails === void 0 ? void 0 : productDetails.price_range).toString()],
            sales_product_quantity: [1],
            sales_promo_name: flag,
            page_hierarchy: "shopping: browse all product: product details",
            page_site_section_lvl_1: productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$name2 = productDetails.name) === null || _productDetails$name2 === void 0 ? void 0 : _productDetails$name2.toString(),
            page_site_section_lvl_2: "Browse products",
            page_site_section_lvl_3: "Home"
          }, userMetaData);

          if (productDetails !== null && productDetails !== void 0 && productDetails.badges_label) {
            analyticsData.sales_promo_name = [productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label];
          }

          if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER) {
            analyticsData.preorder_flag = "true";
          }

          if ((productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$stock = productDetails.stock_status) === null || _productDetails$stock === void 0 ? void 0 : _productDetails$stock.toLowerCase()) === "out_of_stock") {
            analyticsData.page_tool_event = "use";
            analyticsData.page_tool_name = "shopping: devices: product details: out of stock";
          }

          analyticsData.out_of_stock = productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$stock2 = productDetails.stock_status) === null || _productDetails$stock2 === void 0 ? void 0 : _productDetails$stock2.toLowerCase();
          analyticsUtag/* view */.ei(analyticsData);
          setAnalytics(true);
        }
      }
    }
  }, [dynamicRoute, productDetails]);
  (0,react.useEffect)(function () {
    featuresCheck();
    props === null || props === void 0 ? void 0 : props.setHelpLeadBucket(constants/* LEAD_BUCKETS.general */.xO.general);
    analyticsUtag/* setAutoTagging */.fv(false);

    if (true) {
      setRedirectURL(window.location.href);
    }

    setIsUserProfileSync();
    props === null || props === void 0 ? void 0 : props.resetSyncUserProfile();
    setRefreshUser(false);
    closeSnackBar();
    (0,helperServices/* updateBreadCrumbPageTitle */.rN)(router.pathname, productName);
  }, []);

  var getUserLocation = function getUserLocation(productSKU) {
    (0,handleGeoLocation/* default */.Z)(props, productSKU, populateStoreList, setServiceDown);
  };

  (0,react.useEffect)(function () {
    if (storeAddress && storeAddress.length) {
      var storeDetails = (0,handleGeoLocation/* getNearestStore */.I)(storeAddress);
      setNearestStore(storeDetails);
    }
  }, [storeAddress]);

  var showModal = function showModal() {
    setShowModal(true);
  };

  var hideModal = function hideModal() {
    setShowModal(false);
  };

  var getCustomDropDown = function getCustomDropDown() {
    var _productDetails$optio;

    if (productDetails && productDetails !== null && productDetails !== void 0 && (_productDetails$optio = productDetails.options) !== null && _productDetails$optio !== void 0 && _productDetails$optio.length) {
      var customDropDown = productDetails.options.filter(function (option) {
        return option["__typename"] === labels/* default.lbl_custom_dropdown_typeName */.Z.lbl_custom_dropdown_typeName;
      });
      return customDropDown.length ? customDropDown[0] : [];
    }
  };

  var getSortedOptions = function getSortedOptions(optionsArr) {
    if ((0,helperServices/* isArrayNotEmpty */.wh)(optionsArr)) {
      var once_off = optionsArr.find(function (option) {
        return (option === null || option === void 0 ? void 0 : option.sku) === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option;
      });
      var contract = optionsArr.find(function (option) {
        return (option === null || option === void 0 ? void 0 : option.sku) === labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option;
      });
      var upgrade = optionsArr.find(function (option) {
        return (option === null || option === void 0 ? void 0 : option.sku) === labels/* default.lbl_custom_dropdown_upgrade_option */.Z.lbl_custom_dropdown_upgrade_option;
      });
      return [contract, upgrade, once_off];
    }
  };

  var goToProducts = function goToProducts() {
    analyticsUtag/* link */.p4({
      page_name: "shopping: devices: product details",
      link_type: "o",
      link_name: "shopping: devices: product details: error Browse all products"
    });
    (0,helperServices/* showSpinner */.yh)();
    router.push("".concat(shoppingUrlPrefix, "/products")).then(function () {
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  (0,react.useEffect)(function () {
    var _props$userProfileSyn, _props$userProfileSyn2;

    if (props !== null && props !== void 0 && (_props$userProfileSyn = props.userProfileSync) !== null && _props$userProfileSyn !== void 0 && _props$userProfileSyn.userDetails && (props === null || props === void 0 ? void 0 : (_props$userProfileSyn2 = props.userProfileSync) === null || _props$userProfileSyn2 === void 0 ? void 0 : _props$userProfileSyn2.userDetails) != null) {
      var _props$userProfileSyn4;

      setIsUserProfileSync();

      var _props$userProfileSyn3 = props === null || props === void 0 ? void 0 : (_props$userProfileSyn4 = props.userProfileSync) === null || _props$userProfileSyn4 === void 0 ? void 0 : _props$userProfileSyn4.userDetails,
          apiStatus = _props$userProfileSyn3.apiStatus;

      if (apiStatus && !refreshUser) {
        var _props$userProfileSyn5;

        var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
        updateCookieConsentWrapper(props === null || props === void 0 ? void 0 : (_props$userProfileSyn5 = props.userProfileSync) === null || _props$userProfileSyn5 === void 0 ? void 0 : _props$userProfileSyn5.userDetails, cartId);
        setRefreshUser(true);
      } else {
        var _props$userProfileSyn6, _props$userProfileSyn7;

        (0,helperServices/* hideSpinner */.v3)();
        props === null || props === void 0 ? void 0 : props.resetSyncUserProfile();
        setRefreshUser(false);

        if ((props === null || props === void 0 ? void 0 : (_props$userProfileSyn6 = props.userProfileSync) === null || _props$userProfileSyn6 === void 0 ? void 0 : (_props$userProfileSyn7 = _props$userProfileSyn6.userDetails) === null || _props$userProfileSyn7 === void 0 ? void 0 : _props$userProfileSyn7.apiFailStatus) == "401") {
          (0,helperServices/* clearUserToken */.Zj)();
          setTimeout(function () {
            window.location.replace(loginUrl + "?redirectUrl=" + redirectURL);
          }, 100);
          return;
        } else {
          displaySnakbar();
        }
      }
    } // return () => {
    //   if (props?.userProfileSync?.userDetails) {
    //     hideSpinner();
    //   }
    // };

  }, [props === null || props === void 0 ? void 0 : props.userProfileSync]);

  var displaySnakbar = function displaySnakbar() {
    setShowSnackBar({
      visible: true,
      message: labels/* default.errorMessages.lbl_user_profile_sync */.Z.errorMessages.lbl_user_profile_sync
    });
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar({
      visible: false,
      message: ""
    });
  };

  var updateCookieConsentWrapper = function updateCookieConsentWrapper(profileInfo, cartId) {
    try {
      var _profileInfo$result, _profileInfo$result$m, _profileInfo$result$m2, _profileInfo$result2, _profileInfo$result2$;

      var oAuthToken = profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$result = profileInfo.result) === null || _profileInfo$result === void 0 ? void 0 : (_profileInfo$result$m = _profileInfo$result.magentoProfileResponse[0]) === null || _profileInfo$result$m === void 0 ? void 0 : (_profileInfo$result$m2 = _profileInfo$result$m.OAuthTokenDetails[0]) === null || _profileInfo$result$m2 === void 0 ? void 0 : _profileInfo$result$m2.OAuthToken;
      cartId = profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$result2 = profileInfo.result) === null || _profileInfo$result2 === void 0 ? void 0 : (_profileInfo$result2$ = _profileInfo$result2.magentoProfileResponse[0]) === null || _profileInfo$result2$ === void 0 ? void 0 : _profileInfo$result2$.mergedCartID;
      (0,helperServices/* setCookieConsentWrapper */.ol)("auth_token", [(config_default()).cookie_category.strictly_necessary], "document.cookie='auth_token=".concat(oAuthToken, ";path=/'"));
      (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(cartId, ";path=/'"));
    } catch (error) {
      console.log("");
    } finally {
      var updatedProfileInfo = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.result;
      setRefreshUser(false);
      (0,helperServices/* hideSpinner */.v3)();

      if (updatedProfileInfo) {
        props === null || props === void 0 ? void 0 : props.setProfileData(profileInfo);
        props === null || props === void 0 ? void 0 : props.resetSyncUserProfile(); // handleAddToCart();

        setIsUserProfileSync(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.pageAction);
      } else {
        props === null || props === void 0 ? void 0 : props.resetSyncUserProfile();
      }
    }
  };

  var isEligible = function isEligible() {
    var _props$upgrade, _props$upgrade2, _props$upgrade2$selec, _props$upgrade3;

    return (props === null || props === void 0 ? void 0 : (_props$upgrade = props.upgrade) === null || _props$upgrade === void 0 ? void 0 : _props$upgrade.upgradeCheckDone) && (props === null || props === void 0 ? void 0 : (_props$upgrade2 = props.upgrade) === null || _props$upgrade2 === void 0 ? void 0 : (_props$upgrade2$selec = _props$upgrade2.selectedUpgradeResponse) === null || _props$upgrade2$selec === void 0 ? void 0 : _props$upgrade2$selec.upgradeEligible) && (props === null || props === void 0 ? void 0 : (_props$upgrade3 = props.upgrade) === null || _props$upgrade3 === void 0 ? void 0 : _props$upgrade3.topBannerVisible);
  };

  var selectedStoreDetails = function selectedStoreDetails(selectedStore) {
    if (selectedStore) {
      setNearestStore(selectedStore);
    }

    hideModal();
  };

  (0,react.useEffect)(function () {
    document.body.classList.add("product-details");
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "product-details-page",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "product-details-page-inner",
      children: [showSnackBar.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTooltip/* default */.Z, {
        className: "error-container",
        errorMsg: showSnackBar.message,
        buttonHandler: closeSnackBar
      }), productDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ClickAndCollectModal/* default */.Z, {
          sku: productDetails.sku,
          isModalOpen: isModalOpen,
          hideModal: hideModal,
          storeAddress: storeAddress,
          geoLocationIsAllowed: (_props$geoLocation = props.geoLocation) === null || _props$geoLocation === void 0 ? void 0 : _props$geoLocation.allowed,
          selectedStore: selectedStoreDetails
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Head, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
            children: productName
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductDetailsHeader, {
          productName: productName,
          rating: 3.2,
          brand: productDetails && productDetails.manufacturer_label ? productDetails.manufacturer_label : "",
          category: category,
          brandId: productDetails && productDetails.manufacturer ? productDetails.manufacturer : "",
          categoryId: categoryId,
          promotionTag: productDetails && (productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? productDetails === null || productDetails === void 0 ? void 0 : productDetails.badges_label : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(productDetailsBody_ProductDetailsBody, {
          getVariant: function getVariant(selectedVariant) {
            return updateSelectedVariant(selectedVariant);
          },
          productDetails: productDetails,
          selectedVariant: selectedVariant,
          buyOptions: ((_getCustomDropDown = getCustomDropDown()) === null || _getCustomDropDown === void 0 ? void 0 : (_getCustomDropDown$va = _getCustomDropDown.value) === null || _getCustomDropDown$va === void 0 ? void 0 : _getCustomDropDown$va.length) && getSortedOptions((_getCustomDropDown2 = getCustomDropDown()) === null || _getCustomDropDown2 === void 0 ? void 0 : _getCustomDropDown2.value),
          buyOptionTitle: (_getCustomDropDown3 = getCustomDropDown()) === null || _getCustomDropDown3 === void 0 ? void 0 : _getCustomDropDown3.title,
          getBuyOptionType: function getBuyOptionType(optionType) {
            updateBuyOptionType(optionType);
          },
          buyOptionId: (_getCustomDropDown4 = getCustomDropDown()) === null || _getCustomDropDown4 === void 0 ? void 0 : _getCustomDropDown4.option_id,
          optList: optList,
          triggerCallback: isUserProfileSync,
          showSnackBarEvent: displaySnakbar,
          closeSnackBarEvent: closeSnackBar,
          upgradeChecksEnabled: upgradeChecksEnabled,
          isEligible: isEligible(),
          showModal: showModal,
          geoLocationIsAllowed: (_props$geoLocation2 = props.geoLocation) === null || _props$geoLocation2 === void 0 ? void 0 : _props$geoLocation2.allowed,
          nearestStore: nearestStore,
          isStoreStockServiceDown: serviceDown,
          brand: productDetails && productDetails.manufacturer_label ? productDetails.manufacturer_label : "",
          category: category,
          brandId: productDetails && productDetails.manufacturer ? productDetails.manufacturer : ""
        })]
      }), showError && /*#__PURE__*/(0,jsx_runtime.jsx)(pageError/* default */.Z, {
        className: "not-found",
        heading: labels/* default.lbl_menu_top.lbl_product_404_heading */.Z.lbl_menu_top.lbl_product_404_heading,
        description: labels/* default.lbl_menu_top.lbl_product_404_description */.Z.lbl_menu_top.lbl_product_404_description,
        primaryLabel: "Browse all products",
        handlePrimaryClick: goToProducts,
        imgUrl: "".concat(imagePrefix, "/assets/images/search-not-found.svg")
      })]
    }), productDetails && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductDetailsFooterTop, {
      defaultVariant: defaultVariant,
      selectedVariant: selectedVariant,
      productDetails: productDetails,
      sku: productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku,
      selectedBuyOptionType: selectedBuyOptionType,
      buyOptionId: (_getCustomDropDown5 = getCustomDropDown()) === null || _getCustomDropDown5 === void 0 ? void 0 : _getCustomDropDown5.option_id,
      buyOptionTypeId: (_getSortedOptions = getSortedOptions((_getCustomDropDown6 = getCustomDropDown()) === null || _getCustomDropDown6 === void 0 ? void 0 : _getCustomDropDown6.value)) === null || _getSortedOptions === void 0 ? void 0 : (_getSortedOptions$ = _getSortedOptions[0]) === null || _getSortedOptions$ === void 0 ? void 0 : _getSortedOptions$.option_type_id,
      triggerCallback: isUserProfileSync,
      showSnackBarEvent: displaySnakbar,
      closeSnackBarEvent: closeSnackBar
    })]
  });
};

var _id_mapStateToProps = function mapStateToProps(state) {
  return {
    profileData: state.navDetails.profileData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    userProfileSync: state.userProfileSync,
    upgrade: state.upgrade,
    geoLocation: state.geoLocation
  };
};

ProductDetailsPage.defaultProps = {//productsByBrandId: null,
};
/* harmony default export */ var _id_ = ((0,es/* connect */.$j)(_id_mapStateToProps, {
  resetSyncUserProfile: userProfileAction/* resetSyncUserProfile */.h,
  setProfileData: navAction/* setProfileData */._J,
  setGeoLocationStatus: geoLocationAction/* setGeoLocationStatus */.$q,
  setGeoLocationPosition: geoLocationAction/* setGeoLocationPosition */.pt,
  setHelpLeadBucket: getHelpAction/* setHelpLeadBucket */.A
})(ProductDetailsPage));

/***/ }),

/***/ 85160:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/product-details/[id]",
      function () {
        return __webpack_require__(1448);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label-text":"LabelText_label-text__ss__o"};

/***/ }),

/***/ 4924:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__AHuPt"};

/***/ }),

/***/ 60682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timerContainer":"PromotionTimer_timerContainer__EWGfM","discountLabel":"PromotionTimer_discountLabel__kKISK","time":"PromotionTimer_time__PIU2S","zerotime":"PromotionTimer_zerotime__SlI3o","zerotimepad":"PromotionTimer_zerotimepad__rMFqv"};

/***/ }),

/***/ 20753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio-button":"radioButton_radio-button__LZAgt","radio-button__input-hidden":"radioButton_radio-button__input-hidden__IxEoA","radio-button__text":"radioButton_radio-button__text__AF_Wl","radio-button__label-name":"radioButton_radio-button__label-name__w_wa7","radio-button__label":"radioButton_radio-button__label__Q_HAS","radioOptions":"radioButton_radioOptions__JGXmJ","defaultOptions":"radioButton_defaultOptions__DkOjH","radio-button__clickable":"radioButton_radio-button__clickable__1RkdV","radio-button__checkmark":"radioButton_radio-button__checkmark__t6gQb","radio-button__checked":"radioButton_radio-button__checked__db6uz","radio-button__coloring":"radioButton_radio-button__coloring__W9FC3"};

/***/ }),

/***/ 58837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"store":"shopWithStock_store__28Jl3","store__icon":"shopWithStock_store__icon__crSOK","store__name":"shopWithStock_store__name__vt35U","store__stock_status":"shopWithStock_store__stock_status__qq3za","link":"shopWithStock_link__4uHca"};

/***/ }),

/***/ 58428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__9y82S","brand-new":"tag_brand-new__f_W4F","currently-viewing":"tag_currently-viewing__fdjKe","discount":"tag_discount__NyMX6","buy-one-get-one-free":"tag_buy-one-get-one-free__z2hQ2","device-deal":"tag_device-deal__CvIF0","limited-offer":"tag_limited-offer__u9CQE","read-hot-dealz":"tag_read-hot-dealz__ITnUK","low-stock":"tag_low-stock__GjK3M","no-stock":"tag_no-stock__vzFpN","red-hot-deal":"tag_red-hot-deal___yuSu","on-backorder":"tag_on-backorder___5HF0","pre-order":"tag_pre-order__OiaYK","exclusive-to-online":"tag_exclusive-to-online__MHLGd","one-time-offer":"tag_one-time-offer__FSShN","today-only":"tag_today-only__coPUD","for-today-only":"tag_for-today-only__C4Ugl","top-pick":"tag_top-pick__xGezC","black-friday":"tag_black-friday__wPq1G","badge-style-1":"tag_badge-style-1__wvGOX","Recommended":"tag_Recommended__ci3Kx"};

/***/ }),

/***/ 12502:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"productDetailPrice_p-xxs__gSQHU","pl-xxs":"productDetailPrice_pl-xxs__l_QWE","pr-xxs":"productDetailPrice_pr-xxs__OyzJQ","pb-xxs":"productDetailPrice_pb-xxs__YtOQN","pt-xxs":"productDetailPrice_pt-xxs__DoGfy","m-xxs":"productDetailPrice_m-xxs__NCa16","ml-xxs":"productDetailPrice_ml-xxs__R2e7j","mr-xxs":"productDetailPrice_mr-xxs__3_M3u","mb-xxs":"productDetailPrice_mb-xxs__0K4_q","mt-xxs":"productDetailPrice_mt-xxs__kA5Uk","px-xxs":"productDetailPrice_px-xxs__TRrMp","mx-xxs":"productDetailPrice_mx-xxs__YdUTg","my-xxs":"productDetailPrice_my-xxs__Tj7KP","py-xxs":"productDetailPrice_py-xxs__AB_fH","font-size-xxs":"productDetailPrice_font-size-xxs__uTBKd","p-xs":"productDetailPrice_p-xs__GDCg_","pl-xs":"productDetailPrice_pl-xs__x1YXc","pr-xs":"productDetailPrice_pr-xs__pcJEu","pb-xs":"productDetailPrice_pb-xs__5OFQN","pt-xs":"productDetailPrice_pt-xs__FmvZW","m-xs":"productDetailPrice_m-xs__l2Hb1","ml-xs":"productDetailPrice_ml-xs__n0j__","mr-xs":"productDetailPrice_mr-xs__Du_as","mb-xs":"productDetailPrice_mb-xs__M_niG","mt-xs":"productDetailPrice_mt-xs__44PIK","px-xs":"productDetailPrice_px-xs__BtvIr","mx-xs":"productDetailPrice_mx-xs__NSchm","my-xs":"productDetailPrice_my-xs__vyHqh","py-xs":"productDetailPrice_py-xs__YdAVp","font-size-xs":"productDetailPrice_font-size-xs__O11u4","p-ss":"productDetailPrice_p-ss__ysJTL","pl-ss":"productDetailPrice_pl-ss__X594j","pr-ss":"productDetailPrice_pr-ss__xLa5X","pb-ss":"productDetailPrice_pb-ss__9dVHK","pt-ss":"productDetailPrice_pt-ss__nIqJl","m-ss":"productDetailPrice_m-ss__VGnJk","ml-ss":"productDetailPrice_ml-ss__MU_VR","mr-ss":"productDetailPrice_mr-ss__P7acw","mb-ss":"productDetailPrice_mb-ss__AwFjz","mt-ss":"productDetailPrice_mt-ss__lMMrG","px-ss":"productDetailPrice_px-ss__koTIZ","mx-ss":"productDetailPrice_mx-ss__hbARS","my-ss":"productDetailPrice_my-ss__wcCmZ","py-ss":"productDetailPrice_py-ss__DsDBE","font-size-ss":"productDetailPrice_font-size-ss__0tArl","p-ms":"productDetailPrice_p-ms__aaBAY","pl-ms":"productDetailPrice_pl-ms__CNBLD","pr-ms":"productDetailPrice_pr-ms__eJAsA","pb-ms":"productDetailPrice_pb-ms__70qtO","pt-ms":"productDetailPrice_pt-ms__RlxWk","m-ms":"productDetailPrice_m-ms__vUhcO","ml-ms":"productDetailPrice_ml-ms__WAk4x","mr-ms":"productDetailPrice_mr-ms__qmSSx","mb-ms":"productDetailPrice_mb-ms__aMJRi","mt-ms":"productDetailPrice_mt-ms__JPR0O","px-ms":"productDetailPrice_px-ms__8CKOs","mx-ms":"productDetailPrice_mx-ms___07LS","my-ms":"productDetailPrice_my-ms__c1nyv","py-ms":"productDetailPrice_py-ms__12oUt","font-size-ms":"productDetailPrice_font-size-ms__Zjg3k","p-s":"productDetailPrice_p-s__7h2IK","pl-s":"productDetailPrice_pl-s__a6cl0","pr-s":"productDetailPrice_pr-s__pn1_Z","pb-s":"productDetailPrice_pb-s__1pRtb","pt-s":"productDetailPrice_pt-s__uo03n","m-s":"productDetailPrice_m-s__qgay2","ml-s":"productDetailPrice_ml-s__iLvAZ","mr-s":"productDetailPrice_mr-s__FVNyW","mb-s":"productDetailPrice_mb-s__4wujP","mt-s":"productDetailPrice_mt-s__PaJEs","px-s":"productDetailPrice_px-s__HbW6V","mx-s":"productDetailPrice_mx-s__5DBG0","my-s":"productDetailPrice_my-s__zbnOy","py-s":"productDetailPrice_py-s__IRmHl","font-size-s":"productDetailPrice_font-size-s__6MQfE","p-m":"productDetailPrice_p-m__N8_74","pl-m":"productDetailPrice_pl-m__DLCr8","pr-m":"productDetailPrice_pr-m__Xf5BS","pb-m":"productDetailPrice_pb-m__DUYRm","pt-m":"productDetailPrice_pt-m__0Iqcx","m-m":"productDetailPrice_m-m__1KA0k","ml-m":"productDetailPrice_ml-m__7BFLF","mr-m":"productDetailPrice_mr-m__xqY8U","mb-m":"productDetailPrice_mb-m__aNr0D","mt-m":"productDetailPrice_mt-m__H5A_M","px-m":"productDetailPrice_px-m__Fcuqh","mx-m":"productDetailPrice_mx-m__eGRVC","my-m":"productDetailPrice_my-m__Ice_W","py-m":"productDetailPrice_py-m__3xyRF","font-size-m":"productDetailPrice_font-size-m__G_cgV","p-l":"productDetailPrice_p-l__VqmHf","pl-l":"productDetailPrice_pl-l__xOsCP","pr-l":"productDetailPrice_pr-l__FnBcz","pb-l":"productDetailPrice_pb-l__idKcJ","pt-l":"productDetailPrice_pt-l__NBWYX","m-l":"productDetailPrice_m-l__OAAtK","ml-l":"productDetailPrice_ml-l__AZVrr","mr-l":"productDetailPrice_mr-l__cVlPp","mb-l":"productDetailPrice_mb-l__1xTX3","mt-l":"productDetailPrice_mt-l__G3ZHZ","px-l":"productDetailPrice_px-l__A7nCj","mx-l":"productDetailPrice_mx-l__XxKMP","my-l":"productDetailPrice_my-l__rN3A5","py-l":"productDetailPrice_py-l__AYemY","font-size-l":"productDetailPrice_font-size-l__Fr_nd","p-xl":"productDetailPrice_p-xl__RZmY9","pl-xl":"productDetailPrice_pl-xl__LC5Zh","pr-xl":"productDetailPrice_pr-xl__AmiaQ","pb-xl":"productDetailPrice_pb-xl__1O2Bl","pt-xl":"productDetailPrice_pt-xl__mBV36","m-xl":"productDetailPrice_m-xl__Dysvn","ml-xl":"productDetailPrice_ml-xl__7OCrR","mr-xl":"productDetailPrice_mr-xl__MF7U_","mb-xl":"productDetailPrice_mb-xl__Vatln","mt-xl":"productDetailPrice_mt-xl__609x0","px-xl":"productDetailPrice_px-xl__Q5yCn","mx-xl":"productDetailPrice_mx-xl__BDOSP","my-xl":"productDetailPrice_my-xl__6SfbO","py-xl":"productDetailPrice_py-xl__9euRu","font-size-xl":"productDetailPrice_font-size-xl__cItgU","p-xxl":"productDetailPrice_p-xxl__13a1G","pl-xxl":"productDetailPrice_pl-xxl__vTh9H","pr-xxl":"productDetailPrice_pr-xxl__ZO7f4","pb-xxl":"productDetailPrice_pb-xxl__ulv3B","pt-xxl":"productDetailPrice_pt-xxl__HqbsE","m-xxl":"productDetailPrice_m-xxl__20qKG","ml-xxl":"productDetailPrice_ml-xxl__UF91f","mr-xxl":"productDetailPrice_mr-xxl__dClp_","mb-xxl":"productDetailPrice_mb-xxl__FzeUD","mt-xxl":"productDetailPrice_mt-xxl__Y314G","px-xxl":"productDetailPrice_px-xxl__kBAf_","mx-xxl":"productDetailPrice_mx-xxl__thPRA","my-xxl":"productDetailPrice_my-xxl__vwuVk","py-xxl":"productDetailPrice_py-xxl__9Nqao","font-size-xxl":"productDetailPrice_font-size-xxl__8U3ai","overflow-hidden":"productDetailPrice_overflow-hidden__kiw_Y","topMargin":"productDetailPrice_topMargin__pkfbY","textWhite":"productDetailPrice_textWhite__0e02u","prefix":"productDetailPrice_prefix__2z7fH","specialPrice":"productDetailPrice_specialPrice__zJ7xn","whiteLabel":"productDetailPrice_whiteLabel__7OzrY","price":"productDetailPrice_price__LPQIF","price__now":"productDetailPrice_price__now__ZXX6_","price__main":"productDetailPrice_price__main__X56ND","price__was":"productDetailPrice_price__was__oU1Cu","price__save":"productDetailPrice_price__save__Y4wpj"};

/***/ }),

/***/ 96421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promotion":"productDetailsPromotions_promotion__b7Ma1","promotion__tag":"productDetailsPromotions_promotion__tag__iAkCd","promotion__description":"productDetailsPromotions_promotion__description__zdAPw","description_font":"productDetailsPromotions_description_font__7Btrn","promotion__description__link":"productDetailsPromotions_promotion__description__link__h5azH","product-details-bottom-hr":"productDetailsPromotions_product-details-bottom-hr__1d07R"};

/***/ }),

/***/ 15291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product-viewer":"productViewer_product-viewer__Rs_er","product-viewer__device":"productViewer_product-viewer__device__pEbQE","carousel__prev":"productViewer_carousel__prev__XI2cI","carousel__next":"productViewer_carousel__next__oOdcT","carousel":"productViewer_carousel___DTEH","thumbnail":"productViewer_thumbnail___dP3i","thumbnail--active":"productViewer_thumbnail--active__LJRdB","thumbMaxWidth":"productViewer_thumbMaxWidth__dswBU","thumbnailCarousel":"productViewer_thumbnailCarousel__cQsHp"};

/***/ }),

/***/ 76401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemSwitcherWrapper":"productDetailForm_itemSwitcherWrapper__eWtJa","once-off":"productDetailForm_once-off__qSs6p","addInfoWrapper":"productDetailForm_addInfoWrapper__GRK1s","whiteLabel":"productDetailForm_whiteLabel__OZcRu","itemSwitcher":"productDetailForm_itemSwitcher__55HgD","active":"productDetailForm_active__LYFwL","disabled":"productDetailForm_disabled__SPwUv","addToCartBtnStatic":"productDetailForm_addToCartBtnStatic__yAWGs","addToCartBtn":"productDetailForm_addToCartBtn__fO4hP","addedToCartBtn":"productDetailForm_addedToCartBtn__06ynt","preOrderBtn":"productDetailForm_preOrderBtn__Sx_In","viewCartButton":"productDetailForm_viewCartButton__tbeMf","addedToCartVisible":"productDetailForm_addedToCartVisible__osR_1","qtyInfoShow":"productDetailForm_qtyInfoShow__dAwLl","viewcart-btn":"productDetailForm_viewcart-btn__2Ts5R","wishListBtn":"productDetailForm_wishListBtn__CpPkt","snackBarSpacing":"productDetailForm_snackBarSpacing__Twrwl","msg-label":"productDetailForm_msg-label__U2fg8","description-style":"productDetailForm_description-style__dzd_o","modal-body":"productDetailForm_modal-body__ziv_K","btn-spacing":"productDetailForm_btn-spacing__cN4fZ","modal":"productDetailForm_modal__gR7eL","img":"productDetailForm_img__EcrMo","btn":"productDetailForm_btn__wa_65","label":"productDetailForm_label__u4h3V","btn-link":"productDetailForm_btn-link__fryNZ","upgrade-text":"productDetailForm_upgrade-text__jTfSx","dropdownAlignment":"productDetailForm_dropdownAlignment__RekHB","labelPadding":"productDetailForm_labelPadding__J2EvR","deal-div":"productDetailForm_deal-div__zrZ_O","deal-price":"productDetailForm_deal-price__tNkCi","deal-price-sufix":"productDetailForm_deal-price-sufix__nkbvU","optionZindex":"productDetailForm_optionZindex__vW9nF","specialOffersWrapper":"productDetailForm_specialOffersWrapper__dstli","specialOffersWrapperTitle":"productDetailForm_specialOffersWrapperTitle__B_DtD","info-text":"productDetailForm_info-text__QzLFn","info-link":"productDetailForm_info-link__1kWa0","select__option--active":"productDetailForm_select__option--active__Ni_4Z","select__option-disable":"productDetailForm_select__option-disable__RC5bT","sticky_on_mobile":"productDetailForm_sticky_on_mobile__GPzCY","stickyPrice":"productDetailForm_stickyPrice__nmJEq","newButton":"productDetailForm_newButton__kdpfr","sticky_on_mobile_wrapper":"productDetailForm_sticky_on_mobile_wrapper___pKx_","productStickyInfo":"productDetailForm_productStickyInfo___skjg","productStickyImage":"productDetailForm_productStickyImage__1k_yl","productStickyDetails":"productDetailForm_productStickyDetails__DHvJD","productStickyDetailsName":"productDetailForm_productStickyDetailsName__55uDn","productStickyDetailsOptions":"productDetailForm_productStickyDetailsOptions__t2Tuq","productStickyEit":"productDetailForm_productStickyEit__2w3DW","dealPrice":"productDetailForm_dealPrice__OccFg","monthlySelectorWrapper":"productDetailForm_monthlySelectorWrapper__dQlEC","monthlySelector":"productDetailForm_monthlySelector__r39kk","selectedMonthly":"productDetailForm_selectedMonthly__ZOR5o","priceLabel":"productDetailForm_priceLabel__XT3Qn","priceBold":"productDetailForm_priceBold__3fMy4","qtyWrapper":"productDetailForm_qtyWrapper__FwbO4","qtyButton":"productDetailForm_qtyButton__QVS4e","qtyButtonPlus":"productDetailForm_qtyButtonPlus__tDHx0","qtyButtonDisabled":"productDetailForm_qtyButtonDisabled__N8Rt7","qtyWrapperOnWhite":"productDetailForm_qtyWrapperOnWhite__lu7Y5","upgradeButton":"productDetailForm_upgradeButton__06ipJ","formActionsWrapper":"productDetailForm_formActionsWrapper__Sam_x","formActionsWrapperPriceHidden":"productDetailForm_formActionsWrapperPriceHidden__sCTlx","formActions":"productDetailForm_formActions__VmnIC","formActionsContracts":"productDetailForm_formActionsContracts__dMitf","formActionsPriceHidden":"productDetailForm_formActionsPriceHidden__fewwU","addedToCartActionVisible":"productDetailForm_addedToCartActionVisible__iVT5A","qtyInfo":"productDetailForm_qtyInfo__ODH2z","carouselWrapper":"productDetailForm_carouselWrapper__lfaU_","carouselPlan":"productDetailForm_carouselPlan__L5Q7f","planInner":"productDetailForm_planInner__UAtvz","carouselPlanSpecial":"productDetailForm_carouselPlanSpecial__jnX0S","getThisDeal":"productDetailForm_getThisDeal__r4tT4","packageWrapperPromotionElement":"productDetailForm_packageWrapperPromotionElement__liGRo","redHotDeal":"productDetailForm_redHotDeal__em6Qi","lowestDeal":"productDetailForm_lowestDeal__gqEoM","betValue":"productDetailForm_betValue__YRVwt","desktopSwatchWrapper":"productDetailForm_desktopSwatchWrapper__VgKBY","planOfferItems":"productDetailForm_planOfferItems__ksODH","airtime":"productDetailForm_airtime__7_CP_","data":"productDetailForm_data__rkO5b","minutes":"productDetailForm_minutes__ZjLGz","priceWrapper":"productDetailForm_priceWrapper__aS1nu","youSave":"productDetailForm_youSave__zwL39","desktopSwatchInfo":"productDetailForm_desktopSwatchInfo__oEsVL"};

/***/ }),

/***/ 19011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"productDetailIndicators_p-xxs__fdgNz","pl-xxs":"productDetailIndicators_pl-xxs__COVxJ","pr-xxs":"productDetailIndicators_pr-xxs___d76C","pb-xxs":"productDetailIndicators_pb-xxs__T6snn","pt-xxs":"productDetailIndicators_pt-xxs__xIhrY","m-xxs":"productDetailIndicators_m-xxs__i2CW2","ml-xxs":"productDetailIndicators_ml-xxs__XZSo3","mr-xxs":"productDetailIndicators_mr-xxs__Sjhbu","mb-xxs":"productDetailIndicators_mb-xxs__U93E9","mt-xxs":"productDetailIndicators_mt-xxs__rTson","px-xxs":"productDetailIndicators_px-xxs__soJ_t","mx-xxs":"productDetailIndicators_mx-xxs__WYx0U","my-xxs":"productDetailIndicators_my-xxs__hZ_H3","py-xxs":"productDetailIndicators_py-xxs__Vt8p8","font-size-xxs":"productDetailIndicators_font-size-xxs__Rw2hz","p-xs":"productDetailIndicators_p-xs__z4VJx","pl-xs":"productDetailIndicators_pl-xs__6L32i","pr-xs":"productDetailIndicators_pr-xs__N11fs","pb-xs":"productDetailIndicators_pb-xs__NXGY3","pt-xs":"productDetailIndicators_pt-xs__4wnA3","m-xs":"productDetailIndicators_m-xs__QXACd","ml-xs":"productDetailIndicators_ml-xs__p0uf_","mr-xs":"productDetailIndicators_mr-xs__j5HWT","mb-xs":"productDetailIndicators_mb-xs__j1ocv","mt-xs":"productDetailIndicators_mt-xs___4fi1","px-xs":"productDetailIndicators_px-xs__9xv0X","mx-xs":"productDetailIndicators_mx-xs__n_vYy","my-xs":"productDetailIndicators_my-xs__XTLwV","py-xs":"productDetailIndicators_py-xs___BuaN","font-size-xs":"productDetailIndicators_font-size-xs__T9WFc","p-ss":"productDetailIndicators_p-ss__chCSp","pl-ss":"productDetailIndicators_pl-ss__hVPzD","pr-ss":"productDetailIndicators_pr-ss__fbMbN","pb-ss":"productDetailIndicators_pb-ss__bdmeK","pt-ss":"productDetailIndicators_pt-ss__Y_Yxt","m-ss":"productDetailIndicators_m-ss__vyBMm","ml-ss":"productDetailIndicators_ml-ss__I_hWQ","mr-ss":"productDetailIndicators_mr-ss__TWUmR","mb-ss":"productDetailIndicators_mb-ss__OyOYK","mt-ss":"productDetailIndicators_mt-ss__UVGKP","px-ss":"productDetailIndicators_px-ss__jjL_8","mx-ss":"productDetailIndicators_mx-ss__UO5cP","my-ss":"productDetailIndicators_my-ss__uKCrU","py-ss":"productDetailIndicators_py-ss__BmL_g","font-size-ss":"productDetailIndicators_font-size-ss__vKo_y","p-ms":"productDetailIndicators_p-ms__vX8B_","pl-ms":"productDetailIndicators_pl-ms__iWQz1","pr-ms":"productDetailIndicators_pr-ms__Vh6PB","pb-ms":"productDetailIndicators_pb-ms__K6G9_","pt-ms":"productDetailIndicators_pt-ms__0BlwM","m-ms":"productDetailIndicators_m-ms__f1Hoz","ml-ms":"productDetailIndicators_ml-ms__tBA6Q","mr-ms":"productDetailIndicators_mr-ms__WJtN0","mb-ms":"productDetailIndicators_mb-ms__ZzAjo","mt-ms":"productDetailIndicators_mt-ms__9uRwc","px-ms":"productDetailIndicators_px-ms__PG6IC","mx-ms":"productDetailIndicators_mx-ms__8WNzD","my-ms":"productDetailIndicators_my-ms__Tq8w_","py-ms":"productDetailIndicators_py-ms__EpknF","font-size-ms":"productDetailIndicators_font-size-ms__caoPk","p-s":"productDetailIndicators_p-s__eTh6_","pl-s":"productDetailIndicators_pl-s__iCISA","pr-s":"productDetailIndicators_pr-s__KmkoG","pb-s":"productDetailIndicators_pb-s__nviJU","pt-s":"productDetailIndicators_pt-s__rEwYK","m-s":"productDetailIndicators_m-s__3MXif","ml-s":"productDetailIndicators_ml-s__5FQfB","mr-s":"productDetailIndicators_mr-s__82Xwb","mb-s":"productDetailIndicators_mb-s__f723U","mt-s":"productDetailIndicators_mt-s__VcWEf","px-s":"productDetailIndicators_px-s__1BMHb","mx-s":"productDetailIndicators_mx-s__LOk3i","my-s":"productDetailIndicators_my-s__RhnIc","py-s":"productDetailIndicators_py-s__W2ygX","font-size-s":"productDetailIndicators_font-size-s__hjjHW","p-m":"productDetailIndicators_p-m__mbwnK","pl-m":"productDetailIndicators_pl-m__GE2Za","pr-m":"productDetailIndicators_pr-m__d_Wln","pb-m":"productDetailIndicators_pb-m__sd_hp","pt-m":"productDetailIndicators_pt-m__aZg5h","m-m":"productDetailIndicators_m-m__8IFiJ","ml-m":"productDetailIndicators_ml-m__GevJl","mr-m":"productDetailIndicators_mr-m__dZMGP","mb-m":"productDetailIndicators_mb-m__vV2ct","mt-m":"productDetailIndicators_mt-m__fYwao","px-m":"productDetailIndicators_px-m__G0OES","mx-m":"productDetailIndicators_mx-m__H_ZGn","my-m":"productDetailIndicators_my-m__yRRr5","py-m":"productDetailIndicators_py-m__FQPSQ","font-size-m":"productDetailIndicators_font-size-m__3RKr3","p-l":"productDetailIndicators_p-l__nFsQ3","pl-l":"productDetailIndicators_pl-l__2JVD7","pr-l":"productDetailIndicators_pr-l__qx2_K","pb-l":"productDetailIndicators_pb-l__OmV9A","pt-l":"productDetailIndicators_pt-l__SCGbw","m-l":"productDetailIndicators_m-l__rh80Z","ml-l":"productDetailIndicators_ml-l__kKQeC","mr-l":"productDetailIndicators_mr-l__sPr_4","mb-l":"productDetailIndicators_mb-l__h7_Jw","mt-l":"productDetailIndicators_mt-l__HIt8o","px-l":"productDetailIndicators_px-l__KjZKq","mx-l":"productDetailIndicators_mx-l__D1I6l","my-l":"productDetailIndicators_my-l__Vdj4P","py-l":"productDetailIndicators_py-l__U_W2D","font-size-l":"productDetailIndicators_font-size-l__7K_2u","p-xl":"productDetailIndicators_p-xl__582aw","pl-xl":"productDetailIndicators_pl-xl__Z9ScW","pr-xl":"productDetailIndicators_pr-xl__sBdSc","pb-xl":"productDetailIndicators_pb-xl__EO1Af","pt-xl":"productDetailIndicators_pt-xl__iB9Jr","m-xl":"productDetailIndicators_m-xl__l772P","ml-xl":"productDetailIndicators_ml-xl__p6Fha","mr-xl":"productDetailIndicators_mr-xl__mLVdY","mb-xl":"productDetailIndicators_mb-xl__k84rf","mt-xl":"productDetailIndicators_mt-xl__CCiel","px-xl":"productDetailIndicators_px-xl__TfN4K","mx-xl":"productDetailIndicators_mx-xl__F9KgE","my-xl":"productDetailIndicators_my-xl___s1U4","py-xl":"productDetailIndicators_py-xl__sBho_","font-size-xl":"productDetailIndicators_font-size-xl__9oj1d","p-xxl":"productDetailIndicators_p-xxl__VQLbz","pl-xxl":"productDetailIndicators_pl-xxl__fN8Uk","pr-xxl":"productDetailIndicators_pr-xxl__SUoqr","pb-xxl":"productDetailIndicators_pb-xxl__Ok9X_","pt-xxl":"productDetailIndicators_pt-xxl__S9AiJ","m-xxl":"productDetailIndicators_m-xxl__4dOiW","ml-xxl":"productDetailIndicators_ml-xxl__SjrZU","mr-xxl":"productDetailIndicators_mr-xxl__EnHXP","mb-xxl":"productDetailIndicators_mb-xxl__eEtzU","mt-xxl":"productDetailIndicators_mt-xxl__ZvHMx","px-xxl":"productDetailIndicators_px-xxl__kxPxd","mx-xxl":"productDetailIndicators_mx-xxl__I09se","my-xxl":"productDetailIndicators_my-xxl__kw5fy","py-xxl":"productDetailIndicators_py-xxl__wP4qp","font-size-xxl":"productDetailIndicators_font-size-xxl__vAXjq","overflow-hidden":"productDetailIndicators_overflow-hidden__EUfgb","topMargin":"productDetailIndicators_topMargin__YPlyW","shop-with-stock":"productDetailIndicators_shop-with-stock__6kfxH","availabilityWrapper":"productDetailIndicators_availabilityWrapper__nHTLj","label1":"productDetailIndicators_label1__1yoO4","stores-box":"productDetailIndicators_stores-box__ujAYn","tracker":"productDetailIndicators_tracker__fApsj","btn-in-store":"productDetailIndicators_btn-in-store__quSs8","in-stock-info":"productDetailIndicators_in-stock-info__t6isB","notify-me-button":"productDetailIndicators_notify-me-button__3z48j","description":"productDetailIndicators_description__PGTVX","no-stock-store":"productDetailIndicators_no-stock-store__UI3bZ"};

/***/ }),

/***/ 34149:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"productDetailsBody_p-xxs__riOr6","pl-xxs":"productDetailsBody_pl-xxs__ki4iS","pr-xxs":"productDetailsBody_pr-xxs__a4S3O","pb-xxs":"productDetailsBody_pb-xxs__SbsCS","pt-xxs":"productDetailsBody_pt-xxs__nSOR_","m-xxs":"productDetailsBody_m-xxs__CSXvY","ml-xxs":"productDetailsBody_ml-xxs___GZoY","mr-xxs":"productDetailsBody_mr-xxs__OXe_Q","mb-xxs":"productDetailsBody_mb-xxs__tpWFh","mt-xxs":"productDetailsBody_mt-xxs__tErIf","px-xxs":"productDetailsBody_px-xxs__BZxBM","mx-xxs":"productDetailsBody_mx-xxs__OYl1z","my-xxs":"productDetailsBody_my-xxs__yAiae","py-xxs":"productDetailsBody_py-xxs__jSAZ1","font-size-xxs":"productDetailsBody_font-size-xxs__K6HnP","p-xs":"productDetailsBody_p-xs__jwfpc","pl-xs":"productDetailsBody_pl-xs__AHfQV","pr-xs":"productDetailsBody_pr-xs__KiuGJ","pb-xs":"productDetailsBody_pb-xs__WFd2O","pt-xs":"productDetailsBody_pt-xs__oG9Lv","m-xs":"productDetailsBody_m-xs__Ct_kw","ml-xs":"productDetailsBody_ml-xs__elU2l","mr-xs":"productDetailsBody_mr-xs__vQtX9","mb-xs":"productDetailsBody_mb-xs__8he1D","mt-xs":"productDetailsBody_mt-xs__Qqimi","px-xs":"productDetailsBody_px-xs__XCV3Q","mx-xs":"productDetailsBody_mx-xs__CQkEz","my-xs":"productDetailsBody_my-xs__gUjvy","py-xs":"productDetailsBody_py-xs__gnWef","font-size-xs":"productDetailsBody_font-size-xs__ngU9L","p-ss":"productDetailsBody_p-ss__IEk_8","pl-ss":"productDetailsBody_pl-ss__Erf6V","pr-ss":"productDetailsBody_pr-ss__eixil","pb-ss":"productDetailsBody_pb-ss__Kd0Nq","pt-ss":"productDetailsBody_pt-ss__U21eY","m-ss":"productDetailsBody_m-ss__5afJ5","ml-ss":"productDetailsBody_ml-ss__2MMkH","mr-ss":"productDetailsBody_mr-ss__XUUNW","mb-ss":"productDetailsBody_mb-ss__c2KIF","mt-ss":"productDetailsBody_mt-ss__A_HmT","px-ss":"productDetailsBody_px-ss__n5Cqs","mx-ss":"productDetailsBody_mx-ss__seOnd","my-ss":"productDetailsBody_my-ss__5N4SY","py-ss":"productDetailsBody_py-ss__cUKBI","font-size-ss":"productDetailsBody_font-size-ss___3A7l","p-ms":"productDetailsBody_p-ms__EIlwg","pl-ms":"productDetailsBody_pl-ms__pmQTW","pr-ms":"productDetailsBody_pr-ms__r_fIN","pb-ms":"productDetailsBody_pb-ms__n3VQj","pt-ms":"productDetailsBody_pt-ms__DKxYe","m-ms":"productDetailsBody_m-ms__uvF6r","ml-ms":"productDetailsBody_ml-ms__OOI6t","mr-ms":"productDetailsBody_mr-ms__Qvsra","mb-ms":"productDetailsBody_mb-ms__i29bs","mt-ms":"productDetailsBody_mt-ms__SrQTg","px-ms":"productDetailsBody_px-ms__5KyY4","mx-ms":"productDetailsBody_mx-ms__pTk4E","my-ms":"productDetailsBody_my-ms__NWNN0","py-ms":"productDetailsBody_py-ms__gJG8D","font-size-ms":"productDetailsBody_font-size-ms__OjGc6","p-s":"productDetailsBody_p-s__b36_s","pl-s":"productDetailsBody_pl-s__Sy5sy","pr-s":"productDetailsBody_pr-s__yDLK1","pb-s":"productDetailsBody_pb-s__N561J","pt-s":"productDetailsBody_pt-s__pAoye","m-s":"productDetailsBody_m-s__kd5cs","ml-s":"productDetailsBody_ml-s__Rz__7","mr-s":"productDetailsBody_mr-s__sSIEc","mb-s":"productDetailsBody_mb-s__BrwIZ","mt-s":"productDetailsBody_mt-s__i72fR","px-s":"productDetailsBody_px-s__X7cQZ","mx-s":"productDetailsBody_mx-s__I1ZiN","my-s":"productDetailsBody_my-s__T0qac","py-s":"productDetailsBody_py-s__5sBb9","font-size-s":"productDetailsBody_font-size-s__KIgFa","p-m":"productDetailsBody_p-m__e7_RH","pl-m":"productDetailsBody_pl-m__FHIA6","pr-m":"productDetailsBody_pr-m__2jRx8","pb-m":"productDetailsBody_pb-m__isrgw","pt-m":"productDetailsBody_pt-m__nlPo3","m-m":"productDetailsBody_m-m__rwOQn","ml-m":"productDetailsBody_ml-m__WouGt","mr-m":"productDetailsBody_mr-m___mV4w","mb-m":"productDetailsBody_mb-m__OzhgX","mt-m":"productDetailsBody_mt-m__VqyXR","px-m":"productDetailsBody_px-m__Kxnx3","mx-m":"productDetailsBody_mx-m__f_D4K","my-m":"productDetailsBody_my-m__kK73M","py-m":"productDetailsBody_py-m__KFqMz","font-size-m":"productDetailsBody_font-size-m__WX00P","p-l":"productDetailsBody_p-l__cU_Ta","pl-l":"productDetailsBody_pl-l___rHey","pr-l":"productDetailsBody_pr-l__BFz1p","pb-l":"productDetailsBody_pb-l__BkLYt","pt-l":"productDetailsBody_pt-l__KnBOH","m-l":"productDetailsBody_m-l__v3Z3A","ml-l":"productDetailsBody_ml-l__Tq9Py","mr-l":"productDetailsBody_mr-l__g4dgv","mb-l":"productDetailsBody_mb-l__vK9ak","mt-l":"productDetailsBody_mt-l__JPmWc","px-l":"productDetailsBody_px-l__IVKXY","mx-l":"productDetailsBody_mx-l__VDT_k","my-l":"productDetailsBody_my-l__3_btV","py-l":"productDetailsBody_py-l__pwey_","font-size-l":"productDetailsBody_font-size-l__LOgFU","p-xl":"productDetailsBody_p-xl__5tpQT","pl-xl":"productDetailsBody_pl-xl__WNU_l","pr-xl":"productDetailsBody_pr-xl__0ObAZ","pb-xl":"productDetailsBody_pb-xl__qCvBW","pt-xl":"productDetailsBody_pt-xl__HvLsP","m-xl":"productDetailsBody_m-xl__TWUSC","ml-xl":"productDetailsBody_ml-xl__tHka_","mr-xl":"productDetailsBody_mr-xl__CAYCt","mb-xl":"productDetailsBody_mb-xl__1V5j9","mt-xl":"productDetailsBody_mt-xl__tOKyP","px-xl":"productDetailsBody_px-xl__HMmFZ","mx-xl":"productDetailsBody_mx-xl__MBcec","my-xl":"productDetailsBody_my-xl__huv_I","py-xl":"productDetailsBody_py-xl__BHoLY","font-size-xl":"productDetailsBody_font-size-xl__NA8sn","p-xxl":"productDetailsBody_p-xxl__L_BlI","pl-xxl":"productDetailsBody_pl-xxl__ACFfm","pr-xxl":"productDetailsBody_pr-xxl__1EYOP","pb-xxl":"productDetailsBody_pb-xxl__17ZRj","pt-xxl":"productDetailsBody_pt-xxl__rW7ZM","m-xxl":"productDetailsBody_m-xxl__TNR7C","ml-xxl":"productDetailsBody_ml-xxl__FLGpt","mr-xxl":"productDetailsBody_mr-xxl__1BZjw","mb-xxl":"productDetailsBody_mb-xxl__3rGuc","mt-xxl":"productDetailsBody_mt-xxl__Isly9","px-xxl":"productDetailsBody_px-xxl__T4Kl0","mx-xxl":"productDetailsBody_mx-xxl__FuP6M","my-xxl":"productDetailsBody_my-xxl__61rb9","py-xxl":"productDetailsBody_py-xxl__YW0U2","font-size-xxl":"productDetailsBody_font-size-xxl__a9SQz","overflow-hidden":"productDetailsBody_overflow-hidden__pcDOk","topMargin":"productDetailsBody_topMargin__9wJ9w","wrapper":"productDetailsBody_wrapper__CVPbL","wrapper-device":"productDetailsBody_wrapper-device__yLm4p","product-details":"productDetailsBody_product-details__Q3Tv8","shareWrapper":"productDetailsBody_shareWrapper__EC3_R","shareButton":"productDetailsBody_shareButton__ygOHM","brandLogo":"productDetailsBody_brandLogo__awn44","videoModalContent":"productDetailsBody_videoModalContent__AXZs2","titleContainer":"productDetailsBody_titleContainer__OnxeN","productPrice":"productDetailsBody_productPrice__BnNHB","productActionShortcuts":"productDetailsBody_productActionShortcuts__Pw_s2","viewSpecsShortcut":"productDetailsBody_viewSpecsShortcut__Rv8xT","videoShortcut":"productDetailsBody_videoShortcut__1ak1H","deliveryOptionsWrapper":"productDetailsBody_deliveryOptionsWrapper__Oj0fb","deliveryInfoTitle":"productDetailsBody_deliveryInfoTitle__M4nhV","deliveryOptionSub":"productDetailsBody_deliveryOptionSub__g9BML","deliveryOptionsWapper":"productDetailsBody_deliveryOptionsWapper__OtFsl","deliveryOptionTitle":"productDetailsBody_deliveryOptionTitle__eViaM","deliveryOptionDescription":"productDetailsBody_deliveryOptionDescription__EFlCp","videoModalOverlay":"productDetailsBody_videoModalOverlay__az0uf","videoModal":"productDetailsBody_videoModal__t6c33","videoModalClose":"productDetailsBody_videoModalClose__gCEaq","specialFeaturesWrapper":"productDetailsBody_specialFeaturesWrapper__r13mE"};

/***/ }),

/***/ 9557:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8764,7333,6338,9494,284,9774,2888,179], function() { return __webpack_exec__(85160); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);